import "es6-promise/auto";
import Vue from "vue";
import Axios from "axios";
import Common from "./components/common.js";
import Pager from './components/common/pagingUser.vue';
import DatePicker from 'vue2-datepicker';
import Editor from "./components/common/editor.vue";
import swal from 'sweetalert';
import Alram from './components/common/alram.vue';
import VueFileAgent from 'vue-file-agent';
// import Validator from './components/common/validation.js';
import validation from 'validator';
import Share from './components/common/share.js';
import 'vue2-datepicker/index.css';
import 'vue-file-agent/dist/vue-file-agent.css';
import mobile from 'is-mobile';

Vue.use(VueFileAgent);
Vue.use(mobile);

import Profile from "./components/common/dragImgProfileOne.vue";
import DropImg from "./components/common/dragImgFile.vue";
import DropImgAlt from "./components/common/dragImgAlt.vue";
import DropDoc from "./components/common/dragDocFile.vue";
import DropVideo from "./components/common/dragVideoFile.vue";

Vue.component("pager", Pager);
Vue.component('common', Common);
Vue.component("datepicker", DatePicker);
Vue.component("star-rating", VueStarRating.default);
Vue.component("editor", Editor);
// Vue.component('dropimg', DropImg);
Vue.component('dropimg', DropImgAlt);
Vue.component('dropdoc', DropDoc);
Vue.component('dropvideo', DropVideo);
Vue.component("profile", Profile);
Vue.component('alarm', Alram);

Vue.prototype.$pager = Pager;

new Vue({
	el: "#afterschool",
	data: function() {
	return {
		cnt:0,
		loading: true,
		isMobile: false,
		fileKey: '',
		isShare:false,
		listBanner : [],
		isMobileStyle:{
			'width': '100%',
			'height' : 'auto'
			//'height' : '250px'
			// 'height' : '20vh' ,
			// 'object-fit' : 'cover'
		},
		isMobileStyles:{
			// 'height':'150px'
			'height' : 'auto'
		},
		selectLocalBoxInApply			: { code: '', value: '' },
		selectSchoolBoxInApply			: { code: '', value: '' },
		selectGradeBoxInApply			: { code: '', value: '' },
		selectTypeBoxInMain				: { code: '', value: '' },
		selectLocalBoxInMain			: { code: '', value: '' },
		selectLocalBoxInSearch			: { code: '', value: '' },
		selectDateTypeBoxInSearch		: { code: '', value: '' },
		selectDomainBoxInSearch			: { code: '', value: '' },
		selectAffiliationBoxInSearch	: { code: '', value: '' },
		selectGradeBoxInSearch			: { code: '', value: '' },
		selectLocalBoxInConnect			: { code: '', value: '', isClick: false },
		selectYearBoxInMeeting			: { year: '' },
		selectHalfYearlyBoxInMeeting	: { halfYearly: '' },
		selectEmailBoxInTeacherApply	: { code: '', value: '' },
		selectDomainBoxInTeacherApply	: { code: '', value: '' },
		selectLocalBoxInTeacherApply	: { code: '', value: '' },
		selectAffilBoxInTeacherSearch	: { code: '', value: '' },
		selectLocalBoxInSpaceApply		: { code: '', value: '' },
		selectEmailBoxInSpaceApply		: { code: '', value: '' },
		selectMajorBoxInSpaceApply		: { code: '', value: '' },
		selectMediumBoxInSpaceApply		: { code: '', value: '' },
		selectBrdCntList				: { code: '', value: '' },
		selectFaqBoxInWrite 			: { code: '', value: '' },
		selectSggBoxInConnectQna		: { code: '', value: '' },
		phoneNumberByTeacherApply		: '',
		phoneNumberBySpaceApply			: '',
		admittedCntNumberBySpaceApply	: '',
		surfaceAreaFloatBySpaceApply	: '',
		mainName: '',
		viewModel: {
			pager: {
				model		: {},
				pageNo		: 1,
				pageNum		: 1,
				totalSize	: 0,
				rowSize		: 0,
				blockSize	: 0,
				endSize		: 0,
				list		: [],
				href		: "#a",
				etc		: '',
				callBack: function(n) {
					let _etc = this.model.viewModel.pager.etc;
					if(_etc == 'fnGetAfterSchoolPrgmList'){
						this.model.fnGetAfterSchoolPrgmList(n);
					} else if(_etc == 'fnGetFaqList'){
						this.model.fnGetFaqList(n);
					} else if(_etc == 'fnGetNoticeList'){
						this.model.fnGetNoticeList(n);
					} else if(_etc == 'fnGetGalleryList'){
						this.model.fnGetGalleryList(n);
					} else if(_etc == 'fnGetNoticeReply'){
						this.model.fnGetNoticeReply(n);
					} else if(_etc == 'fnGetTeacherBrdList'){
						this.model.fnGetTeacherBrdList(n);
					} else if(_etc == 'fnGetTeacherBrdDetailReply'){
						this.model.fnGetTeacherBrdDetailReply(n);
					} else if(_etc == 'fnGetAfterSchoolTchrList'){
						this.model.fnGetAfterSchoolTchrList(n);
					} else if(_etc == 'fnGetTeacherDetail'){
						this.model.fnGetTeacherDetail(n);
					} else if(_etc == 'fnGetAfterSchoolSpcList'){
						this.model.fnGetAfterSchoolSpcList(n);
					} else if(_etc == 'fnGetAfterSchoolSpaceDetail'){
						this.model.fnGetAfterSchoolSpaceDetail(n);
					} else if(_etc == 'fnGetMyNaviNoticeList'){
						this.model.fnGetMyNaviNoticeList(n);
					} else if(_etc == 'fnGetMyNaviFaqList'){
						this.model.fnGetMyNaviFaqList(n);
					} else if(_etc == 'fnGetFaqList'){
						this.model.fnGetFaqList(n);
					} else if(_etc == 'fnGetProgramPostRequestList'){
						this.model.fnGetProgramPostRequestList(n);
					}

				}
			}
		},
		fileImgList			: [],
		filePlanList		: [],
		fileApplyList		: [], // 마을강사 신청양식
		fileEtcList			: [],
		fileVdList			: [],
		mapViewModel: {
			detailMapAddr	: [],
			listMapAddr		: [],
			map				: null,
			mapInit			: 0
		},
		searchModel: {
			startDate			: '',
			endDate				: '',
			keyword				: '',
			faqCd				: '',
			faqName				: '',
			targetName			: '',
			targetCd			: '',
			searchTypeCd		: "searchType1",
			searchTypeName		: "마을방과후 프로그램",
			sggCd				: null,
			sggName				: '',
			schoolCd			: '',
			schoolName			: '',
			gradeCd				: '',
			gradeName			: '',
			domainCd			: '',
			domainName			: '',
			affiliationCd		: '',
			affiliationName		: '',
			dateTypeCd			: "dateType1",
			dateTypeName		: "접수기간",
			isMentoring			: false,
			sggCdList			: [],
			schoolCdList		: [],
			targetCdList		: [],
			searchTypeList		: [],
			dateTypeList		: [],
			faqCdList			: [],
			emailCdList			: [],
			domainCdList		: [],
			affiliationCdList	: [],
			facilityMajorCdList : [],
			facilityMediumCdList : [],
		},
		menuViewModel: {
			isFrstTab: true,
			isScndTab: false,
			isThrdTab: false,
			isFrthTab: false,
			tab: 0
		},
		mainModel: {
			fndPrgrBySggList	: [],
			fndTchrBySggList	: [],
			fndSpcBySggList		: [],
			newPrgrList		: [],
			newTchrList		: [],
			newSpcList		: []
		},
		orderModel: {
			isLatest	: true,
			isPopularity	: false,
			orderValue	: '1'
		},
		programModel: {
			programList	: [],
			programListCnt	: 1,
			reviewList	: [],
			qnaList		: [],
			roundList	: [],
			program		: {
				price: 0,
				isPhoto : false,
				isPrivacy: false,
			},
			user		: {},
			review		: {
				title			: '',
				contentFirst	: '',
				vote			: 0,
				uidKey			: '',
				isLike			: false
			},
			qna: {
				title	: '',
				content	: '',
				password: '',
				uidKey	: ''
			},
			uidKey		: '',
			qnaPw		: '',
			participateCnt	: 0,


		},
		programViewModel: {
			isFrstTab: 				true,
			isScndTab: 				false,
			isThrdTab:				false,
			isFrthTab: 				false,
			isSubFrstSct:			true,
			isSubScndSct: 			false,
			isSubThrdSct: 			false,
			isSubFrthSct: 			false,
			isApplyBtn: 			false
		},
		applyModel: {
			applyCnt	: 1,
			applyUserList	: [],
			applyUser	: {},
			applyPrice	: 0,
			isInfoInputCheck: false
		},
		applyViewModel: {},
		teacherViewModel:{
			tab:					'',
			isSubFrstSct:			false,
			isSubScndSct:			false,
			isSubThrdSct:			false,
			isSubFrthSct:			false,
			isReplyWrite:			false,
			isReReplyWrite:			false,
			isReplyUpdate:			false,
			isReReplyUpdate:		false
		},
		selectProFiles:{
			detail : null,
			param : 'PROFILE',
			text : '변경할 이미지를 선택해주세요'
		},
		teacherModel:{
			name : 					'',		//강사명
			gender:					'',		//강사성별
			phone:					'',		//강사연락처
			emailId:				'',		//이메일 ID
			emailAddr:				'',		//이메일 사이트
			email:					'',		//이메일 전체 주소
			phoneOpenYn:			false,
			emailOpenYn:			false,
			sggCd:					'',
			sggName:				'',
			sggCdList:				[],
			eduContent:				'',		//교육내용
			areas:					'',		//활동가능 지역구
			currentActive:			'',
			emailCd:				'',
			emailName:				'',
			emailAddrEtc:			'',
			applyCheck:				0,
			planDoc:				{},
			applyDoc:				{},
			privacyDoc:				{},
			profileImg:				{},
			brdList:				[],
			brdListCnt:				0,
			brdDetail:				{
				title:				'',
				content:			'',
				doc:				{},
				uidKey:				''
			},
			keyword:				'',
			replyDepthZeroList:		[],
			replyDepthOneList:		[],
			replyListCnt:			0,
			replyUidKey:			'',
			replyContent:			'',
			reReplyContent:			'',
			teacherList:			[],
			teacherListCnt:			1,
			teacherDto:				{},
			domainCd:				'',
			domainName:				'',
			domainEtc:				'',
			phoneEduOrgYn:			false,
			phoneGovOrgYn:			false,
			phoneParentsYn:			false,
			emailEduOrgYn:			false,
			emailGovOrgYn:			false,
			emailParentsYn:			false,
			specialType:			'YOU'
		},
		spaceModel:{
			facilityMjCd:			'',
			facilityMjName:			'',
			facilityMdCd:			'',
			facilityMdName:			'',
			facilityMdEtc:			'',
			spaceName:				'',
			spaceAddr:				'',
			spaceTel:				'',
			spaceEmail:				'',
			majorLevel:				'',
			mediumLevel:			'',
			admittedCnt:			0,
			surfaceArea:			'',
			purpose:				'',
			rentalFee:				0,
			mentoringYn:			'',
			managementAgency:		'',
			link:					'',
			sggName:				'',
			sggCd:					'',
			emailAddr:				'',
			emailCd:				'',
			emailAddrEtc:			'',
			emailOpenYn:			false,
			spaceList:				[],
			spaceListCnt:			1,
			spaceDto:				{},

			//유효성
			isSpaceName:			false,
			isSggCd:				false,
			isSpaceAddr:			false,
			isSpaceTel:				false,
			isSpaceEmail:	false,
			isemailAddr:	false,
			isFacilityMjCd:	false,
			isFacilityMdCd:	false,
			isAdmittedCnt:	false,
			isSurfaceArea:	false,
			isPurpose:	false,
			isMentoringYn:	false,
			isRentalFee:	false,
			isManagementAgency:	false,

			validateTxtSpaceName:		'마을공간명은 필수항목입니다.',
			validateTxtSggCd:			'지역선택은 필수항목입니다.',
			validateTxtSpaceAddr:		'주소는 필수항목입니다.',
			validateTxtSpaceTel:		'전화번호는 필수항목입니다.',
			validateTxtSpaceEmail:		'이메일은 필수항목입니다.',
			validateTxtEmailAddr:		'이메일은 필수항목입니다.',
			validateTxtFacilityMjCd: 	'공간분류는 필수항목입니다.',
			validateTxtFacilityMDCd:	'공간분류는 필수항목입니다.',
			validateTxtAdmittedCnt:		'수용인원은 필수항목입니다.',
			validateTxtSurfaceArea:		'면적은 필수항목입니다.',
			validateTxtPurpose:			'용도는 필수항목입니다.',
			validateTxtMentoringYn:		'멘토링 가능여부는 필수항목입니다.',
			validateTxtRentalFee:		'대관료는 필수항목입니다.',
			validateTxtManagementAgency:'운영기관은 필수항목입니다.',
		},
		valiObj:{
			isSubject:false
			,isTarget:false
		},
		spaceViewModel:{
			isSubFrstSct:			false,
			isSubScndSct:			false,
		},
		boardModel: {
			noticeList:                [],
			noticeListCnt:             1,
			faqList:                   [],
			faqListCnt:                1,
			faqCategory:               [],
			notice:                    {},
			faq:                       {},
			uidKey:                    '',
			faqCd:                     '',
			replyDepthZeroList:        [],
			replyDepthOneList:         [],
			replyListCnt:              0,
			replyContent:              '',
			reReplyContent:            '',
			replyUidKey:               '',
			isReportOn:                '',
			reportList:                [],
			reportEtcValue:            '',
			reportValues:              '',
			qnaList:					[],
			qnaListCnt:					1,
			qna:						{},
			qnaAnswer:					{}
		},
		boardViewModel: {
			isFrstSct:        true,
			isScndSct:        false,
			isThrdSct:		  false,
			isFrthSct:		  false,
			isReplyWrite:     false,
			isReplyUpdate:    false,
			isReReplyWrite:   false,
			isReReplyUpdate:  false
		},
		mynaviModel: {
			today:                new Date()
			, rowValue:             '10건씩 보기'
			, rowNum:               10
			, orderList:            []
			, contentList:			[]
			, contentListCnt:		0
			, keyword:				''
			, startDate:			''
			, endDate:				''
			, title:				''
			, content:				''
			, selectViewYn:         ''
			, selectSearch:         ''

		},
		mynaviViewModel: {
			isToday:                false
			, isWeek:               false
			, isOneMonth:           false
			, isTwoMonth:           false
			, isSixMonth:           false
			, isProfileUpdate:      false
			, isDetailSearch:		false
		},
		meetingViewModel: {
			isFrstSct: true,
			isScndSct: false,
			isThrdSct: false,
			isFrthSct: false
		},
		meetingModel: {
			galleryVO: {
				programTitle	: '',
				title			: '',
				contentFirst	: '',
				uidKey			: ''
			},
			galleryList		: [],
			galleryListCnt  : 1,
			yearList		: [],
			halfYearlyList	: [],
			year			: '',
			halfYearly		: '',
			thisYear		: '',
			thisMonth		: '',
			totalList	: []
			},
      afterTeacherRejectMsg: '', // (마을강사) 반려 사유
      afterTeacherIsShowRejectForm: false, // (마을강사) 반려 사유 작성 폼 show/hide
		};
	},
	beforeMount:function(){
		let vm = this;
		let pageName = $("#pageName").val();

		if (pageName == "afterMain") {
			vm.fnGetSeoulSvgMap();
		}
	},
	updated: function() {
		let vm = this;
		let pageName = $("#pageName").val();
		if (pageName == "afterMain") {
			$(".mainName").text('');
			$(".btn_back").hide();
		}

		if ( (pageName == "programMain" && vm.menuViewModel.tab == 3)
		  || (pageName == "teacherMain" && vm.menuViewModel.tab == 3)) {
			vm.fnGetSeoulSvgMap();
		}
	},
	filters: {
		currency: function(value) {
			let num = new Number(value);
			return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
		},
		filterSelectSearch: function(value){
            if(value == '' || value == null){
                return "전체";
            }else if(value == "title"){
                return "제목";
            }else if(value == "userNm"){
                return "신청기관";
            }
        },
		filterSelectViewYn: function(value){
            if(value == '' || value == null){
                return "선택";
            }else if(value == "Y"){
                return "게시";
            }else if(value == "N"){
                return "미게시";
            }
        }
	},
	mounted: function() {
		let pageName = $("#pageName").val();
		if(pageName == 'meetingMain' || pageName == 'connectMain'){
			Kakao.init("25727a9190252a67c490a909452aecd8");
		}

		this.fnOnPageLoad();

    // setTimeout(function() {console.log('finish Load');  }, 1000);
    // this.fnGetAfterProgramSessionStorage();
    // console.log("find Session finish")

    setTimeout( () => {
      this.fnGetAfterProgramSessionStorage();
    }, 2500);
	},
	created: function() {
		this.isMobile = mobile();
		setTimeout(() => {
			this.loading = false;
		}, 2000);


		let _data = this.$data.orderModel;
		let _keyList = Object.keys(_data);
		for (let values in _keyList) {
			let _values = _keyList[values];
			if (_values.indexOf("CodeList") > -1) {
				_data[_values] = Common.fnBrdOrderingCode();
			}
		}
		$(".const").css("fill", "#FF0000");
		// this.fnGetSeoulGuCode();

    if (!('$' in Vue.prototype) && '$' in window) {
      Vue.prototype.$ = window.$; // <template> 에서 $ 사용
    }
	},
	watch: {
		selectedProgram: function(newVal, oldVal) {
			let _color = "#FF0000";
			if (newVal == "1") {
				_color = "#FF0000";
			} else if (newVal == "2") {
				_color = "#FFD8D8";
			} else {
				_color = "#D941C5";
			}
			$(".const").css("fill", _color);
		},
		selectLocalBoxInApply: function(newValue, oldValue) {
			if (newValue != '') {
				this.searchModel.sggName = newValue.value;
				this.searchModel.sggCd = newValue.code;
				// this.fnGetSchoolCode(this.searchModel.sggCd);
			} else {
				this.searchModel.sggName = '';
				this.searchModel.sggCd = '';
			}
		},
		selectSchoolBoxInApply: function(newValue, oldValue) {
			if (newValue != '') {
				this.searchModel.schoolName = newValue.value;
				this.searchModel.schoolCd = newValue.code;
				// this.fnGetTargetCode('apply', newValue.code);
			} else {
				this.searchModel.schoolName = '';
				this.searchModel.schoolCd = '';
			}
		},
		selectGradeBoxInApply: function(newValue, oldValue) {
			if (newValue != '') {
				this.searchModel.gradeName = newValue.value;
				this.searchModel.gradeCd = newValue.code;

			} else {
				this.searchModel.gradeName = '';
				this.searchModel.gradeCd = '';
			}
		},
		selectTypeBoxInMain: function(newValue, oldValue) {
			let vm = this;
			if (newValue != '') {
				vm.searchModel.searchTypeName = newValue.value;
				vm.searchModel.searchTypeCd = newValue.code;
				if (newValue.code == "searchType1") {
					vm.fnGetAfterSchoolPrgrCntBySggList();
				} else if (newValue.code == "searchType2") {
					vm.fnGetAfterSchoolTchrCntBySggList();
				} else if (newValue.code == "searchType3") {
					vm.fnGetAfterSchoolSpcCntBySggList();
				}
			} else {
				vm.searchModel.sggName = '';
				vm.searchModel.sggCd = '';
			}
		},
		selectLocalBoxInMain: function(newValue, oldValue) {
			let vm = this;
			if (newValue != '') {
				vm.searchModel.sggName = newValue.value;
				vm.searchModel.sggCd = newValue.code;
			} else {
				vm.searchModel.sggName = '';
				vm.searchModel.sggCd = '';
			}
			console.log('vm.searchModel.searchTypeCd',vm.searchModel.searchTypeCd)
			console.log('vm.searchModel.sggCd',vm.searchModel.sggCd)
			if (vm.searchModel.searchTypeCd == "searchType1") {
				vm.fnGetAfterSchoolPrgrCntBySggList();
				// $("svg path").not("#MAP" + vm.searchModel.sggCd).css("fill", "#eee4c2");
				// $("#MAP" + vm.searchModel.sggCd).css("fill", "#f8cd3f");
			} else if (vm.searchModel.searchTypeCd == "searchType2") {
				vm.fnGetAfterSchoolTchrCntBySggList();
				// $("svg path").not("#MAP" + vm.searchModel.sggCd).css("fill", "#ecd5cd");
				// $("#MAP" + vm.searchModel.sggCd).css("fill", "#ee6538");
			} else if (vm.searchModel.searchTypeCd == "searchType3") {
				vm.fnGetAfterSchoolSpcCntBySggList();
				// $("svg path").not("#MAP" + vm.searchModel.sggCd).css("fill", "#d1e3e7");
				// $("#MAP" + vm.searchModel.sggCd).css("fill", "#5ac1da");
			}
		},
		selectLocalBoxInSearch: function(newValue, oldValue) {
			if (newValue != '') {
				this.searchModel.sggName = newValue.value;
				this.searchModel.sggCd = newValue.code;
			} else {
				this.searchModel.sggName = '';
				this.searchModel.sggCd = '';
			}
		},
		selectDomainBoxInSearch: function(newValue, oldValue) {
			if (newValue != '') {
				this.searchModel.domainName = newValue.value;
				this.searchModel.domainCd = newValue.code;
			} else {
				this.searchModel.domainName = '';
				this.searchModel.domainCd = '';
			}
		},
		selectAffiliationBoxInSearch: function(newValue, oldValue) {
			if (newValue != '') {
				this.searchModel.affiliationName = newValue.value;
				this.searchModel.affiliationCd = newValue.code;
			} else {
				this.searchModel.affiliationName = '';
				this.searchModel.affiliationCd = '';
			}
		},
		selectGradeBoxInSearch: function(newValue, oldValue) {
			if (newValue != '') {
				this.searchModel.targetName = newValue.value;
				this.searchModel.targetCd = newValue.code;
			} else {
				this.searchModel.targetName = '';
				this.searchModel.targetCd = '';
			}
		},
		selectLocalBoxInConnect: function(newValue, oldValue) {
			if (newValue != '') {
				this.searchModel.sggName = newValue.value;
				this.searchModel.sggCd = newValue.code;
			} else {
				this.searchModel.sggName = '';
				this.searchModel.sggCd = '';
			}
		},
		selectYearBoxInMeeting: function(newValue, oldValue) {
			if (newValue != '') {
				this.meetingModel.year = newValue.year;
			} else {
				this.meetingModel.year = '';
			}
			this.fnGetHallOfFame();
		},
		selectHalfYearlyBoxInMeeting: function(newValue, oldValue) {
			if (newValue != '') {
				this.meetingModel.halfYearly = newValue.halfYearly;
			} else {
				this.meetingModel.halfYearly = '';
			}
			this.fnGetHallOfFame();
		},
		selectDateTypeBoxInSearch: function(newValue, oldValue) {
			if (newValue != '') {
				this.searchModel.dateTypeName = newValue.value;
				this.searchModel.dateTypeCd = newValue.code;
			} else {
				this.searchModel.dateTypeName = '';
				this.searchModel.dateTypeCd = '';
			}
		},
		selectEmailBoxInTeacherApply: function(newValue, oldValue){
			if (newValue != null && newValue != '') {
				this.teacherModel.emailAddr = newValue.value;
				this.teacherModel.emailCd = newValue.code;
			} else {
				this.teacherModel.emailAddr = '';
				this.teacherModel.emailCd = '';
			}
		},
		selectLocalBoxInTeacherApply: function(newValue, oldValue){
			if (newValue != '') {
				this.searchModel.sggName = newValue.value;
				this.searchModel.sggCd = newValue.code;
			} else {
				this.searchModel.sggName = '';
				this.searchModel.sggCd = '';
			}
		},
		selectAffilBoxInTeacherSearch: function(newValue, oldValue){
			if (newValue != '') {
				this.searchModel.domainName = newValue.value;
				this.searchModel.domainCd 	= newValue.code;
			} else {
				this.searchModel.domainName = '';
				this.searchModel.domainCd 	= '';
			}
		},
		selectDomainBoxInTeacherApply: function(newValue, oldValue){
			if (newValue != '') {
				// this.searchModel.domainName = newValue.value;
				// this.searchModel.domainCd 	= newValue.code;
				this.searchModel.affiliationName = newValue.value;
				this.searchModel.affiliationCd   = newValue.code;
			} else {
				// this.searchModel.domainName = '';
				// this.searchModel.domainCd 	= '';
				this.searchModel.affiliationName = '';
				this.searchModel.affiliationCd   = '';
			}
			// if(this.menuViewModel.tab==3){
			// 	this.fnGetAfterSchoolTchrCntBySggList();
			// 	this.fnGetAfterSchoolTchrList(1);
			// }
		},
		selectLocalBoxInSpaceApply: function(newValue, oldValue){
			if (newValue != '') {
				this.searchModel.sggName 	= newValue.value;
				this.spaceModel.spaceAddr	= newValue.value;
				this.searchModel.sggCd 		= newValue.code;
			} else {
				this.searchModel.sggName 	= '';
				this.spaceModel.spaceAddr	= '';
				this.searchModel.sggCd 		= '';
			}
		},
		selectEmailBoxInSpaceApply: function(newValue, oldValue){
			if (newValue != '') {
				this.spaceModel.emailAddr 	= newValue.value;
				this.spaceModel.emailCd 	= newValue.code;
			} else {
				this.spaceModel.emailAddr 	= '';
				this.spaceModel.emailCd 	= '';
			}
		},
		selectMajorBoxInSpaceApply: function(newValue, oldValue){
			if (newValue != '') {
				this.spaceModel.facilityMjName 	= newValue.value;
				this.spaceModel.facilityMjCd 	= newValue.code;
			} else {
				this.spaceModel.emailAddr 		= '';
				this.spaceModel.facilityMjName 	= '';
			}
		},

		selectMediumBoxInSpaceApply: function(newValue, oldValue){
			if (newValue != '') {
				this.spaceModel.facilityMdName 	= newValue.value;
				this.spaceModel.facilityMdCd 	= newValue.code;
			} else {
				this.spaceModel.facilityMdName 	= '';
				this.spaceModel.facilityMdCd 	= '';
			}
		},
		phoneNumberByTeacherApply(value){
			let reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|!?@#$%^&*():;+-=~{}<>\_\[\]\|\\\"\'\,\.\/\`\\]/;
			if(reg.exec(value) !== null ) {
				this.phoneNumberByTeacherApply = value.replace(/[^0-9]/g,'');
			}

			if(isNaN(parseInt(value))){
				this.phoneNumberByTeacherApply = '';
			}
			this.teacherModel.phone = this.phoneNumberByTeacherApply;
		},
		phoneNumberBySpaceApply(value){
			let reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|!?@#$%^&*():;+-=~{}<>\_\[\]\|\\\"\'\,\.\/\`\\]/;
			if(reg.exec(value) !== null ) {
				this.phoneNumberBySpaceApply = value.replace(/[^0-9]/g,'');
			}

			if(isNaN(parseInt(value))){
				this.phoneNumberBySpaceApply = '';
			}
			this.spaceModel.spaceTel = this.phoneNumberBySpaceApply;
		},
		admittedCntNumberBySpaceApply(value){
			let reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|!?@#$%^&*():;+-=~{}<>\_\[\]\|\\\"\'\,\.\/\`\\]/;
			if(reg.exec(value) !== null ) {
				this.admittedCntNumberBySpaceApply = value.replace(/[^0-9]/g,'');
			}

			if(isNaN(parseInt(value))){
				this.admittedCntNumberBySpaceApply = '';
			}
			this.spaceModel.admittedCnt = this.admittedCntNumberBySpaceApply;
		},
		surfaceAreaFloatBySpaceApply(value){
			let reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|!?@#$%^&*():;+-=~{}<>\_\[\]\|\\\"\'\,\/\`\\]/;
			if(reg.exec(value) !== null ) {
				this.surfaceAreaFloatBySpaceApply = value.replace(/[^0-9]/g,'');
			}

			if(isNaN(parseFloat(value))){
				this.surfaceAreaFloatBySpaceApply = '';
			}
			this.spaceModel.surfaceArea = this.surfaceAreaFloatBySpaceApply;
		},
		selectBrdCntList: function(newValue, oldValue){
            if (newValue != '') {
                this.mynaviModel.rowValue = newValue.value;
                this.mynaviModel.rowNum = newValue.code;
            } else {
                this.mynaviModel.rowValue = '';
                this.mynaviModel.rowNum = '';
            }

            let pageName = $('#pageName').val();
            if(pageName == 'noticeList'){
                this.fnGetMyNaviNoticeList(1);
            } else if(pageName == 'faqList'){
                this.fnGetMyNaviFaqList(1);
            }
        },
		selectFaqBoxInWrite: function(newValue, oldValue) {
			if (newValue != '') {
				this.searchModel.faqName = newValue.value;
				this.searchModel.faqCd	 = newValue.code;
			} else {
				this.searchModel.faqName = '';
				this.searchModel.faqCd	 = '';
			}
		},
		selectSggBoxInConnectQna: function (newValue, oldValue) {
			if (newValue != '') {
				this.searchModel.sggName = newValue.value;
				this.searchModel.sggCd	 = newValue.code;
			} else {
				this.searchModel.sggName = '';
				this.searchModel.sggCd	 = '';
			}
		}
	},
	methods: {
		fnOnPageLoad: function() {
			let pageName = $("#pageName").val();

			if (pageName == "programSearch") {
				this.mainName = "마을방과후 프로그램";
				this.fnGetProgramSearchPage();
			} else if (pageName == "programDetail") {
				this.mainName = "마을방과후 프로그램";
				this.fnGetProgramDetailPage();
			} else if (pageName == "programApply") {
				this.mainName = "신청/결제";
				this.fnGetProgramApplyPage();
			} else if (pageName == "programApplySuccess") {
				this.mainName = "신청/결제";
			} else if (pageName == "programMain") {
				this.mainName = "마을방과후 프로그램";
        const tab = $("#tab").val();
				this.menuViewModel.isFrstTab = tab === 1;
				this.menuViewModel.isThrdTab = tab === 3;
				this.fnGetProgramPage(tab);
			} else if (pageName == "supportMain") {
				this.mainName = "방과후활동지원센터";
				this.fnGetSupportCenterPage();
			} else if (pageName == "connectMain") {
				this.mainName = "마을방과후 이음";
				this.fnGetConnectPage();
			} else if (pageName == "meetingMain") {
				this.mainName = "청소년 모임터";
				this.fnGetMeetingPage();
			}else if (pageName == "meetingInsert") {
				this.mainName = "청소년 모임터";
				this.fnGetFileKey();
			} else if(pageName == "teacherMain"){
				this.mainName = "마을강사";
				let _sggCd = $('#sggCd').val();
				// let _tab = $('#tab').val();
				let _tab = parseInt($('#tab').val());
				if(  _tab == null || _tab == undefined || isNaN(_tab)
				  || _tab == '' || (_tab > 4 || _tab < 1)){
					_tab = 3;
				}

				if(_sggCd != null && _sggCd != ''){
					_tab = 3;
				}

				this.fnChgTab(_tab);
			} else if(pageName == 'teacherApply'){
				this.mainName = "마을강사 신청내역";
				this.fnChkTeacherApply();	//신청여부 체크
				this.fnGetTeacherApply();
				setTimeout(() => {
					this.fnGetTeacherApplyScene();
				}, 500);

			} else if(pageName == 'tchrDetail'){
				this.mainName = "마을강사 신청내역";
				this.fnChkTeacherApply();
				this.fnGetTeacherApply();

				setTimeout(() => {
					this.fnGetTeacherApplyScene();
				}, 500);

			} else if(pageName == 'teacherDetail'){
        this.mainName = "마을강사 프로필";
        this.fnGetTeacherDetail(1, $("#uidKey").val());
			} else if(pageName == 'spaceMain'){
				this.mainName = "마을공간";
				this.fnGetAfterSpaceSearchPage();
				if($("#tab").val() != null && $("#tab").val() != ''){
					this.fnChgTab($("#tab").val());
				}else{
					this.fnChgTab(2);
				}

			} else if(pageName == 'noticeList'){
				this.mainName = "공지사항 내역";
				this.fnSetCntOption();
				this.fnGetMyNaviNoticeList(1);
			} else if(pageName == 'noticeWrite'){
				this.mainName = "공지사항 작성하기";
				let _uidKey = $('#uidKey').val();
				if(_uidKey != null && _uidKey !=''){
					this.fnGetNoticeDetail(_uidKey);
					setTimeout(() => {
						this.mynaviModel.title = this.boardModel.notice.title;
						this.mynaviModel.content = this.boardModel.notice.contentFirst;
						this.mynaviModel.uidKey = this.boardModel.notice.uidKey;
					},500);
				}
			} else if(pageName == 'faqList'){
				this.mainName = "자주묻는질문 내역";
				this.fnSetCntOption();
				this.fnGetMyNaviFaqList(1);
			} else if(pageName == 'faqWrite'){
				this.mainName = "자주묻는질문 작성하기";
				let _uidKey = $('#uidKey').val();
				if(_uidKey != null && _uidKey !=''){
					this.fnGetFaqDetail(_uidKey);

					setTimeout(() => {
						this.mynaviModel.title = this.boardModel.faq.title;
						this.mynaviModel.content = this.boardModel.faq.content;
						this.mynaviModel.uidKey = this.boardModel.faq.uidKey;
						this.fnGetFaqCode(this.boardModel.faq.faqCd);
					},500);
				} else {
					this.fnGetFaqCode();
				}
			} else  if(pageName=='programPostRequest'){
				this.mainName = '프로그램 게시요청 내역'
				this.fnGetProgramPostRequestList(1);
			} else {
				this.fnGetMainPage();
			}
		},
		//메인페이지(YI-410-01)
		fnGetMainPage: function() {
			let vm = this;
			this.fnOnCheckBanner();
			//마을방과후 서울 구별 리스트
			this.fnGetSeoulGuCode();

			//신규프로그램
			this.fnGetAfterSchoolPrgmList(1);
			//신규마을강사 리스트
			this.fnGetAfterSchoolTchrList(1);
			//신규마을공간 리스트
			this.fnGetAfterSchoolSpcList(1);

			//마을방과후 찾기
			vm.searchModel.searchTypeList.push({
				code: "searchType1",
				value: "마을방과후 프로그램"
			});
			vm.searchModel.searchTypeList.push({
				code: "searchType2",
				value: "마을강사"
			});
			vm.searchModel.searchTypeList.push({
				code: "searchType3",
				value: "마을공간"
			});
			if (vm.searchModel.searchTypeCd == "searchType1") {
				this.fnGetAfterSchoolPrgrCntBySggList();
			} else if (vm.searchModel.searchTypeCd == "searchType2") {
				this.fnGetAfterSchoolTchrCntBySggList();
			} else if (vm.searchModel.searchTypeCd == "searchType3") {
				this.fnGetAfterSchoolSpcCntBySggList();
			}

		},
		 fnOnCheckBanner:function(){
            let vm = this;
            let _param = {
                uidKey: 'BANNVLOCNV00600'
              , divide:'custommer'
            }
            let param = {
                pageNo : 0,
                pageSize : 10,
                paramText : JSON.stringify(_param)
            };

            Axios.post("/api/admin/banner/list", param).then(function(response) {
              vm.listBanner =  response.data.list;
            }).catch(function(ex) {
                console.log(ex);
            });
        },
		//방과후활동지원센터 페이지(YI-410-02)
		fnGetSupportCenterPage: function() {
			let _tab = parseInt($('#tab').val());
			if(  _tab == null || _tab == undefined || isNaN(_tab)
			  || _tab == '' || (_tab > 3 || _tab < 1)){
				_tab = 1;
			}
			this.fnChgTab(_tab);
		},
		//마을방과후 프로그램(YI-410-03)
		fnGetProgramPage: function(tab) {
			let _tab = 0;
			this.searchModel.dateTypeList.push({
				code: "dateType1",
				value: "접수기간"
			});
			this.searchModel.dateTypeList.push({
				code: "dateType2",
				value: "교육기간"
			});

			let paramTab = $("#tab").val();
			if (!this.fnIsEmptyChk(tab)) {
				_tab = tab;
			} else if (!this.fnIsEmptyChk(paramTab)) {
				_tab = paramTab;
			}
			this.fnChgTab(_tab);
		},
		//마을방과후 프로그램 찾기(YI-410-03-03-02)
		fnGetProgramSearchPage: function() {
			let vm = this;
			vm.searchModel.sggCd = $("#sggCd").val();
			vm.searchModel.startDate = $("#startDate").val();
			vm.searchModel.endDate = $("#endDate").val();

			//시군구코드조회
			this.fnGetSeoulGuCode();
			//영역조회
			// this.fnGetDomainCode();
			//계열조회
			this.fnGetAffiliationCode();
			//대상 조회
			this.fnGetTargetCode();
			//프로그램 조회
			this.fnGetAfterSchoolPrgmList(1);

			let _pageName = $("#pageName").val();
			if (_pageName == "programSearch") {
				this.fnChgTab(3);
			}
		},
		//마을방과후 프로그램 상세(YI-410-03-03-03)
		fnGetProgramDetailPage: function(tab) {
			let vm = this;
			vm.programModel.uidKey = $("#uidKey").val();

			//상세페이지 조회
			this.fnGetAfterSchoolPrgmDetail();
			//후기리스트 조회
			this.fnGetAfterSchoolPrgmReviewList();
			//문의리스트 조회
			this.fnGetAfterSchoolPrgmQnaList();

			let _tab = 1;
			let paramTab = $("#uidKey").val();
			if (tab != null && tab > 0) {
				_tab = tab;
			}
			this.fnChgTab(paramTab);
			this.fnChgSubTab(_tab);
		},
		//마을방과후 프로그램 신청
		fnGetProgramApplyPage: function() {
			let vm = this;
			vm.programModel.uidKey = $("#uidKey").val();

			//신청상품정보 조회
			this.fnGetApplyProgramInfo();

			//지역코드 조회
			// this.fnGetLocalCode();
			//학교코드 조회
			// this.fnGetSchoolCode();
			//학년코드 조회
			// this.fnGetTargetCode('apply');

			//신청자 배열 기본 정의
			// vm.applyModel.applyUserList.push(vm.applyModel.applyUser);


			// vm.fnSetParticipantInfo(vm.programModel.user);
		},
		//마을방과후 이음(YI-410-06)
		fnGetConnectPage: function() {
			//마을방과후 서울 구별 리스트
			this.fnGetSeoulGuCode();

			//구별 공지사항 리스트 조회
			// this.fnGetNoticeList(1);

			//카테고리별 자주묻는질문 조회
			// this.fnGetFaqList(1);
			let vm = this;
			let _tab = $('#tab').val();
			let _uidKey = $('#uidKey').val();

			let tab = 1;
			if(_tab != null && _tab != undefined && _tab != ''){
				tab = _tab;
			}
			vm.fnChgTab(tab, _uidKey);
		},
		//마을방과후 청소년 모임터(YI-410-07)
		fnGetMeetingPage: function() {
			let vm = this;
			let _tab = $('#tab').val();
			let _uidKey = $('#uidKey').val();

			let tab = 2;
			if(_tab != null && _tab != undefined && _tab != ''){
				tab = _tab;
			}

			vm.fnChgTab(tab, _uidKey);
		},
		//시군구 코드 조회
		fnGetSeoulGuCode: function() {
			let vm = this;
			let _param = {};
			let param = {param:_param};
			let _pageName = $("#pageName").val();
			Axios.post("/api/afterschool/code/sgg", param).then(function(response) {
				let _sggParam = $("#sggCd").val();
				if(response.data.paramCdDtoList !=null && response.data.paramCdDtoList.length != 0){
					vm.searchModel.sggCdList = [];
					response.data.paramCdDtoList.forEach(function(item) {
						let val = { code: item.sggCd, value: item.sggName };
						vm.searchModel.sggCdList.push(val);
						if (_pageName == "programSearch") {
							if (item.sggCd == _sggParam) {
								vm.selectLocalBoxInSearch = {
									code: item.sggCd,
									value: item.sggName
								};
							}
						} else if (_pageName == "teacherApply") {
							if (item.sggCd == vm.searchModel.sggCd) {
								vm.teacherModel.sggName = item.sggName;
								vm.selectLocalBoxInTeacherApply = {
									code: item.sggCd,
									value: item.sggName
								};
							}
						} else if (_pageName == "tchrDetail") {
							if (item.sggCd == vm.searchModel.sggCd) {
								vm.teacherModel.sggName = item.sggName;
								vm.selectLocalBoxInTeacherApply = {
									code: item.sggCd,
									value: item.sggName
								};
							}
						} else if (_pageName == "connectMain") {
							if (item.sggCd == vm.boardModel.qna.sggCd) {
								vm.teacherModel.sggName = item.sggName;
								vm.selectSggBoxInConnectQna = {
									code: item.sggCd,
									value: item.sggName
								};
							}
						}
					});
				}
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//영역 코드 조회
		fnGetDomainCode: function() {
			let vm = this;
			let param = {};
			Axios.post("/api/afterschool/code/domain", param).then(function(response) {
				response.data.paramCdDtoList.forEach(function(item) {
					let val = { code: item.targetCd, value: item.targetTitle };
					vm.searchModel.domainCdList.push(val);
				});
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//계열 코드 조회
		fnGetAffiliationCode: function() {
			let vm = this;
			let param = {};
			let _pageName = $("#pageName").val();
			Axios.post("/api/afterschool/code/affiliation", param).then(function(response) {
				vm.searchModel.affiliationCdList=[];
				if (_pageName == "teacherMain" && vm.menuViewModel.isThrdTab) {
					vm.searchModel.affiliationCdList.push({
						code	: '',
						value	: "전체",
					});
				}
				response.data.paramCdDtoList.forEach(function(item) {
					let val = { code: item.targetCd, value: item.targetTitle };
					vm.searchModel.affiliationCdList.push(val);
					if (_pageName == "teacherApply") {
						if (item.targetCd == vm.teacherModel.affiliationCd) {
							vm.selectDomainBoxInTeacherApply = {
								code: item.targetCd,
								value: item.targetTitle
							};
						}
					} else if (_pageName == "tchrDetail") {
						if (item.targetCd == vm.teacherModel.affiliationCd) {
							vm.selectDomainBoxInTeacherApply = {
								code: item.targetCd,
								value: item.targetTitle
							};
						}
					}
				});
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//대상 코드 조회-option이 apply면 초,중,고 외 대상코드 제외
		fnGetTargetCode: function(option, _schoolCd, _targetCd) {
			let vm = this;
			let _param = { schoolCd : _schoolCd };
			let param = {param : _param};
			Axios.post("/api/afterschool/code/target", param).then(function(response) {
				if (option == "apply") {
					let school = response.data.paramCdDto;
					let schoolType = '';
					if(school != null){
						if (school.schoolName.indexOf("초등학교") > -1) {
							schoolType = "초등학교";
						} else if (school.schoolName.indexOf("중학교") > -1) {
							schoolType = "중학교";
						} else if (school.schoolName.indexOf("고등학교") > -1) {
							schoolType = "고등학교";
						}
					}
					response.data.paramCdDtoList.forEach(function(item) {
						if (item.targetCd.indexOf("000") == -1) {
							if (item.targetTitle.indexOf(schoolType) > -1) {
								let val = { code: item.targetCd, value: item.targetTitle };
								vm.searchModel.targetCdList.push(val);
							}
						}
					});

					if (!vm.fnIsEmptyChk(_targetCd)) {
						vm.searchModel.targetCdList.forEach(function(item) {
							if (item.code == _targetCd) {
								vm.selectGradeBoxInApply = item;
							}
						});
					}
				} else {
					vm.searchModel.targetCdList = [];
					response.data.paramCdDtoList.forEach(function(item) {
						let val = { code: item.targetCd, value: item.targetTitle };
						vm.searchModel.targetCdList.push(val);
					});
				}
			}).catch(function(ex) {
				console.log(ex);
			});

		},
		//전체지역 코드 조회
		fnGetLocalCode: function(_sggCd) {
			let vm = this;
			let _param = {};
			let param = {param:_param};
			Axios.post("/api/afterschool/code/local", param).then(function(response) {
				response.data.paramCdDtoList.forEach(function(item) {
					let _sggName = item.sido + " " + item.sggName;
					let val = { code: item.sggCd, value: _sggName };
					vm.searchModel.sggCdList.push(val);
				});
				vm.searchModel.sggCdList.forEach(function(object) {
					if (object.code == _sggCd) {
						vm.selectLocalBoxInApply = object;
					}
				});
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//지역별 학교 코드 조회
		fnGetSchoolCode: function(_sggCd, _schoolCd) {
			let vm = this;
			let _param = { sggCd: _sggCd };
			let param = {param : _param};
			Axios.post("/api/afterschool/code/school", param).then(function(response) {
				response.data.paramCdDtoList.forEach(function(item) {
					let val = {
						code: item.schoolCd,
						value: item.schoolName,
						type: item.schoolType
					};
					vm.searchModel.schoolCdList.push(val);
				});
				vm.searchModel.schoolCdList.forEach(function(object) {
					if (object.code == _schoolCd) {
						vm.selectSchoolBoxInApply = object;
					}
				});
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//자주묻는질문 카테고리 코드 조회
		fnGetFaqCode: function(_faqCd) {
			let vm = this;
			let param = {};
			let _pageName = $('#pageName').val();
			Axios.post("/api/afterschool/code/faq", param).then(function(response) {
				vm.searchModel.faqCdList = [];
				if(_pageName != 'faqWrite'){
					vm.searchModel.faqCdList.push({
						code	: '',
						value	: "전체",
						isClick : true
					});
				}
				response.data.paramCdDtoList.forEach(function(item) {
					let val = {
						code	: item.targetCd,
						value	: item.targetTitle,
						isClick	: false
					};
					vm.searchModel.faqCdList.push(val);
				});
				if(_pageName == 'faqWrite'){
					vm.searchModel.faqCdList.forEach(function (item) {
						if(item.code == _faqCd){
							vm.selectFaqBoxInWrite = item;
						}
					});
				}
			}).catch(function(ex) {
				console.log(ex);
			});
			if(_pageName != 'faqWrite'){
				tabSwitch();
			}
		},
		//구별 마을방과후 프로그램 건수 조회
		fnGetAfterSchoolPrgrCntBySggList: function() {
			let vm = this;
			let _startDate = new Date(vm.searchModel.startDate);
			let _endDate = new Date(vm.searchModel.endDate);

			let _tmpStrDt = vm.fnChkDateVal(_startDate);
			let _tmpEndDt = vm.fnChkDateVal(_endDate);
			let _param = { sggCd		: vm.searchModel.sggCd
						 , dateType		: vm.searchModel.dateTypeCd
						 , startDate	: _tmpStrDt
						 , endDate		: _tmpEndDt
						 , orderValue	: vm.orderModel.orderValue
						 , keyword		: vm.searchModel.keyword
						 };
			let param = {param : _param};
			Axios.post("/api/afterschool/program/sggcnt/list", param).then(function(response) {
				vm.mainModel.fndPrgrBySggList = response.data.paramCdDtoList;
				vm.fnChgVal();
				vm.fnChgMapColor('searchType1');
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//구별 마을방과후 강사 건수 조회
		fnGetAfterSchoolTchrCntBySggList: function() {
			let vm = this;
			let _sggCd = '';
			let _tmpSggCd = $('#sggCd').val();
			if(_tmpSggCd != null && _tmpSggCd != ''){
				_sggCd = '';
			} else {
				_sggCd = vm.searchModel.sggCd
			}
			let _param = { sggCd		: _sggCd
						 , keyword		: vm.searchModel.keyword
						 , affiliationCd: vm.searchModel.affiliationCd
						 };
			let param = {param : _param};
			Axios.post("/api/afterschool/teacher/sggcnt/list", param).then(function(response) {
				vm.mainModel.fndTchrBySggList = response.data.paramCdDtoList;
				vm.fnChgVal();
				vm.fnChgMapColor('searchType2');
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//구별 마을방과후 공간 건수 조회
		fnGetAfterSchoolSpcCntBySggList: function() {
			let vm = this;
			let _sggCd = '';
			let _tmpSggCd = $('#sggCd').val();
			if(_tmpSggCd != null && _tmpSggCd != ''){
				_sggCd = '';
			} else {
				_sggCd = vm.searchModel.sggCd
			}
			let _param = { sggCd: _sggCd
						 , mentoringYn : (vm.searchModel.isMentoring ? "Y" : '')
						 , keyword	: vm.searchModel.keyword
						 };
			let param = {param : _param};
			Axios.post("/api/afterschool/space/sggcnt/list", param).then(function(response) {
				vm.mainModel.fndSpcBySggList = response.data.paramCdDtoList;
				vm.fnChgVal();
				vm.fnChgMapColor('searchType3');
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//마을방과후 프로그램 찾기 페이지 목록 새로고침
		fnGetProgramAllPage: function(){
			if(( this.searchModel.endDate != null && this.searchModel.endDate != '' )
			  && this.searchModel.startDate > this.searchModel.endDate){
				swal({
                    title      : '',
                    text       : '시작일보다 이전 날짜를 선택할 수 없습니다.',
                    icon       : vm.fnOnLoadSwalImageData('info'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						},
					},
                    dangerMode : true
                });
				this.searchModel.endDate = '';
				return false;
			}
			this.fnGetAfterSchoolPrgrCntBySggList();
			this.fnGetAfterSchoolPrgmList(1);
			let _pageName = $("#pageName").val();
			setTimeout(() => {
				this.fnSetMap(_pageName);
			}, 200);
		},
		//마을방과후 프로그램 목록 조회
		fnGetAfterSchoolPrgmList: function(pageNumber, _sggCd) {
      let vm = this;
			let _pageName = $("#pageName").val();
			let _paramSggCd = $("#sggCd").val();
			vm.viewModel.pager.rowSize = 6;
			vm.viewModel.pager.blockSize = 5;
			vm.viewModel.pager.pageNo = pageNumber;

			let _startDate = new Date(vm.searchModel.startDate);
			let _endDate = new Date(vm.searchModel.endDate);
			let _tmpStrDt = vm.fnChkDateVal(_startDate);
			let _tmpEndDt = vm.fnChkDateVal(_endDate);
			let tmpSggCd = null;

			if(_sggCd != null && _sggCd !=''){
				tmpSggCd = _sggCd;
			} else if(_paramSggCd != null && _paramSggCd != ''){
				if(vm.searchModel.sggCd != null){
					tmpSggCd = vm.searchModel.sggCd;
				} else {
					tmpSggCd = _paramSggCd;
				}
			} else {
				tmpSggCd = vm.searchModel.sggCd;
			}
			let _param = { sggCd		: tmpSggCd
						 , target		: vm.searchModel.targetCd
						//  , domainCd		: vm.searchModel.domainCd
						 , affiliationCd: vm.searchModel.affiliationCd
						 , dateType		: vm.searchModel.dateTypeCd
						 , startDate	: _tmpStrDt
						 , endDate		: _tmpEndDt
						 , keyword		: vm.searchModel.keyword
						 , orderValue	: vm.orderModel.orderValue
						 };
			let param = { param 		: _param
				    	, pageNo		: vm.viewModel.pager.pageNo
				    	, pageSize		: vm.viewModel.pager.rowSize
				    	};
			Axios.post("/api/afterschool/program/list", param).then(function(response) {
				if (_pageName.indexOf("program") > -1 || _pageName == "meetingMain" || _pageName == 'teacherMain') {
					vm.programModel.programList = [];
					response.data.paramPrgmDtoList.forEach(function (object) {
						if(object.zzimYn == 'Y'){
							object.isZzim = true;
						} else {
							object.isZzim = false;
						}
						let today = new Date();
						let startDate = new Date(object.acceptStartDate);
						let endDate = new Date(object.acceptEndDate);

						if(startDate > today){
							object.status = '접수대기';
						} else if( startDate <= today &&
								   endDate >= today){
								object.status = '접수중';
						} else if(endDate < today){
							object.status = '마감';
						}

						let affList = [];
						let _affNm = object.affiliationName.split(",");

						_affNm.forEach(function(item){
							let affCode = "";

							switch(item){
								case "인문과학":
									affCode = "dpt_label dpt01";
									break;
								case "사회과학":
									affCode = "dpt_label dpt02";
									break;
								case "상경":
									affCode = "dpt_label dpt03";
									break;
								case "사범(교육)":
									affCode = "dpt_label dpt04";
									break;
								case "자연과학":
									affCode = "dpt_label dpt05";
									break;
								case "공학":
									affCode = "dpt_label dpt06";
									break;
								case "의학/보건":
									affCode = "dpt_label dpt07";
									break;
								case "예체능":
									affCode = "dpt_label dpt08";
									break;
								case "융합":
									affCode = "dpt_label dpt09";
									break;
							}

							let affItem = {code : affCode, title : item.substr(0,1)}
							affList.push(affItem);
						});
						object.affList = affList;

						vm.programModel.programList.push(object);
					});
					vm.programModel.programListCnt = response.data.paramListCnt;
					vm.fnSetPager(response.data.paramListCnt, 'fnGetAfterSchoolPrgmList');
				} else {
					vm.mainModel.newPrgrList = [];

					console.log(response.data.paramPrgmDtoList);
					response.data.paramPrgmDtoList.forEach(function (object) {
						if(object.zzimYn == 'Y'){
							object.isZzim = true;
						} else {
							object.isZzim = false;
						}

						// let today = new Date();
						// let startDate = new Date(object.acceptStartDate);
						// let endDate = new Date(object.acceptEndDate);

						// if(startDate > today){
						// 	object.status = '접수대기';
						// } else if( startDate <= today &&
						// 		   endDate >= today){
						// 		object.status = '접수중';
						// } else if(endDate < today){
						// 	object.status = '마감';
						// }


						if(object.status == "IXVNV00001"){
							object.status = '접수대기';
						}else if(object.status == "IXVNV00002"){
							object.status = '접수중';
						}else if(object.status == "IXVNV00004"){
							object.status = '마감';
						}

						let affList = [];
						let _affNm = object.affiliationName.split(",");

						_affNm.forEach(function(item){
							let affCode = "";
							switch(item){
								case "인문과학":
									affCode = "dpt_label dpt01";
									break;
								case "사회과학":
									affCode = "dpt_label dpt02";
									break;
								case "상경":
									affCode = "dpt_label dpt03";
									break;
								case "사범(교육)":
									affCode = "dpt_label dpt04";
									break;
								case "자연과학":
									affCode = "dpt_label dpt05";
									break;
								case "공학":
									affCode = "dpt_label dpt06";
									break;
								case "의학/보건":
									affCode = "dpt_label dpt07";
									break;
								case "예체능":
									affCode = "dpt_label dpt08";
									break;
								case "융합":
									affCode = "dpt_label dpt09";
									break;
							}

							let affItem = {code : affCode, title : item.substr(0,1)}
							affList.push(affItem);

						});
						object.affList = affList;

						vm.mainModel.newPrgrList.push(object);
					});
					vm.fnSetPager(response.data.paramListCnt, 'fnGetAfterSchoolPrgmList');
				}
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//찜버튼 클릭
		fnChgZzimButton: function(object){
			let vm = this;
			//로그인 체크
			let _userKey = $("#loginUserKey").val();

			if (this.fnIsEmptyChk(_userKey)) {
				swal({
                    title      : '',
                    text       : '로그인이 필요합니다. 로그인 페이지로 이동합니다.',
                    icon       : vm.fnOnLoadSwalImageData('info'),
                    buttons    : true,
                    dangerMode : true
                }).then(result => {
                    if(result){
                        location.href = "/youthnavi/signup/login";
                    }
                });
			} else {
				//로그인이 되어 있으면
				object.isZzim = !object.isZzim;

				let _param = { uidKey : object.uidKey};
				let param = { param : _param};
				Axios.post("/api/afterschool/program/zzim/update", param).then(function(response) {
					let result = response.data.result
				}).catch(function(ex) {
					console.log(ex);
				});
			}
		},
		//마을방과후 강사 목록 조회
		fnGetAfterSchoolTchrList: function(pageNumber, _sggCd) {
			let vm = this;
			vm.viewModel.pager.rowSize = 6;
			vm.viewModel.pager.blockSize = 5;
			vm.viewModel.pager.pageNo = pageNumber;
			let tmpSggCd = '';
			if(_sggCd != null && _sggCd !=''){
				tmpSggCd = _sggCd;
			} else {
				tmpSggCd = vm.searchModel.sggCd;
			}
			let _param = { sggCd 		: tmpSggCd
						 , keyword		: vm.searchModel.keyword
						 , affiliationCd : vm.searchModel.affiliationCd
						 , orderValue	: vm.orderModel.orderValue
						 };
			let param = { param 		: _param
				    	, pageNo		: vm.viewModel.pager.pageNo
				    	, pageSize		: vm.viewModel.pager.rowSize
				    	};
			Axios.post("/api/afterschool/teacher/list", param).then(function(response) {
				vm.teacherModel.teacherList = response.data.paramUsrDtoList;
				vm.teacherModel.teacherListCnt = response.data.paramListCnt;
				vm.fnSetPager(response.data.paramListCnt,'fnGetAfterSchoolTchrList');
			}).catch(function(ex) {
			    console.log(ex);
			});
		},
		//마을방과후 공간 목록 조회
		fnGetAfterSchoolSpcList: function(pageNumber, _sggCd) {
			let vm = this;
			vm.viewModel.pager.rowSize = 6;
			vm.viewModel.pager.blockSize = 5;
			vm.viewModel.pager.pageNo = pageNumber;
			let tmpSggCd = '';
			if(_sggCd != null && _sggCd !=''){
				tmpSggCd = _sggCd;
			} else {
				tmpSggCd = vm.searchModel.sggCd;
			}
			let _param = { sggCd 		: tmpSggCd
						 , mentoringYn	: (vm.searchModel.isMentoring ? "Y" : '')
						 , keyword		: vm.searchModel.keyword
						 , orderValue	: vm.orderModel.orderValue
						 };
			let param = { param 		: _param
				    	, pageNo		: vm.viewModel.pager.pageNo
				    	, pageSize		: vm.viewModel.pager.rowSize
				    	};
			Axios.post("/api/afterschool/space/list", param).then(function(response) {
				vm.spaceModel.spaceList = response.data.paramSpcDtoList;
				vm.spaceModel.spaceList.cnt = response.data.paramListCnt;
				vm.fnSetPager(response.data.paramListCnt,'fnGetAfterSchoolSpcList');
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//마을방과후 프로그램 상세 조회
		fnGetAfterSchoolPrgmDetail: function() {
			let vm = this;
			let _param = { uidKey: vm.programModel.uidKey };
			let param = { param : _param};
			Axios.post("/api/afterschool/program/detail", param).then(function(response) {
				vm.programModel.program = response.data.paramPrgmDto;
				if(vm.programModel.program.zzimYn == 'Y'){
					vm.programModel.program.isZzim = true;
				} else {
					vm.programModel.program.isZzim = false;
				}
				vm.programModel.roundList = response.data.paramPrgmDtoList;
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//마을방과후 프로그램 신청상품정보 조회
		fnGetApplyProgramInfo: function() {
			let vm = this;
			let _uidKey = $("#uidKey").val();
			let _param = { roundUidKey: _uidKey };
			let param = { param : _param};
			Axios.post("/api/afterschool/program/apply/info", param).then(function(response) {
				vm.programModel.program = response.data.paramPrgmDto;		//프로그램 정보
				vm.programModel.user = response.data.paramUsrDto;			//사용자정보
				let _birthYear = vm.programModel.user.birthday.substr(0,4)
				let _todayYear = new Date().getFullYear();
				vm.programModel.user.age = _todayYear - _birthYear +1;
				vm.programModel.user.phoneFront = vm.programModel.user.cellphone.substr(0, 3);
				vm.programModel.user.phoneMiddle = vm.programModel.user.cellphone.substr(3, 4);
				vm.programModel.user.phoneBack = vm.programModel.user.cellphone.substr(7, 4);
				let sggCd = vm.programModel.user.schoolSggCd;
				let schoolCd = vm.programModel.user.schoolCd;
				let targetCd = vm.programModel.user.gradeCd;
				if(sggCd != null && sggCd != ''){
					vm.fnGetLocalCode(sggCd);
				}
				if(schoolCd != null && schoolCd != ''){
					vm.fnGetSchoolCode(sggCd, schoolCd);
					vm.fnGetTargetCode("apply", schoolCd, targetCd);
				}
				vm.applyModel.applyPrice = vm.programModel.program.price * vm.applyModel.applyCnt;
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//마을방과후 프로그램 후기 리스트 조회
		fnGetAfterSchoolPrgmReviewList: function() {
			let vm = this;
			vm.viewModel.pager.rowSize = 3;
			vm.viewModel.pager.blockSize = 5;
			let _param = {uidKey: vm.programModel.uidKey};
			let param = { param : _param
				    , pageNo: vm.viewModel.pager.pageNo
				    , pageSize: vm.viewModel.pager.rowSize};
			Axios.post("/api/afterschool/program/detail/review/list", param).then(function(response) {
				vm.programModel.reviewList = response.data.paramBrdDtoList;
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//마을방과후 프로그램 문의 리스트 조회
		fnGetAfterSchoolPrgmQnaList: function() {
			let vm = this;
			vm.viewModel.pager.rowSize = 3;
			vm.viewModel.pager.blockSize = 5;
			let _param = {programKey: vm.programModel.uidKey};
			let param = { param : _param
						, pageNo: vm.viewModel.pager.pageNo
						, pageSize: vm.viewModel.pager.rowSize
						};
			Axios.post("/api/afterschool/program/detail/qna/list", param).then(function(response) {
			if (response.data.paramQnaDtoList != null && response.data.paramQnaDtoList.length > 0) {
				vm.programModel.qnaList = [];
				response.data.paramQnaDtoList.forEach(function(item) {
					item.isPwSct = false;
					item.inputPw = '';
					vm.programModel.qnaList.push(item);
				});
			}
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//마을방과후 프로그램 후기 상세 조회
		fnGetAfterSchoolPrgmReviewDetail: function(_uidKey) {
			let vm = this;
			let _param = { uidKey: _uidKey };
			let param = { param : _param};
			Axios.post("/api/afterschool/program/detail/review/detail", param).then(function(response) {
				vm.programModel.review = response.data.paramBrdDto;
			}) .catch(function(ex) {
				console.log(ex);
			});
		},
		//마을방과후 프로그램 문의 상세 조회
		fnGetAfterSchoolPrgmQnaDetail: function(_uidKey) {
			let vm = this;
			let _param = { uidKey: _uidKey };
			let param = { param : _param};
			Axios.post("/api/afterschool/program/detail/qna/detail", param).then(function(response) {
				vm.programModel.qna = response.data.paramQnaDto;
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//마을방과후 프로그램 후기 상세 등록
		fnSetAfterSchoolPrgmReviewDetail: function() {
			let vm = this;
			let _param = { programKey: vm.programModel.program.uidKey
			, title: vm.programModel.review.title
			, contentFirst: vm.programModel.review.contentFirst
			, satisfaction : vm.programModel.review.vote};
			let param = { param : _param};
			Axios.post("/api/afterschool/program/detail/review/write", param).then(function(response) {
				let result = response.data.result;
				if (result > 0) {
					swal({
						title      : '',
						text       : '정상적으로 등록되었습니다.',
						icon       : vm.fnOnLoadSwalImageData('success'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							vm.onClickAfterProgramDetailtoList(3);
						}
					});
				} else {
					swal({
						title      : '',
						text       : '등록에 실패하였습니다',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					});
					return false;
				}
			}) .catch(function(ex) {
				console.log(ex);
				swal({
					title      : '',
					text       : '등록에 실패하였습니다',
					icon       : vm.fnOnLoadSwalImageData('error'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						},
					},
					dangerMode : true
				});
				return false;
			});
		},
		//마을방과후 프로그램 후기 상세 수정
		fnSetAfterSchoolPrgmReviewDetailUpdate: function() {
			let vm = this;
			let _param = { programKey: vm.programModel.program.uidKey
				     , uidKey: vm.programModel.review.uidKey
				     , title: vm.programModel.review.title
				     , contentFirst: vm.programModel.review.contentFirst
				     , satisfaction : vm.programModel.review.vote};
			let param = { param : _param};
			Axios.post("/api/afterschool/program/detail/review/update", param).then(function(response) {
				let result = response.data.result;
				if (result > 0) {
					swal({
						title      : '',
						text       : '정상적으로 수정되었습니다.',
						icon       : vm.fnOnLoadSwalImageData('success'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							vm.onClickAfterProgramDetailtoList(3);
						}
					});
				} else {
					swal({
						title      : '',
						text       : '수정에 실패하였습니다',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					});
					return false;
				}
			}).catch(function(ex) {
				console.log(ex);
				swal({
					title      : '',
					text       : '수정에 실패하였습니다',
					icon       : vm.fnOnLoadSwalImageData('error'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						},
					},
					dangerMode : true
				});
				return false;
			});
		},
		//마을방과후 프로그램 문의 상세 등록
		fnSetAfterSchoolPrgmQnaDetail: function() {
			let vm = this;
			let _param = { programKey: vm.programModel.program.uidKey
				     , title: vm.programModel.review.title
				     , contentFirst: vm.programModel.review.contentFirst
				     , password: vm.programModel.qna.password
					 , centerKey: vm.programModel.program.centerKey
				     };
			let param = { param : _param};
			Axios.post("/api/afterschool/program/detail/qna/write", param).then(function(response) {
				let result = response.data.result;
				if (result > 0) {
					swal({
						title      : '',
						text       : '정상적으로 등록되었습니다.',
						icon       : vm.fnOnLoadSwalImageData('success'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							vm.onClickAfterProgramDetailtoList(4);
						}
					});

				} else {
					swal({
						title      : '',
						text       : '등록에 실패하였습니다.',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					});
					return false;
				}
			}).catch(function(ex) {
				console.log(ex);
				swal({
					title      : '',
					text       : '등록에 실패하였습니다.',
					icon       : vm.fnOnLoadSwalImageData('error'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						},
					},
					dangerMode : true
				});
				return false;
			});
		},
		//마을방과후 프로그램 문의 상세 수정
		fnSetAfterSchoolPrgmQnaDetailUpdate: function() {
			let vm = this;
			let _param = { title: vm.programModel.qna.title
				     , contentFirst: vm.programModel.qna.content
				     , uidKey: vm.programModel.qna.uidKey
				     };
			let param = { param : _param};
			Axios.post("/api/afterschool/program/detail/qna/update", param).then(function(response) {
				let result = response.data.result;
				if (result > 0) {
					swal({
						title      : '',
						text       : '정상적으로 수정되었습니다.',
						icon       : vm.fnOnLoadSwalImageData('success'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							vm.onClickAfterProgramDetailtoList(4);
						}
					});
				} else {
					swal({
						title      : '',
						text       : '수정에 실패하였습니다.',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					});
					return false;
				}
			}).catch(function(ex) {
				console.log(ex);
				swal({
					title      : '',
					text       : '수정에 실패하였습니다.',
					icon       : vm.fnOnLoadSwalImageData('error'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						},
					},
					dangerMode : true
				});
				return false;
			});
		},
		//마을방과후 프로그램 후기 상세 삭제
		fnSetAfterSchoolPrgmReviewDelete: function() {
			let vm = this;
			let _param = { uidKey: vm.programModel.review.uidKey };
			let param = { param : _param};
			Axios.post("/api/afterschool/program/detail/review/delete", param).then(function(response) {
				let result = response.data.result;
				if (result > 0) {
					swal({
						title      : '',
						text       : '정상적으로 삭제되었습니다.',
						icon       : vm.fnOnLoadSwalImageData('success'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							vm.onClickAfterProgramDetailtoList(4);
						}
					});
				} else {
					swal({
						title      : '',
						text       : '삭제에 실패하였습니다.',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					});
					return false;
				}
				}).catch(function(ex) {
					console.log(ex);
					swal({
						title      : '',
						text       : '삭제에 실패하였습니다.',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					});
				return false;
			});
		},
		//마을방과후 프로그램 문의 상세 삭제
		fnSetAfterSchoolPrgmQnaDelete: function() {
			let vm = this;
			let _param = { uidKey: vm.programModel.qna.uidKey };
			let param = { param : _param};
			Axios.post("/api/afterschool/program/detail/qna/delete", param).then(function(response) {
				let result = response.data.result;
				if (result > 0) {
					swal({
						title      : '',
						text       : '정상적으로 삭제되었습니다.',
						icon       : vm.fnOnLoadSwalImageData('success'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							vm.onClickAfterProgramDetailtoList(4);
						}
					});
				} else {
					swal({
						title      : '',
						text       : '삭제에 실패하였습니다.',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					});
					return false;
				}
				}).catch(function(ex) {
					console.log(ex);
					swal({
						title      : '',
						text       : '삭제에 실패하였습니다.',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					});
				return false;
			});
		},
		//마을방과후 이음 공지사항 목록 조회
		fnGetNoticeList: function(pageNumber) {
			let vm = this;
			if(vm.fnIsEmptyChk(pageNumber)){
				pageNumber = 1;
			}
			vm.viewModel.pager.rowSize = 4;
			vm.viewModel.pager.blockSize = 5;
			vm.viewModel.pager.pageNo = pageNumber;
			let _param = { keyword: vm.searchModel.keyword
				     , sggCd: vm.searchModel.sggCd
				     };
			let param = { param : _param
				    , pageNo: vm.viewModel.pager.pageNo
				    , pageSize: vm.viewModel.pager.rowSize
				    };
			Axios.post("/api/afterschool/connect/notice/list", param).then(function(response) {
				vm.boardModel.noticeList = response.data.paramBrdDtoList;
				vm.boardModel.noticeListCnt = response.data.paramListCnt;
				vm.fnSetPager(response.data.paramListCnt, 'fnGetNoticeList');
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//마을방과후 이음 공지사항 상세 조회
		fnGetNoticeDetail: function(_uidKey) {
			let vm = this;
			let _param = { uidKey: _uidKey };
			let param = { param : _param};
			Axios.post("/api/afterschool/connect/notice/detail", param).then(function(response) {
				vm.boardModel.notice = response.data.paramBrdDto;
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//마을방과후 이음 자주묻는질문 목록 조회
		fnGetFaqList: function(pageNumber) {
			let vm = this;
			vm.viewModel.pager.rowSize = 4;
			vm.viewModel.pager.blockSize = 5;
			vm.viewModel.pager.pageNo = pageNumber;
			let _param = { keyword: vm.searchModel.keyword
				     , faqCd: vm.searchModel.faqCd
				     };
			let param = { param : _param
				    , pageNo: vm.viewModel.pager.pageNo
				    , pageSize: vm.viewModel.pager.rowSize
				    };
			Axios.post("/api/afterschool/connect/faq/list", param).then(function(response) {
				vm.boardModel.faqList = response.data.paramQnaDtoList;
				vm.boardModel.faqListCnt = response.data.paramListCnt;
				vm.fnSetPager(response.data.paramListCnt, 'fnGetFaqList');
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//마을방과후 이음 자주묻는질문 상세 조회
		fnGetFaqDetail: function(_uidKey) {
			let vm = this;
			let _param = { uidKey: _uidKey };
			let param = { param : _param};
			Axios.post("/api/afterschool/connect/faq/detail", param).then(function(response) {
				vm.boardModel.faq = response.data.paramQnaDto;
				if(vm.boardModel.faq.likeYn == 'Y'){
					vm.boardModel.faq.isLike = true;
				} else {
					vm.boardModel.faq.isLike = false;
				}
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//청소년 모임터 탭 변경 이동
		fnGotoMeetingPlace(idx){
			location.href = "/customer/afterschool/meetingPlace?tab=" + idx;
		},
		//탭 변환
		fnChgTab: function(tab, uidKey) {
			let vm = this;
			let pageName = $("#pageName").val();
			if(pageName == 'meetingMain'){
				if(tab == 1){
					vm.menuViewModel.isFrstTab = true;
					vm.menuViewModel.isScndTab = false;
					vm.menuViewModel.isThrdTab = false;
					if(uidKey == null || uidKey == undefined || uidKey == ''){
						//청소년 방과후 갤러리 리스트 조회
						vm.fnGetGalleryList(1);
					} else {
						vm.fnGetGalleryDetail(uidKey)
					}
				} else if(tab == 2){
					//인기콘텐츠 리스트 조회
					this.fnGetProgramSearchPage();
					vm.menuViewModel.isFrstTab = false;
					vm.menuViewModel.isScndTab = true;
					vm.menuViewModel.isThrdTab = false;
				} else if(tab == 3){
					//명예의 전당(반기별) 조회
					//-연도지정(2021~2025)
					let today = new Date();
					vm.meetingModel.thisYear = today.getFullYear();
					vm.meetingModel.thisMonth = today.getMonth();
					vm.meetingModel.yearList = [];
					for (let i = 1; i <= 5; i++) {
						let _year = { year: "202" + i };
						vm.meetingModel.yearList.push(_year);
					}
					//-반기지정(상반기(1~6), 하반기(7~12))
					vm.meetingModel.halfYearlyList = [];
					vm.meetingModel.halfYearlyList.push({ halfYearly: "상반기" });
					vm.meetingModel.halfYearlyList.push({ halfYearly: "하반기" });
					this.fnGetHallOfFame();
					vm.menuViewModel.isFrstTab = false;
					vm.menuViewModel.isScndTab = false;
					vm.menuViewModel.isThrdTab = true;
				}
			} else if (pageName == 'connectMain'){
				vm.searchModel.keyword = '';
				vm.searchModel.sggCd = '';
				vm.searchModel.faqCd = '';

				//공지사항
				if (tab == 1) {
					if(uidKey == null || uidKey == undefined || uidKey == ''){
						vm.fnChgCnnctSubSct(1);
						vm.fnGetNoticeList(1);
					} else {
						vm.fnChgCnnctSubSct(2, uidKey, 'notice');
					}
					vm.menuViewModel.isFrstTab = true;
					vm.menuViewModel.isScndTab = false;
					vm.menuViewModel.isThrdTab = false;
				//자주묻는질문
				} else if (tab == 2) {
					if(vm.boardViewModel.isFrstSct){
						vm.fnGetFaqCode();
					}
					if(uidKey == null || uidKey == undefined || uidKey == ''){
						vm.fnChgCnnctSubSct(1);
						vm.fnGetFaqList(1);
					} else {
						vm.fnChgCnnctSubSct(2, uidKey ,'faq');
					}
					vm.menuViewModel.isFrstTab = false;
					vm.menuViewModel.isScndTab = true;
					vm.menuViewModel.isThrdTab = false;
				//문의하기
				} else if (tab == 3) {
					let _subTab = $('#subTab').val();
					if(_subTab != null && _subTab != undefined && _subTab != ''){
						vm.fnChgCnnctSubSct(_subTab);
					} else if(uidKey == null || uidKey == undefined || uidKey == ''){
						vm.fnChgCnnctSubSct(1);
						vm.fnGetQnaList(1);
					} else {
						vm.fnChgCnnctSubSct(2, uidKey ,'qna');
					}
					vm.menuViewModel.isFrstTab = false;
					vm.menuViewModel.isScndTab = false;
					vm.menuViewModel.isThrdTab = true;


				}
			} else if(pageName == 'programMain'){
				vm.menuViewModel.tab = tab;
				vm.fnChgValInitByPrgm();
				if (tab == 1) {
					vm.menuViewModel.isFrstTab = true;
					vm.menuViewModel.isScndTab = false;
					vm.menuViewModel.isThrdTab = false;
					vm.menuViewModel.isFrthTab = false;
				} else if (tab == 3) {
					vm.fnGetAfterSchoolPrgrCntBySggList();
					vm.fnGetAfterSchoolPrgmList(1);
					vm.menuViewModel.isFrstTab = false;
					vm.menuViewModel.isScndTab = false;
					vm.menuViewModel.isThrdTab = true;
					vm.menuViewModel.isFrthTab = false;
				}
			} else if (pageName == 'teacherMain'){
				vm.menuViewModel.tab = tab;
				vm.fnChgValInitByTchr();
				if (tab == 1) {
					vm.menuViewModel.isFrstTab = true;
					vm.menuViewModel.isScndTab = false;
					vm.menuViewModel.isThrdTab = false;
					vm.menuViewModel.isFrthTab = false;
				} else if (tab == 2) {
					vm.fnChkTeacherApply();
					setTimeout(() => {
						if(vm.teacherModel.applyCheck > 0){
							vm.fnChgTab(1);
						} else {
							vm.menuViewModel.isFrstTab = false;
							vm.menuViewModel.isScndTab = true;
							vm.menuViewModel.isThrdTab = false;
							vm.menuViewModel.isFrthTab = false;
							vm.fnGetTeacherApplyScene();
						}
					}, 200);
				} else if (tab == 3) {
					let _tmp = $('#uidKey').val();
					if(_tmp != null && _tmp != undefined && _tmp != ''){
						vm.fnChgSubTabByTchr(2, _tmp)
					} else {
						vm.fnGetAfterTeacherSearchPage();
					}
					vm.menuViewModel.isFrstTab = false;
					vm.menuViewModel.isScndTab = false;
					vm.menuViewModel.isThrdTab = true;
					vm.menuViewModel.isFrthTab = false;
				} else if (tab == 4) {
					vm.teacherModel.keyword = '';
					vm.fnChgSubTabByTchr(1);
					vm.menuViewModel.isFrstTab = false;
					vm.menuViewModel.isScndTab = false;
					vm.menuViewModel.isThrdTab = false;
					vm.menuViewModel.isFrthTab = true;
				}

			} else {
				let _tab = 0;
				vm.mapViewModel.mapInit = 0;

				if (tab > 0) {
					_tab = tab;
				} else if (pageName.indexOf("program") > -1) {
					_tab = $("#tab").val();
				}

				if (_tab == null || _tab == 0) {
					vm.menuViewModel.tab = tab;
				}

				if (vm.menuViewModel.tab == null || vm.menuViewModel.tab == 0) {
					vm.menuViewModel.tab = _tab;
				} else {
					vm.menuViewModel.tab = tab;
				}

				if (pageName == 'spaceMain'){
					vm.fnChgValInitBySpc();
				} else if (pageName == 'teacherMain'){
					vm.fnChgValInitByTchr();
				} else if (pageName.indexOf("program") > -1 || pageName == 'meetingPlace') {
					vm.fnChgValInitByPrgm();
				}

				if (vm.menuViewModel.tab == 1) {
					if (pageName.indexOf("connect") > -1) {
						vm.fnGetNoticeList(1);
					} else if(pageName == 'spaceMain'){
						vm.fnGetSpaceApply();
						vm.fnGetImgFileKeyBySpace();
					}
					vm.menuViewModel.isFrstTab = true;
					vm.menuViewModel.isScndTab = false;
					vm.menuViewModel.isThrdTab = false;
					vm.menuViewModel.isFrthTab = false;

				} else if (vm.menuViewModel.tab == 2) {
					if(pageName.indexOf("teacher") > -1) {
						if(vm.menuViewModel.tab == 2){
							vm.fnChkTeacherApply();
							setTimeout(() => {
								if(vm.teacherModel.applyCheck > 0){
									vm.fnChgTab(1);
								} else {
									vm.fnGetTeacherApplyScene();
									vm.menuViewModel.isFrstTab = false;
									vm.menuViewModel.isScndTab = true;
									vm.menuViewModel.isThrdTab = false;
									vm.menuViewModel.isFrthTab = false;
								}
							}, 200);
						}
					} else if (pageName.indexOf("connect") > -1) {
						vm.fnGetFaqList(1);
					} else if(pageName == 'spaceMain'){
						let _uidKey = $('#uidKey').val();
						if(_uidKey != null && _uidKey != ''){
							vm.fnChgSubTabBySpc(2, _uidKey);
						} else {
							vm.fnGetAfterSpaceSearchPage();
						}
					}
					vm.menuViewModel.isFrstTab = false;
					vm.menuViewModel.isScndTab = true;
					vm.menuViewModel.isThrdTab = false;
					vm.menuViewModel.isFrthTab = false;

				} else if (vm.menuViewModel.tab == 3) {
					vm.menuViewModel.isFrstTab = false;
					vm.menuViewModel.isScndTab = false;
					vm.menuViewModel.isThrdTab = true;
					vm.menuViewModel.isFrthTab = false;

					if (pageName == "programMain")  {
						vm.fnChgValInitByPrgm();
						vm.fnGetAfterSchoolPrgrCntBySggList();
						vm.fnGetAfterSchoolPrgmList(1);
					} else if(pageName == 'meetingPlace') {
						vm.fnChgValInitByPrgm();
					} else if(pageName == 'teacherMain'){
						vm.fnGetAfterTeacherSearchPage();
					}
				} else if (vm.menuViewModel.tab == 4) {
					if(pageName == 'teacherMain'){
						vm.teacherModel.keyword = '';
						vm.fnChgSubTabByTchr(1);
					}
					vm.menuViewModel.isFrstTab = false;
					vm.menuViewModel.isScndTab = false;
					vm.menuViewModel.isThrdTab = false;
					vm.menuViewModel.isFrthTab = true;
				}
				// if(pageName == 'meetingMain'){
				// 	vm.fnChgMtpcSubSct(1);
				// }
				vm.boardModel.isReportOn = false;
			}
		},
		//정렬 변환
		fnChgOrder: function(order) {

			let vm = this;
			let pageName = $('#pageName').val();
			// 최신순
			if (order == "1") {
				vm.orderModel.isLatest = true;
				vm.orderModel.isPopularity = false;
				vm.orderModel.orderValue = order;
			/*  프로그램 : 인기순
				마을강사 : 이름순
				마을공간 : 이름순 */
			} else if (order == "2") {
				vm.orderModel.isLatest = false;
				vm.orderModel.isPopularity = true;
				vm.orderModel.orderValue = order;
			}
			if(pageName == 'programMain'){
				vm.fnGetAfterSchoolPrgmList(1);
			} else if(pageName == 'teacherMain'){
				vm.fnGetAfterSchoolTchrList(1);
			} else if(pageName == 'spaceMain'){
				vm.fnGetAfterSchoolSpcList(1);
			}
		},
		//하위탭 변환
		fnChgSubTab: function(tab) {
			let vm = this;
			if (tab == 1) {
				vm.programViewModel.isFrstTab = true;
				vm.programViewModel.isScndTab = false;
				vm.programViewModel.isThrdTab = false;
				vm.programViewModel.isFrthTab = false;
				$("#aftschprgrapply").show();
			} else if (tab == 2) {
				vm.programViewModel.isFrstTab = false;
				vm.programViewModel.isScndTab = true;
				vm.programViewModel.isThrdTab = false;
				vm.programViewModel.isFrthTab = false;
				$("#aftschprgrapply").show();
			} else if (tab == 3) {
				vm.programViewModel.isFrstTab = false;
				vm.programViewModel.isScndTab = false;
				vm.programViewModel.isThrdTab = true;
				vm.programViewModel.isFrthTab = false;
				vm.fnChgSubSct(1);
				$("#aftschprgrapply").hide();
			} else if (tab == 4) {
				vm.programViewModel.isFrstTab = false;
				vm.programViewModel.isScndTab = false;
				vm.programViewModel.isThrdTab = false;
				vm.programViewModel.isFrthTab = true;
				vm.fnChgSubSct(1);
				$("#aftschprgrapply").hide();
			}
			this.fnChgIsPwCheck();
		},
		//하위섹션(목록, 상세, 글쓰기, 수정) 변환
		fnChgSubSct: function(tab, uidKey) {
			let vm = this;
			//목록
			if (tab == 1) {
				vm.programViewModel.isSubFrstSct = true;
				vm.programViewModel.isSubScndSct = false;
				vm.programViewModel.isSubThrdSct = false;
				vm.programViewModel.isSubFrthSct = false;
			//상세
			} else if (tab == 2) {
				if (vm.programViewModel.isThrdTab) {
					this.fnGetAfterSchoolPrgmReviewDetail(uidKey);
				} else if (vm.programViewModel.isFrthTab) {
					this.fnGetAfterSchoolPrgmQnaDetail(uidKey);
				}
				vm.programViewModel.isSubFrstSct = false;
				vm.programViewModel.isSubScndSct = true;
				vm.programViewModel.isSubThrdSct = false;
				vm.programViewModel.isSubFrthSct = false;
			//글쓰기
			} else if (tab == 3) {
				let _userKey = $("#loginUserKey").val();
				if (this.fnIsEmptyChk(_userKey)) {
					swal({
						title      : '',
						text       : '로그인이 필요합니다. 로그인 페이지로 이동합니다.',
						icon       : vm.fnOnLoadSwalImageData('info'),
						buttons    : true,
						dangerMode : true
					}).then(result => {
						if(result){
							location.href = "/youthnavi/signup/login";
						}else{
							return;
						}
					});
				}

				//참가여부 체크

				let _uidKey = $('#uidKey').val();
				let _param = {uidKey: _uidKey};
				let param = {param:_param};
				Axios.post("/api/afterschool/program/participate/check", param).then(function(response) {
					//vm.programModel.participateCnt = response.data.result;
					let result = response.data.result;

					if(result == 0){
						swal({
							title      : '',
							text       : '프로그램에 참가해야만 후기를 작성할 수 있습니다.',
							icon       : vm.fnOnLoadSwalImageData('warning'),
							buttons: {
								cancel: {
									text: "Cancel",
									value: false,
									visible: false,
								},
								confirm: {
									text: "Ok",
									value: true,
									visible: true,
								},
							},
							dangerMode : true
						});
						return false;
					} else {
						vm.programViewModel.isSubFrstSct = false;
						vm.programViewModel.isSubScndSct = false;
						vm.programViewModel.isSubThrdSct = true;
						vm.programViewModel.isSubFrthSct = false;
					}

				}).catch(function(ex) {
					console.log(ex);
				});





				// 	this.fnGetProgramparticipateYn();
				// 	setTimeout(() => {
				// 		if(vm.programModel.participateCnt == 0){
				// 			swal({
				// 				title      : '',
				// 				text       : '프로그램에 참가해야만 후기를 작성할 수 있습니다.',
				// 				icon       : vm.fnOnLoadSwalImageData('warning'),
				// 				buttons: {
				// 					cancel: {
				// 						text: "Cancel",
				// 						value: false,
				// 						visible: false,
				// 					},
				// 					confirm: {
				// 						text: "Ok",
				// 						value: true,
				// 						visible: true,
				// 					},
				// 				},
				// 				dangerMode : true
				// 			});
				// 			return false;
				// 		} else {
				// 			vm.programViewModel.isSubFrstSct = false;
				// 			vm.programViewModel.isSubScndSct = false;
				// 			vm.programViewModel.isSubThrdSct = true;
				// 			vm.programViewModel.isSubFrthSct = false;
				// 		}
				// 	}, 300);
				// } else {
				// vm.programViewModel.isSubFrstSct = false;
				// vm.programViewModel.isSubScndSct = false;
				// vm.programViewModel.isSubThrdSct = true;
				// vm.programViewModel.isSubFrthSct = false;
				// if (vm.programViewModel.isThrdTab || vm.programViewModel.isFrthTab) {

				// }
			//수정
			} else if (tab == 4) {
				if (vm.programViewModel.isThrdTab) {
				this.fnGetAfterSchoolPrgmReviewDetail(uidKey);
				}
				// else if (vm.programViewModel.isFrthTab){
				//     this.fnGetAfterSchoolPrgmQnaDetail(uidKey);
				// }
				vm.programViewModel.isSubFrstSct = false;
				vm.programViewModel.isSubScndSct = false;
				vm.programViewModel.isSubThrdSct = false;
				vm.programViewModel.isSubFrthSct = true;
			}
			this.fnChgIsPwCheck();
			this.boardModel.isReportOn = false;
		},
		//마을방과후 하위 탭 변경
		fnChgSubTabByTchr: function(tab, uidKey){
			let vm = this;
			if(tab == 1){
				if(vm.menuViewModel.tab==3){
					let _sggCd = $('#sggCd').val();
					// if(_sggCd == null || _sggCd == ''){
					// 	vm.fnGetAfterSchoolTchrCntBySggList();
					// }
					//vm.fnGetDomainCode();
					vm.fnGetAffiliationCode();
					vm.fnGetAfterSchoolTchrList(1);

				} else if(vm.menuViewModel.tab==4){
					vm.fnGetTeacherBrdList(1);
				}
				vm.scrollToTop();
				vm.teacherViewModel.isSubFrstSct = true;
				vm.teacherViewModel.isSubScndSct = false;
				vm.teacherViewModel.isSubThrdSct = false;
				vm.teacherViewModel.isSubFrthSct = false;
			} else if(tab == 2){
				if(vm.menuViewModel.tab==3){
					vm.fnGetTeacherDetail(1, uidKey);
				} else if(vm.menuViewModel.tab == 4){
					vm.fnGetTeacherBrdDetail(uidKey);
				}
				vm.scrollToTop();
				vm.teacherViewModel.isSubFrstSct = false;
				vm.teacherViewModel.isSubScndSct = true;
				vm.teacherViewModel.isSubThrdSct = false;
				vm.teacherViewModel.isSubFrthSct = false;
			} else if(tab == 3){
				vm.teacherModel.brdDetail = {};
				vm.teacherViewModel.isSubFrstSct = false;
				vm.teacherViewModel.isSubScndSct = false;
				vm.teacherViewModel.isSubThrdSct = true;
				vm.teacherViewModel.isSubFrthSct = false;
			} else if(tab == 4){
				vm.teacherViewModel.isSubFrstSct = false;
				vm.teacherViewModel.isSubScndSct = false;
				vm.teacherViewModel.isSubThrdSct = false;
				vm.teacherViewModel.isSubFrthSct = true;
			}

		},
		//마을공간 하위 탭 변경
		fnChgSubTabBySpc: function(tab, _uidKey){
			let vm = this;
			//목록
			if(tab == 1){
				vm.fnGetSearchBySpace();
				vm.spaceViewModel.isSubFrstSct = true;
				vm.spaceViewModel.isSubScndSct = false;
			//상세
			}else if(tab == 2){
				vm.fnGetAfterSchoolSpaceDetail(1, _uidKey);
				vm.spaceViewModel.isSubFrstSct = false;
				vm.spaceViewModel.isSubScndSct = true;
				setTimeout(() => {
					//마을방과후 - 마을공간 슬라이드
					spaceSlide1();
				}, 500);
			}
		}
		,
		//마을방과후 프로그램 참가여부 체크
		fnGetProgramparticipateYn: function(){
			let vm = this;
			let _uidKey = $('#uidKey').val();
			let _param = {uidKey: _uidKey};
			let param = {param:_param};
			Axios.post("/api/afterschool/program/participate/check", param).then(function(response) {
				vm.programModel.participateCnt = response.data.result;
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//문의 비밀번호 창 초기화
		fnChgIsPwCheck: function() {
			let vm = this;
			if (vm.programModel.qnaList != null && vm.programModel.qnaList.size > 0) {
				let tmp = 0;
				vm.programModel.qnaList.forEach(function(item) {
					vm.programModel.qnaList[tmp].isPwSct = false;
					vm.programModel.qnaList[tmp].inputPw = false;
					tmp++;
				});
				vm.programModel.qnaPw = '';
			}
		},
		//마을방과후 이음 목록/상세
		fnChgCnnctSubSct: function(tab, uidKey, menu) {
			let vm = this;
			vm.boardModel.uidKey = uidKey;
			//목록
			if (tab == 1) {
				vm.boardModel.notice = {};
				vm.boardModel.faq = {};
				vm.boardModel.qna = {};
				vm.boardModel.isReportOn = false;
				vm.boardViewModel.isFrstSct = true;
				vm.boardViewModel.isScndSct = false;
				vm.boardViewModel.isThrdSct = false;
				vm.boardViewModel.isFrthSct = false;
			//상세
			} else if (tab == 2) {
				if (menu == 'notice') {
					this.fnGetNoticeDetail(uidKey);
					setTimeout(() => {
						this.fnGetNoticeReply(1);
					}, 100);
				} else if (menu == 'faq') {
					this.fnGetFaqDetail(uidKey);
				} else if (menu == 'qna') {
					this.fnGetQnaDetail(uidKey);
				}
				vm.boardViewModel.isFrstSct = false;
				vm.boardViewModel.isScndSct = true;
				vm.boardViewModel.isThrdSct = false;
				vm.boardViewModel.isFrthSct = false;
			//글쓰기
			} else if (tab == 3) {
				vm.fnGetSeoulGuCode();
				vm.boardViewModel.isFrstSct = false;
				vm.boardViewModel.isScndSct = false;
				vm.boardViewModel.isThrdSct = true;
				vm.boardViewModel.isFrthSct = false;

				setTimeout(function(){
					$("div#editor-container").parent().attr("tabindex", 500);
				}, 1000);
			//수정
			} else if (tab == 4) {
				vm.fnGetQnaDetail(uidKey);
				vm.boardViewModel.isFrstSct = false;
				vm.boardViewModel.isScndSct = false;
				vm.boardViewModel.isThrdSct = false;
				vm.boardViewModel.isFrthSct = true;

				setTimeout(function(){
					$("div#editor-container").parent().attr("tabindex", 500);
				}, 1000);
			}
			vm.scrollToTop();


		},
		//청소년 모임터 목록 상세
		fnChgMtpcSubSct: function(tab, uidKey) {
			let vm = this;
			if (tab == 1) {
				vm.fnGetGalleryList(1);
				vm.meetingViewModel.isFrstSct = true;
				vm.meetingViewModel.isScndSct = false;
				vm.meetingViewModel.isThrdSct = false;
				vm.meetingViewModel.isFrthSct = false;
			} else if (tab == 2) {
				vm.meetingViewModel.isFrstSct = false;
				vm.meetingViewModel.isScndSct = true;
				vm.meetingViewModel.isThrdSct = false;
				vm.meetingViewModel.isFrthSct = false;
			} else if (tab == 3) {

				location.href = "/customer/afterschool/meetingPlaceInsert";

				// vm.fnGetFileKey();
				// vm.meetingViewModel.isFrstSct = false;
				// vm.meetingViewModel.isScndSct = false;
				// vm.meetingViewModel.isThrdSct = true;
				// vm.meetingViewModel.isFrthSct = false;


			} else if (tab == 4) {
				vm.fnGetGalleryDetail(uidKey);
				vm.fnGetFileKey();
				vm.meetingViewModel.isFrstSct = false;
				vm.meetingViewModel.isScndSct = false;
				vm.meetingViewModel.isThrdSct = false;
				vm.meetingViewModel.isFrthSct = true;
			}
			vm.scrollToTop();
		},
		//마을방과후 프로그램 후기 작성하기
		fnSetProgramReviewChk: function() {
			let vm = this;
			let param = {};
			Axios.post("/api/afterschool/program/detail/review/check", param).then(function(response) {
				let result = response.data.result;
				if (result == 1) {
					vm.fnChgSubSct(3);
				} else {
					swal({
						title      : '',
						text       : '프로그램에 참여해야 작성하실 수 있습니다.',
						icon       : vm.fnOnLoadSwalImageData('warning'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					});
					return false;
				}
			}).catch(function(ex) {
				console.log(ex);
				swal({
					title      : '',
					text       : '후기 작성에 실패 하였습니다.',
					icon       : vm.fnOnLoadSwalImageData('error'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						},
					},
					dangerMode : true
				});
				return false;
			});
		},
		//메뉴링크-방과후지원센터
		onClickAfterSupportCenter() {
			location.href = "/customer/afterschool/supportcenter";
		},
		//메뉴링크-마을방과후 프로그램
		onClickAfterProgram(tab) {
			if (tab != null && tab != '') {
				location.href = "/customer/afterschool/program?tab=" + tab;
			} else {
				location.href = "/customer/afterschool/program";
			}
		},
		//메뉴링크-마을방과후 프로그램 검색
		onClickAfterProgramSearch(tab, sggCd, startDate, endDate) {
			let uri = "/customer/afterschool/program/search?tab=" + tab;
			if (sggCd != null && sggCd != '') {
				uri += "&sggCd=" + sggCd;
			}
			if (startDate != null && startDate != '') {
				uri += "&startDate=" + startDate;
			}
			if (endDate != null && endDate != '') {
				uri += "&endDate=" + endDate;
			}
			location.href = uri;
		},
		//메뉴링크-마을방과후 프로그램 상세
		onClickAfterProgramDetail(uidKey) {
			let vm = this;

      let _tab = 3;
			let uri =
			"/customer/afterschool/program/detail?uidKey=" + uidKey + "&tab=" + _tab;
			location.href = uri;

      let backData =[{
        pageNo : vm.viewModel.pager.pageNo,
        mapInit : vm.mapViewModel.mapInit,
        sggCd : vm.searchModel.sggCd,
        startDate : vm.searchModel.startDate,
        endDate : vm.searchModel.endDate,
        targetCd : vm.searchModel.targetCd,
        affiliationCd : vm.searchModel.affiliationCd,
        keyword : vm.searchModel.keyword,
        ordervalue : vm.searchModel.ordervalue,
        isLatest : vm.orderModel.isLatest,
        isPopularity : vm.orderModel.isPopularity,
      }];
      sessionStorage.setItem('after.program',JSON.stringify(backData));
		}
    // 마을 방과후 프로그램 히스토리 백
    , fnGetAfterProgramSessionStorage() {
      let vm = this;
      let pageNo;
      let mapInit;
      let backData;
      let sggCd;
      let startDate;
      let endDate;
      let targetCd;
      let affiliationCd;
      let keyword;
      let ordervalue;
      let isLatest;
      let isPopularity;

      if (sessionStorage.getItem('after.program') != null){
        console.log("Get Session")

        backData = JSON.parse(sessionStorage.getItem('after.program'));
        sessionStorage.removeItem('after.program');

        mapInit = backData[0].mapInit;
        vm.mapViewModel.mapInit = mapInit;

        sggCd = backData[0].sggCd;
        vm.searchModel.sggCd = sggCd;

        startDate = backData[0].startDate;
        vm.searchModel.startDate = startDate;

        endDate = backData[0].endDate;
        vm.searchModel.endDate = endDate;

        targetCd = backData[0].targetCd;
        vm.searchModel.targetCd = targetCd;

        affiliationCd = backData[0].affiliationCd;
        vm.searchModel.affiliationCd = affiliationCd;

        keyword = backData[0].keyword;
        vm.searchModel.keyword = keyword;

        ordervalue = backData[0].ordervalue;
        vm.searchModel.ordervalue = ordervalue;

        isLatest = backData[0].isLatest;
        vm.orderModel.isLatest = isLatest;

        isPopularity = backData[0].isPopularity;
        vm.orderModel.isPopularity = isPopularity;

        pageNo = backData[0].pageNo;
        vm.viewModel.pager.pageNo = pageNo;

        vm.fnGetAfterSchoolPrgrCntBySggList();
        vm.fnGetAfterSchoolPrgmList(pageNo);



        // setTimeout( () => {
        // }, 1500);
      }
    }

    //진로체험 페이지 이동
		,fnGotoDetailP(uid){
            location.href = "/customer/expinfo/detailExpinfo?uidKey="+uid;
        },
		//메뉴링크-마을방과후 프로그램 신청
		onClickAfterProgramApply(uidKey) {
			let vm = this;
			let _userKey = $("#loginUserKey").val();
			let uri = '';
			if (this.fnIsEmptyChk(_userKey)) {
				swal({
                    title      : '',
                    text       : '로그인이 필요합니다. 로그인 페이지로 이동합니다.',
                    icon       : vm.fnOnLoadSwalImageData('info'),
                    buttons    : true,
                    dangerMode : true
                }).then(result => {
                    if(result){
                        location.href = "/youthnavi/signup/login";
                    }
                });
			} else {
				uri = "/customer/afterschool/program/apply?uidKey=" + uidKey;
			}
			location.href = uri;
		},
		//마을방과후 프로그램 문의 리스트 비밀번호 입력화면 출력
		onClickAfterProgramDetailQnaPw(_uidKey) {
			let vm = this;
			// let val = {uidKey:item.uidKey, isPwSct:false};
			let isOpen = vm.programModel.qnaList.find(obj => obj.uidKey == _uidKey).isPwSct;
			let objIdx = vm.programModel.qnaList.findIndex(
				obj => obj.uidKey == _uidKey
			);
			vm.programModel.qnaList[objIdx].isPwSct = !isOpen;
		},
		//마을방과후 프로그램 문의 리스트 비밀번호 입력
		onClickAfterProgramDetailQnaPwCheck(_uidKey) {
			let vm = this;
			let _password = vm.programModel.qnaList.find(obj => obj.uidKey == _uidKey).password;
			let _inputPw = vm.programModel.qnaList.find(obj => obj.uidKey == _uidKey).inputPw;
			if (_inputPw != _password) {
				swal({
                    title      : '',
                    text       : '비밀번호가 일치하지 않습니다.',
                    icon       : vm.fnOnLoadSwalImageData('warning'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						},
					},
                    dangerMode : true
                });
				return false;
			} else {
				vm.fnChgSubSct(2, _uidKey);
			}
		},
		//마을방과후 프로그램 문의/후기 상세에서 목록으로 이동
		onClickAfterProgramDetailtoList(tab) {
			this.fnGetProgramDetailPage(tab);
			this.programModel.review = {};
			this.programModel.qna = {};
			this.programModel.review.vote = 0;
			this.fnChgIsPwCheck();
		},
		//메뉴링크-마을강사
		onClickAfterTeacher(sggCd) {
			let uri = "/customer/afterschool/teacher" ;
			if (sggCd != null && sggCd != '') {
				uri += "?sggCd=" + sggCd;
			}
			location.href = uri;
		},
		//메뉴링크-마을공간
		onClickAfterSpace(sggCd) {
			let uri = "/customer/afterschool/space";
			if (sggCd != null && sggCd != '') {
				uri += "?sggCd=" + sggCd;
			}
			location.href = uri;
		},
		//메뉴링크-마을방과후 이음
		onClickAfterNotice() {
			location.href = "/customer/afterschool/connect";
		},
		//메뉴링크-청소년 모임터
		onClickAfterMeetingPlace() {
			location.href = "/customer/afterschool/meetingPlace";
		},
		//마을방과후 이음 공지사항 검색어 버튼
		onClickSearchButton() {
			let vm = this;
			if (vm.menuViewModel.isFrstTab) {
				vm.fnGetNoticeList(1);
			} else if (vm.menuViewModel.isScndTab) {
				vm.fnGetFaqList(1);
			} else if (vm.menuViewModel.isThrdTab) {
				vm.fnGetQnaList(1);
			}
		},
		//마을방과후 이음 자주묻는질문 카테고리 버튼
		onClickCategoryButton(code) {
			let vm = this;
			let objIdx = vm.searchModel.faqCdList.findIndex(obj => obj.code == code);
			vm.searchModel.faqCdList.forEach(function(item) {
				item.isClick = false;
			});
			vm.searchModel.faqCdList[objIdx].isClick = true;
			this.searchModel.faqCd = code;
			this.fnGetFaqList(1);
		},

		//에디터 사용
		onEditorChange: function(event) {
			let vm = this;
			// this.viewModel.detail.cmm_cntnt = event.html;
			let _pageName = $('#pageName').val();
			if (_pageName == 'noticeWrite' || _pageName == 'faqWrite'){
				vm.mynaviModel.content = event.html;
			} else if (vm.programViewModel.isThrdTab) {
				vm.programModel.review.contentFirst = event.html;
			} else if (vm.programViewModel.isFrthTab) {
				vm.programModel.qna.content = event.html;
			} else if ( vm.meetingViewModel.isThrdSct || vm.meetingViewModel.isFrthSct) {
				vm.meetingModel.galleryVO.contentFirst = event.html;
			} else if (vm.teacherViewModel.isSubThrdSct || vm.teacherViewModel.isSubFrthSct){
				vm.teacherModel.brdDetail.content = event.html;
			} else if (vm.boardViewModel.isThrdSct || vm.boardViewModel.isFrthSct){
				vm.boardModel.qna.content = event.html;
			}
			vm.$emit("getEditorInfo", event);
		},
		onEditorGalChange: function(event) {
			let vm = this;
			// this.viewModel.detail.cmm_cntnt = event.html;
			vm.meetingModel.galleryVO.contentFirst = event.html;
			vm.$emit("getEditorInfo", event);
		},
		//empty체크
		fnIsEmptyChk: function(val) {
			if ( val === '' || val === null || val === undefined || (val !== null && typeof val === "object" && !Object.keys(val).length)) {
				return true;
			} else {
				return false;
			}
		},

		//참기인원 수 증가
		onClickPlus: function() {
			let vm = this;
			if (vm.applyModel.applyCnt >= 6) {
				vm.applyModel.applyCnt = 6;
			} else {
				vm.applyModel.applyCnt++;
				vm.applyModel.applyUser = {
					name: '',
					age: '',
					sggCd: '',
					schoolCd: '',
					targetCd: '',
					phoneFront: '',
					phoneMiddle: '',
					phoneBack: '',
					programKey: vm.programModel.program.title
				};
				vm.applyModel.applyPrice =
				vm.programModel.program.price * vm.applyModel.applyCnt;
				vm.applyModel.applyUserList.push(vm.applyModel.applyUser);
			}
		},
		//참기인원 수 감소
		onClickMinus: function() {
			let vm = this;
			if (vm.applyModel.applyCnt <= 1) {
				vm.applyModel.applyCnt = 1;
			} else {
				vm.applyModel.applyCnt--;
				vm.applyModel.applyUserList.splice(-1);
			}
			vm.applyModel.applyPrice = vm.programModel.program.price * vm.applyModel.applyCnt;
		},
		//마을방과후 참여자 정보 등록
		fnSetApplyUser: function() {
			let vm = this;
			let _uidKey = $("#uidKey").val();

			//프로그램 신청 정보 준비
			let birthYear = vm.programModel.user.birthday.substr(0,4);
			let _age = parseInt(year) - parseInt(birthYear) + 1;

			let tmp = { name		: vm.programModel.user.name
					  , age			: _age
					  , sggCd		: vm.programModel.user.schoolSggCd
					  , schoolCd	: ''
					  , targetCd	: ''
					  , phoneFront	: ''
					  , phoneMiddle	: ''
					  , phoneBack	: ''
					  , programKey	: vm.programModel.program.uidKey
					  };
			let _param = { applyUserList	: vm.applyModel.applyUserList
						 , roundUidKey		: _uidKey
						 , tPrice			: vm.applyModel.applyPrice
						 , userCnt			: vm.applyModel.applyCnt
						 , isPhoto 			: vm.programModel.program.isPhoto ? "Y" : "N"
						 , isPrivacy		: vm.programModel.program.isPrivacy ? "Y" : "N"
						 };
			let param = {param : _param};
			Axios.post("/api/afterschool/program/apply/create", param).then(function(response) {
				let result = response.data.result;
				if (result == 1) {
					swal({
						title      : '',
						text       : '정상적으로 신청되었습니다.',
						icon       : vm.fnOnLoadSwalImageData('success'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							location.href = "/customer/afterschool/program/apply/success";
						}
					});
				} else {
					swal({
						title      : '',
						text       : '신청에 실패하였습니다.',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					});
					return false;
				}
			}).catch(function(ex) {
				console.log(ex);
				swal({
                    title      : '',
                    text       : '신청에 실패하였습니다.',
                    icon       : vm.fnOnLoadSwalImageData('error'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						},
					},
                    dangerMode : true
                });
				return false;
			});
		},
		//참여자 정보에 신청자 정보 등록
		fnSetParticipantInfo: function(_user) {
			let vm = this;
			vm.applyModel.isInfoInputCheck = !vm.applyModel.isInfoInputCheck;
			let tmp = { name: ''
				  	  , age: ''
					  , sggCd: ''
					  , schoolCd: ''
					  , targetCd: ''
					  , phoneFront: ''
					  , phoneMiddle: ''
					  , phoneBack: ''
				 	  , programKey: vm.programModel.program.uidKey
					  };
			if (vm.applyModel.isInfoInputCheck) {
				let today = new Date();
				let userBirth = _user.birthday;
				let year = today.getFullYear();
				let birthYear = userBirth.substr(0,4);
				let _old = parseInt(year) - parseInt(birthYear) + 1;

				tmp.sggCd = _user.schoolSggCd;
				tmp.schoolCd = _user.schoolCd;
				// if(tmp.sggCd != null && tmp.sggCd != ''){
				// 	this.fnGetLocalCode(tmp.sggCd);
				// }
				if(tmp.schoolCd != null && tmp.schoolCd != ''){
					this.fnGetSchoolCode(tmp.sggCd, tmp.schoolCd);
				}
				tmp.name = _user.name
				tmp.age = _old;
				tmp.targetCd = _user.gradeCd;
				let _phone = _user.cellphone;
				tmp.phoneFront = _phone.substr(0, 3);
				tmp.phoneMiddle = _phone.substr(3, 4);
				tmp.phoneBack = _phone.substr(7, 4);
				vm.applyModel.applyUserList[0] = tmp;
				this.fnGetTargetCode("apply", tmp.schoolCd, tmp.targetCd);
			} else {
				vm.applyModel.applyUserList[0] = tmp;
				vm.selectLocalBoxInApply = '';
				vm.selectSchoolBoxInApply = '';
				vm.selectGradeBoxInApply = '';
			}
		},
		//신청하기 버튼
		onClickApplyBtn: function() {
			let vm = this;
			vm.programViewModel.isApplyBtn = !vm.programViewModel.isApplyBtn;
		},
		//신청내역 클릭
		onClickApplyHistoryBtn: function() {
			let url = "/youthnavi/mypage/user/expinfo/programreg";
			location.href = url;
		},
		//갤러리 목록 조회
		fnGetGalleryList: function(pageNumber) {
			let vm = this;
			vm.viewModel.pager.rowSize = 6;
			vm.viewModel.pager.blockSize = 5;
			vm.viewModel.pager.pageNo = pageNumber;
			let param = { pageNo: vm.viewModel.pager.pageNo
				    , pageSize: vm.viewModel.pager.rowSize
				    };
			Axios.post("/api/afterschool/gallery/select/list", param).then(function(response) {
				vm.meetingModel.galleryList = response.data.paramBrdDtoList;
				vm.meetingModel.galleryListCnt =  response.data.paramListCnt;
				vm.fnSetPager(response.data.paramListCnt,'fnGetGalleryList');
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//갤러리 상세 조회
		fnGetGalleryDetail: function(_uidKey) {
			let vm = this;
			let _param = { uidKey: _uidKey};
			let param = {param:_param};
			Axios.post("/api/afterschool/gallery/select/detail", param).then(function(response) {
				vm.meetingModel.galleryVO = response.data.paramBrdDto;
				vm.fileImgList			  = response.data.fileImgList;
				if(vm.fileImgList.length > 0){
                    vm.fileImgList.forEach(function(file){
                        file.fileUrl = "/img/" + file.file_new_name.substr(0,8) + "/" + file.file_new_name;
                    });
                }
			}).catch(function(ex) {
				console.log(ex);
			});
			if(vm.meetingViewModel.isThrdSct){
				vm.fnChgMtpcSubSct(1);
			} else {
				vm.fnChgMtpcSubSct(2);
			}
		},
		//갤러리 등록 버튼
		fnSetGalleryInsert: function() {
			let vm = this;

			//유효성 체크
			let _IsProgramTitle	= validation.isEmpty(vm.meetingModel.galleryVO.programTitle);
            let _IsTitle        = validation.isEmpty(vm.meetingModel.galleryVO.title);
            let _IsContent      = validation.isEmpty(vm.meetingModel.galleryVO.contentFirst);

			let _param = { programTitle	: vm.meetingModel.galleryVO.programTitle
				     	 , title		: vm.meetingModel.galleryVO.title
				    	 , contentFirst	: vm.meetingModel.galleryVO.contentFirst
						 , fileKey 		: vm.fileKey
				     	 };
			let param = {param : _param};

			if( _IsProgramTitle || _IsTitle || _IsContent){
				let _word = '';
                if(_IsProgramTitle){
                    _word = '프로그래명';
                } else if(_IsTitle){
                    _word = '제목';
                } else if(_IsContent){
                    _word = '내용';
                }

                if( _IsTitle || _IsContent) {
                    swal({
                        text        : _word+'을 입력해주세요.',
                    });
				}
			} else {
				if(vm.meetingModel.galleryVO.programTitle.length > 200){
					swal({
                        title       : '프로그램명 길이 오류',
                        text        : '프로그램명은 200자 이하로 입력해주세요.',
                    });
				} else if(vm.meetingModel.galleryVO.title.length > 200){
					swal({
                        title       : '제목 길이 오류',
                        text        : '제목은 200자 이하로 입력해주세요.',
                    });
				} else {
					Axios.post("/api/afterschool/gallery/write", param).then(function(response) {
						let result = response.data.result;
						if (result >= 1) {
              vm.fnCallImgAltSave();
							swal({
								title      : '',
								text       : '정상적으로 등록되었습니다.',
								icon       : vm.fnOnLoadSwalImageData('success'),
								buttons: {
									cancel: {
										text: "Cancel",
										value: false,
										visible: false,
									},
									confirm: {
										text: "Ok",
										value: true,
										visible: true,
									},
								},
								dangerMode : true
							}).then(result => {
								if(result){
									// vm.fnSetGalleryCancle();
									location.href = "/customer/afterschool/meetingPlace?tab=1"
								}
							});
						} else if(result == -999) {
                            swal({
                                title      : '등록 실패',
                                text       : '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
                                icon       : vm.fnOnLoadSwalImageData('error'),
                                buttons: {
                                    cancel: {
                                        text: "Cancel",
                                        value: false,
                                        visible: false,
                                    },
                                    confirm: {
                                        text: "Ok",
                                        value: true,
                                        visible: true,
                                    },
                                },
                                dangerMode : true
                            }).then(result => {
                                if(result){
                                    return false;
                                }
                            });
                        } else {
							swal({
								title      : '',
								text       : '등록에 실패하였습니다.',
								icon       : vm.fnOnLoadSwalImageData('error'),
								buttons: {
									cancel: {
										text: "Cancel",
										value: false,
										visible: false,
									},
									confirm: {
										text: "Ok",
										value: true,
										visible: true,
									},
								},
								dangerMode : true
							});
							return false;
						}
					}).catch(function(ex) {
						console.log(ex);
						swal({
							title      : '',
							text       : '등록에 실패하였습니다.',
							icon       : vm.fnOnLoadSwalImageData('error'),
							buttons: {
								cancel: {
									text: "Cancel",
									value: false,
									visible: false,
								},
								confirm: {
									text: "Ok",
									value: true,
									visible: true,
								},
							},
							dangerMode : true
						});
						return false;
					});
				}

			}
		},
		//갤러리 수정 버튼
		fnSetGalleryUpdate: function(_uidKey) {
			let vm = this;

			//유효성 체크
			let _IsProgramTitle	= validation.isEmpty(vm.meetingModel.galleryVO.programTitle);
			let _IsTitle        = validation.isEmpty(vm.meetingModel.galleryVO.title);
			let _IsContent      = validation.isEmpty(vm.meetingModel.galleryVO.contentFirst);

			let _param = { programTitle	: vm.meetingModel.galleryVO.programTitle
						, title			: vm.meetingModel.galleryVO.title
						, contentFirst	: vm.meetingModel.galleryVO.contentFirst
						, uidKey		: _uidKey
						, fileKey 		: vm.fileKey
						};
			let param = {param : _param};

			if( _IsProgramTitle || _IsTitle || _IsContent){
				let _word = '';
				if(_IsProgramTitle){
					_word = '프로그래명';
				} else if(_IsTitle){
					_word = '제목';
				} else if(_IsContent){
					_word = '내용';
				}

				if( _IsTitle || _IsContent) {
					swal({
						text        : _word+'을 입력해주세요.',
					});
				}
			} else {
				if(vm.meetingModel.galleryVO.programTitle.length > 200){
					swal({
						title       : '프로그램명 길이 오류',
						text        : '프로그램명은 200자 이하로 입력해주세요.',
					});
				} else if(vm.meetingModel.galleryVO.title.length > 200){
					swal({
						title       : '제목 길이 오류',
						text        : '제목은 200자 이하로 입력해주세요.',
					});
				} else {
					Axios.post("/api/afterschool/gallery/update", param).then(function(response) {
						let result = response.data.result;
						if (result >= 1) {
              vm.fnCallImgAltSave();
							swal({
								title      : '',
								text       : '정상적으로 수정되었습니다.',
								icon       : vm.fnOnLoadSwalImageData('success'),
								buttons: {
									cancel: {
										text: "Cancel",
										value: false,
										visible: false,
									},
									confirm: {
										text: "Ok",
										value: true,
										visible: true,
									},
								},
								dangerMode : true
							}).then(result => {
								if(result){
									vm.fnSetGalleryCancle();
								}
							});
						} else if(result == -999) {
                            swal({
                                title      : '수정 실패',
                                text       : '수정에 실패하였습니다(개인정보 또는 비속어 포함)',
                                icon       : vm.fnOnLoadSwalImageData('error'),
                                buttons: {
                                    cancel: {
                                        text: "Cancel",
                                        value: false,
                                        visible: false,
                                    },
                                    confirm: {
                                        text: "Ok",
                                        value: true,
                                        visible: true,
                                    },
                                },
                                dangerMode : true
                            }).then(result => {
                                if(result){
                                    return false;
                                }
                            });
                        } else {
							swal({
								title      : '',
								text       : '수정에 실패하였습니다.',
								icon       : vm.fnOnLoadSwalImageData('error'),
								buttons: {
									cancel: {
										text: "Cancel",
										value: false,
										visible: false,
									},
									confirm: {
										text: "Ok",
										value: true,
										visible: true,
									},
								},
								dangerMode : true
							});
							return false;
						}
					}).catch(function(ex) {
						console.log(ex);
						swal({
							title      : '',
							text       : '수정에 실패하였습니다.',
							icon       : vm.fnOnLoadSwalImageData('error'),
							buttons: {
								cancel: {
									text: "Cancel",
									value: false,
									visible: false,
								},
								confirm: {
									text: "Ok",
									value: true,
									visible: true,
								},
							},
							dangerMode : true
						});
						return false;
					});
				}
			}
		},
		//갤러리 취소 버튼
		fnSetGalleryCancle: function() {
			let vm = this;
			vm.meetingModel.galleryVO.programTitle = '';
			vm.meetingModel.galleryVO.title = '';
			vm.meetingModel.galleryVO.contentFirst = '';
			vm.fileImgList = [];
			this.fnChgMtpcSubSct(1);
		},
		//명예의전당 조회
		fnGetHallOfFame: function() {
			let vm = this;
			let _year = vm.meetingModel.year;
			let _halfYearly = vm.meetingModel.halfYearly;
			if (_year == '') {
				_year = vm.meetingModel.thisYear;
			} else {
				_year = vm.meetingModel.year;
			}
			if (_halfYearly == '') {
				if (vm.meetingModel.thisMonth < 6) {
					_halfYearly = "상반기";
				} else {
					_halfYearly = "하반기"; }
			} else {
				_halfYearly = vm.meetingModel.halfYearly;
			}
			let _param = { year: _year
				     	 , halfYearly: _halfYearly
				     	 };
			let param = {param:_param};
			Axios.post("/api/afterschool/halloffame/select", param).then(function(response) {
				vm.meetingModel.totalList = response.data.totalList;
			}).catch(function(ex) {
				console.log(ex);
				return false;
			});
		},
		//페이징 처리
		fnSetPager: function(totalCount, etc){
			let vm = this;
			vm.viewModel.pager.etc = etc
			vm.viewModel.pager.totalSize = totalCount;
			vm.viewModel.pager.pageNum = (vm.viewModel.pager.pageNo * vm.viewModel.pager.rowSize) - vm.viewModel.pager.rowSize;
			Pager.props = Pager.methods.createPager(vm.viewModel.pager, vm, "list");
		},
		//지도 바꾸기 - mainPage
		fnOnChangeMap: function() {
			let vm = this;
		 	$("body").load("/customer/afterschool", vm.mapViewModel.map,function() {
				vm.fnChgVal();
				vm.fnOnLoadColorMap();

			});
		},
		//메뉴별 지도 설정 - 각 메뉴 메인페이지
		fnSetMap: function(_pageName){
			let vm = this;
			$("body").load("svg g", function() {
				if (_pageName == 'programMain') {
					vm.mainModel.fndPrgrBySggList.forEach(function(object) {
						let _isClass = $('svg g TEXT tspan'+'#CNT'+object.sggCd)
						_isClass.text('');
						_isClass.append("(" +object.sggCdCnt +")");
						_isClass.css('fill', 'black');
						$('svg g text'+ ' ' +'#CNT'+object.sggCd).val(object.sggCdCnt);
					});
				} else if(_pageName == 'teacherMain'){
					vm.mainModel.fndTchrBySggList.forEach(function(object) {
						let _isClass = $('svg g TEXT tspan'+'#CNT'+object.sggCd)
						_isClass.text('');
						_isClass.append("(" +object.sggCdCnt +")");
						_isClass.css('fill', 'black');
						$('svg g text'+ ' ' +'#CNT'+object.sggCd).val(object.sggCdCnt);
					});
				} else if(_pageName == 'spaceMain'){
					vm.mainModel.fndSpcBySggList.forEach(function(object) {
						let _isClass = $('svg g TEXT tspan'+'#CNT'+object.sggCd)
						_isClass.text('');
						_isClass.append("(" +object.sggCdCnt +")");
						_isClass.css('fill', 'black');
						$('svg g text'+ ' ' +'#CNT'+object.sggCd).val(object.sggCdCnt);
					});
				}
			});
		},
		fnChgVal: function(){
			let vm = this;
			if (vm.selectTypeBoxInMain.code == "searchType2") {
				vm.mainModel.fndTchrBySggList.forEach(function(object) {
					let _isClass = $('svg g TEXT tspan'+'#CNT'+object.sggCd)
					_isClass.text('');
					_isClass.append("(" +object.sggCdCnt +")");
					_isClass.css('fill', 'black');
					$('svg g text'+ ' ' +'#CNT'+object.sggCd).val(object.sggCdCnt);
				});
			} else if (vm.selectTypeBoxInMain.code == "searchType3") {
				vm.mainModel.fndSpcBySggList.forEach(function(object) {
					let _isClass = $('svg g TEXT tspan'+'#CNT'+object.sggCd)
					_isClass.text('');
					_isClass.append("(" +object.sggCdCnt +")");
					_isClass.css('fill', 'black');
					$('svg g text'+ ' ' +'#CNT'+object.sggCd).val(object.sggCdCnt);
				});
			} else {
				vm.mainModel.fndPrgrBySggList.forEach(function(object) {
					let _isClass = $('svg g TEXT tspan'+'#CNT'+object.sggCd)
					_isClass.text('');
					_isClass.append("(" +object.sggCdCnt +")");
					_isClass.css('fill', 'black');
					$('svg g text'+ ' ' +'#CNT'+object.sggCd).val(object.sggCdCnt);
				});
			}
		},
		fnOnLoadColorMap: function() {
			let vm = this;
			if (vm.selectTypeBoxInMain.code == "searchType2") {
				$("svg g path").css("fill", "#ecd5cd");
			} else if (vm.selectTypeBoxInMain.code == "searchType3") {
				$("svg g path").css("fill", "#d1e3e7");
			} else {
				$("svg g path").css("fill", "#eee4c2");
			}
		},
		fnOnLoadColorMapByPrgmPage: function() {
			let vm = this;
      if(vm.mapViewModel.mapInit == 0){
				$("body").load("svg g", function() {
					$("svg g path").css("fill", "#eee4c2");
				});
			} else {
				$("svg path").not("#MAP" + vm.mapViewModel.mapInit).css("fill", "#eee4c2");
				$("#MAP" + vm.mapViewModel.mapInit).css("fill", "#f8cd3f");
			}
		},
		fnOnLoadColorMapByTchrPage: function() {
			let vm = this;
			let _sggCd = vm.mapViewModel.mapInit ? vm.mapViewModel.mapInit : $('#sggCd').val();
			if(_sggCd != null && _sggCd != ''){
				vm.mapViewModel.mapInit = _sggCd;
			}
			if(vm.mapViewModel.mapInit == 0){
				$("body").load("svg g", function() {
					$("svg g path").css("fill", "#ecd5cd");
				});
			} else {
				$("svg path").not("#MAP" + vm.mapViewModel.mapInit).css("fill", "#ecd5cd");
				$("#MAP" + vm.mapViewModel.mapInit).css("fill", "#ee6538");
			}
		},

		// svg 지도 불러오기-초기 지도 화면 셋팅
		fnGetSeoulSvgMap: function() {
			let vm = this;
			let _pageName = $('#pageName').val();
			Axios.get("/design/common/images/seoul_svg.svg").then(function(response) {
				vm.mapViewModel.map = response.data;
				if(_pageName == 'afterMain'){
					vm.fnOnChangeMap();
				} else {
					if(_pageName == 'programMain'){
						vm.fnOnLoadColorMapByPrgmPage();
					} else if(_pageName == 'teacherMain'){
						vm.fnOnLoadColorMapByTchrPage();
					}
					setTimeout(() => {
						vm.fnSetMap(_pageName);
					}, 200);
				}
			}).catch(function(ex) {
				console.log(ex);
			});
			vm.addClickHandler();
		},
		addClickHandler: function() {
			let vm = this;
			let _pageName = $('#pageName').val();
			$("body").off().on("click", "svg path, text", function(evt) {
				let _id = evt.target.id;
				vm.mapViewModel.mapInit = _id.substring(3, 8);
				if ((_pageName == 'afterMain' && vm.searchModel.searchTypeCd == "searchType1") || _pageName == 'programMain') {
					$("svg path").not("#MAP" + vm.mapViewModel.mapInit).css("fill", "#eee4c2");
					$("#MAP" + vm.mapViewModel.mapInit).css("fill", "#f8cd3f");
					vm.searchModel.sggCd = vm.mapViewModel.mapInit;
					if(_pageName == 'programMain'){
						vm.fnGetAfterSchoolPrgmList(1, vm.mapViewModel.mapInit);
					} else {
						vm.onClickAfterProgramSearch(3,vm.mapViewModel.mapInit);
					}
				} else if ((_pageName == 'afterMain' && vm.searchModel.searchTypeCd == "searchType2") || _pageName == 'teacherMain') {
					$("svg path").not("#MAP" + vm.mapViewModel.mapInit).css("fill", "#ecd5cd");
					$("#MAP" + vm.mapViewModel.mapInit).css("fill", "#ee6538");
					vm.searchModel.sggCd = vm.mapViewModel.mapInit;
					if(_pageName == 'teacherMain'){
						vm.fnGetAfterSchoolTchrList(1, vm.mapViewModel.mapInit);
					} else {
						vm.onClickAfterTeacher(vm.mapViewModel.mapInit);
					}
				} else if ((_pageName == 'afterMain' && vm.searchModel.searchTypeCd == "searchType3") || _pageName == 'teacherMain') {
					$("svg path").not("#MAP" + vm.mapViewModel.mapInit).css("fill", "#d1e3e7");
					$("#MAP" + vm.mapViewModel.mapInit).css("fill", "#5ac1da");
					vm.searchModel.sggCd = vm.mapViewModel.mapInit;
					vm.onClickAfterSpace(vm.mapViewModel.mapInit);
				}

			});
		},
		//프로그램 기본값 초기화
		fnChgValInitByPrgm: function(){
			let vm = this;
			vm.searchModel.sggCd 		= '';
			vm.searchModel.domainCd		= '';
			vm.searchModel.targetCd 	= '';
			vm.searchModel.startDate 	= '';
			vm.searchModel.endDate 		= '';
			vm.searchModel.keyword 		= '';
		/* 	vm.viewModel.pager.pageNo 	= 0;
			vm.viewModel.pager.rowSize 	= 0; */
			vm.orderModel.orderValue 	= '1';
			vm.searchModel.dateTypeName = "접수기간";
			vm.searchModel.dateTypeCd 	= "dateType1";
			vm.mapViewModel.mapInit		= 0;
		},
		//날짜데이터 변환
		fnChkDateVal: function(date){
			let _tmpStrDt = '';
			let _tmp = new Date('1970-01-01');
			if(date.getTime() == _tmp.getTime()){
				date = '';
			}

			if(!isNaN(date) && date != '' ){
				let tmpMonth = date.getMonth() + 1;
				let tmpDate = date.getDate();
				if(tmpMonth < 10){
					tmpMonth = '0'+ String(tmpMonth);
				}
				if(tmpDate < 10){
					tmpDate = '0'+ String(tmpDate);
				}
				_tmpStrDt = date.getFullYear()+"-"+tmpMonth+"-"+tmpDate;
			} else {
				_tmpStrDt = null;
			}
			return _tmpStrDt;
		},
		//공지사항 댓글 창 열기
		onClickNoticeReplyWriteOn: function(){
			let vm = this;
			vm.boardViewModel.isReplyWrite = true;
		},
		//공지사항 댓글 창 닫기
		onClickNoticeReplyWriteOff: function(_uidKey){
			let vm = this;
			vm.boardModel.replyContent = '';
			vm.boardViewModel.isReplyWrite = false;
			vm.fnGetNoticeReply(1,_uidKey);
		},
		//공지사항 대댓글 창 열기
		onClickNoticeReReplyWriteOn: function(_uidKey){
			let vm = this;
			vm.boardModel.replyUidKey = _uidKey;
			vm.boardViewModel.isReReplyWrite = true;
		},
		//공지사항 대댓글 창 닫기
		onClickNoticeReReplyWriteOff: function(_uidKey){
			let vm = this;
			vm.boardModel.reReplyContent = '';
			vm.boardModel.replyUidKey = '';
			vm.boardViewModel.isReReplyWrite = false;
			vm.fnGetNoticeReply(1,_uidKey);
		},
		//공지사항 댓글 수정 창 열기
		onClickNoticeReplyUpdateOn: function(object){
			let vm = this;
			vm.boardModel.replyUidKey = object.uidKey;
			vm.boardViewModel.isReplyUpdate = true;
			vm.boardModel.replyContent = object.content;
		},
		//공지사항 댓글 수정 창 닫기
		onClickNoticeReplyUpdateOff: function(_uidKey){
			let vm = this;
			vm.boardModel.replyUidKey = '';
			vm.boardModel.replyContent = '';
			vm.boardViewModel.isReplyUpdate = false;
			vm.fnGetNoticeReply(1,_uidKey);
		},
		//공지사항 대댓글 수정 창 열기
		onClickNoticeReReplyUpdateOn: function(object){
			let vm = this;
			vm.boardModel.replyUidKey = object.uidKey;
			vm.boardViewModel.isReReplyUpdate = true;
			vm.boardModel.replyContent = object.content;
		},
		//공지사항 대댓글 수정 창 닫기
		onClickNoticeReReplyUpdateOff: function(_uidKey){
			let vm = this;
			vm.boardModel.replyUidKey = '';
			vm.boardModel.replyContent = '';
			vm.boardViewModel.isReReplyUpdate = false;
			vm.fnGetNoticeReply(1,_uidKey);
		},
		//공지사항 댓글 남기기
		fnSetNoticeReply: function(_uidKey){
			let vm = this;
			let _param = { contentFirst : vm.boardModel.replyContent
						 , uidKey       : _uidKey
						 , replyDepth   : '0'
						 };
			let param = {param:_param};
			Axios.post("/api/afterschool/notice/reply/write", param).then(function(response) {
				let result = response.data.result;
				if (result >= 1) {
					swal({
						title      : '등록 성공',
						text       : '등록에 성공하였습니다.',
						icon       : vm.fnOnLoadSwalImageData('success'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							vm.onClickNoticeReplyWriteOff();
						}
					});

				} else if(result == -999) {
					swal({
						title      : '등록 실패',
						text       : '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							return false;
						}
					});
				} else {
					swal({
						title      : '등록 실패',
						text       : '등록에 실패하였습니다',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							return false;
						}
					});
				}
			}).catch(function(ex) {
				console.log(ex);
				alert("등록에 실패하였습니다.");
				return false;
			});
		},
		//공지사항 대댓글 남기기
		fnSetNoticeReReply: function(_uidKey, _replyUidKey){
			let vm = this;
			let _param = { contentFirst  : vm.boardModel.reReplyContent
						 , uidKey        : _uidKey
						 , parentsUidKey : _replyUidKey
						 , replyDepth   : '1'
						 };
			let param = {param:_param};
			Axios.post("/api/afterschool/notice/reply/write", param).then(function(response) {
				let result = response.data.result;
				if (result >= 1) {
					swal({
						title      : '등록 성공',
						text       : '등록에 성공하였습니다.',
						icon       : vm.fnOnLoadSwalImageData('success'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							vm.onClickNoticeReReplyWriteOff();
						}
					});

				} else if(result == -999) {
					swal({
						title      : '등록 실패',
						text       : '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							return false;
						}
					});
				} else {
					swal({
						title      : '등록 실패',
						text       : '등록에 실패하였습니다',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							return false;
						}
					});
				}
			}).catch(function(ex) {
				console.log(ex);
				alert("등록에 실패하였습니다.");
				return false;
			});
		},
		//공지사항 댓글 조회
		fnGetNoticeReply: function(pageNumber){
			let vm = this;
			let _uidKey = $('#brdUidKey').val();
			vm.viewModel.pager.rowSize = 15;
			vm.viewModel.pager.blockSize = 5;
			vm.viewModel.pager.pageNo = pageNumber;
			let _param = { uidKey        : _uidKey};
			let param = { param:        _param
						, pageNo:       vm.viewModel.pager.pageNo
						, pageSize:     vm.viewModel.pager.rowSize};
			Axios.post("/api/afterschool/notice/reply/select", param).then(function(response) {
				vm.boardModel.replyDepthZeroList = response.data.replyDepthZeroList;
				vm.boardModel.replyDepthOneList = response.data.replyDepthOneList;
				vm.boardModel.replyListCnt = response.data.paramListCnt;
				vm.fnSetPager(response.data.paramListCnt, "fnGetNoticeReply");
			}).catch(function(ex) {
				console.log(ex);
				return false;
			});
		},
		//공지사항 댓글 수정
		fnSetNoticeReplyUpdate: function(_uidKey,depth){
			let vm = this;
			let _param = { contentFirst : vm.boardModel.replyContent
						 , uidKey       : _uidKey
						 };
			let param = { param:_param}
			Axios.post("/api/afterschool/notice/reply/update", param).then(function(response) {
				let result = response.data.result;
				if (result >= 1) {
					swal({
						title      : '수정 성공',
						text       : '수정에 성공하였습니다.',
						icon       : vm.fnOnLoadSwalImageData('success'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							if(depth == 0){
								vm.onClickNoticeReplyUpdateOff();
							} else if(depth == 1){
								vm.onClickNoticeReReplyUpdateOff();
							}
						}
					});

				} else if(result == -999) {
					swal({
						title      : '수정 실패',
						text       : '수정에 실패하였습니다(개인정보 또는 비속어 포함)',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							return false;
						}
					});
				} else {
					swal({
						title      : '수정 실패',
						text       : '수정에 실패하였습니다',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							return false;
						}
					});
				}
			}).catch(function(ex) {
				console.log(ex);
				alert("수정에 실패하였습니다.");
				return false;
			});
		},
		//공지사항 댓글 삭제
		fnSetNoticeReplydelete: function(_uidKey){
			let vm = this;
			let _param = { contentFirst : vm.boardModel.replyContent
						 , uidKey       : _uidKey
						 };
			let param = { param:_param}
			Axios.post("/api/afterschool/notice/reply/delete", param).then(function(response) {
				let result = response.data.result;
				if (result >= 1) {
					swal({
						title      : '삭제 성공',
						text       : '삭제에 성공하였습니다.',
						icon       : vm.fnOnLoadSwalImageData('success'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							vm.onClickNoticeReplyWriteOff();
						}
					});

				} else {
					swal({
						title      : '삭제 실패',
						text       : '삭제에 실패하였습니다',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							return false;
						}
					});
				}
			}).catch(function(ex) {
				console.log(ex);
				alert("수정에 실패하였습니다.");
				return false;
			});
		},
		//신고 팝업 열기
		OnClickMentoContentsReportOpen: function(_uidKey){
			let vm = this;
			let _userKey = $("#loginUserKey").val();
			let uri = '';
			if (this.fnIsEmptyChk(_userKey)) {
				swal({
                    title      : '',
                    text       : '로그인이 필요합니다. 로그인 페이지로 이동합니다.',
                    icon       : vm.fnOnLoadSwalImageData('info'),
                    buttons    : true,
                    dangerMode : true
                }).then(result => {
                    if(result){
                        location.href = "/youthnavi/signup/login";
                    }
                });
			} else {
				let _param = { uidKey : _uidKey};
				let param = { param:_param}
				Axios.post("/api/afterschool/report/history", param).then(function(response) {
					let result = response.data.result;
					if(result >= 1){
						alert("접수된 신고 이력이 있습니다.");
						return false;
					} else {
						vm.fnGetReportContents();
						vm.boardModel.isReportOn = true;
					}
				}).catch(function(ex) {
					console.log(ex);
					return false;
				});
			}
		},
		//신고 팝업 닫기
		OnClickMentoContentsReportClose: function(){
			let vm = this;
			vm.boardModel.isReportOn       = false;
			vm.boardModel.reportEtcValue   = '';
			vm.boardModel.reportValues     = '';
		},
		//신고 사유 조회
		fnGetReportContents: function(){
			let vm = this;
			let _param = {};
			let param = {param:_param};
			Axios.post("/api/afterschool/report/contents", param).then(function(response) {
				vm.boardModel.reportList = response.data.paramCdDtoList;
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//신고 등록
		fnSetReport: function(_uidKey){
			let vm = this;
			let _reason = vm.boardModel.reportValues;
			let _reasonEtc = '';

			if(_reason == null || _reason.trim() == ''){
				swal({
                    title      : '',
                    text       : '신고사유를 선택해 주세요',
                    icon       : vm.fnOnLoadSwalImageData('warning'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						},
					},
                    dangerMode : true
                });
				return false;
			}

			if(_reason == 'RPTNVYTHNV00400' && vm.boardModel.reportEtcValue.trim().length == 0){
				swal({
                    title      : '',
                    text       : '기타사유를 입력해 주세요',
                    icon       : vm.fnOnLoadSwalImageData('warning'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						},
					},
                    dangerMode : true
                });
				return false;
			} else if(_reason == 'RPTNVYTHNV00400' && vm.boardModel.reportEtcValue.trim().length > 0){
				_reasonEtc = vm.boardModel.reportEtcValue.trim();
			}

			let _param = { brdUidKey:_uidKey
				     , reportKey:_reason
				     , reportEtc:_reasonEtc};
			let param = { param:_param};
			Axios.post("/api/afterschool/group/contents/report", param).then(function(response) {
				let result = response.data.result;
				if(result >= 1){
					alert("정상적으로 등록되었습니다.");
					swal({
                        title      : '신고 완료',
                        text       : '게시물 신고가 완료되었습니다.',
                        icon       : vm.fnOnLoadSwalImageData('success'),
                        buttons: {
                            cancel: {
                                text: "Cancel",
                                value: false,
                                visible: false,
                            },
                            confirm: {
                                text: "Ok",
                                value: true,
                                visible: true,
                            },
                        },
                        dangerMode : true
                    }).then(result => {
                        if(result){
                            vm.OnClickMentoContentsReportClose();
                        }
                    });
				} else if(resultCnt == -999) {
					swal({
						title      : '신고 실패',
						text       : '신고에 실패하였습니다(개인정보 또는 비속어 포함)',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							return false;
						}
					});
				} else {
                    swal({
                        title       : '신고 실패',
                        text        : '게시물 신고가 실패하였습니다.',
                        icon        : this.fnOnLoadSwalImageData('error'),
                        buttons: {
                            cancel: {
                                text: "Cancel",
                                value: false,
                                visible: false,
                            },
                            confirm: {
                                text: "Ok",
                                value: true,
                                visible: true,
                            },
                        },
                        dangerMode  : true,
                    }).then(result => {
                        if(result){
                            return false;
                        }
                    });
                }
			}).catch(function(ex) {
				console.log(ex);
				swal({
					title       : '신고 실패',
					text        : '게시물 신고가 실패하였습니다.',
					icon        : this.fnOnLoadSwalImageData('error'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						},
					},
					dangerMode  : true,
				}).then(result => {
					if(result){
						return false;
					}
				});
			});

		},
		//좋아요 버튼 클릭
		fnChgLikeButton: function(object){

			//로그인 체크
			let _userKey = $("#loginUserKey").val();
			if (this.fnIsEmptyChk(_userKey)) {
				swal({
                    title      : '',
                    text       : '로그인이 필요합니다. 로그인 페이지로 이동합니다.',
                    icon       : vm.fnOnLoadSwalImageData('info'),
                    buttons    : true,
                    dangerMode : true
                }).then(result => {
                    if(result){
                        location.href = "/youthnavi/signup/login";
                    }
                });
			}
			//로그인이 되어 있으면
			object.isLike = !object.isLike;
			let vm = this;
			let _param = { uidKey       : object.uidKey
						, rcmmUidKey    : object.rcmmUidKey
						, isLike        : object.isLike
						};
			let param = {param : _param};
			Axios.post("/api/afterschool/board/like/update", param).then(function(response) {
				let result = response.data.result
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//이메일 코드 가져오기
		fnGetEmailCode: function(){
			let vm = this;
			let _pageName = $('#pageName').val();
			let _param = {};
			let param = {param:_param};
			Axios.post("/api/afterschool/code/email", param).then(function(response) {
				if(response.data.paramCdDtoList != null && response.data.paramCdDtoList.length != 0){
					response.data.paramCdDtoList.forEach(function (item) {
						let val = { code: item.targetCd, value: item.targetTitle };
						vm.searchModel.emailCdList.push(val);
						if (_pageName === "teacherApply" || _pageName === "tchrDetail") {
							if (item.targetCd == vm.teacherModel.emailCd) {
								vm.teacherModel.emailName = item.targetCd;
								vm.selectEmailBoxInTeacherApply = {
									code: item.targetCd,
									value: item.targetTitle
								};
							} else if(vm.teacherModel.emailCd == null){
								vm.selectEmailBoxInTeacherApply = {
									code: '',
									value: vm.teacherModel.emailName
								};
							}
						}
            // else if (_pageName == "tchrDetail") {
						// 	if (item.targetCd == vm.searchModel.emailCd) {
						// 		vm.teacherModel.emailName = item.targetCd;
						// 		vm.selectEmailBoxInTeacherApply = {
						// 			code: item.targetCd,
						// 			value: item.targetTitle
						// 		};
						// 	} else if(vm.searchModel.emailCd == null){
						// 		vm.selectEmailBoxInTeacherApply = {
						// 			code: '',
						// 			value: vm.teacherModel.emailName
						// 		};
						// 	}
						// }
					});
				}
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//마을강사 등록화면
		fnGetTeacherApplyScene: function(){
			//이메일 코드 목록 가져오기
			this.fnGetEmailCode();
			//시군구 코드 가져오기
			this.fnGetSeoulGuCode();
			//영역 코드 목록 가져오기
			//this.fnGetDomainCode();
			//계열 코드 목록 가져오기
			this.fnGetAffiliationCode();
			if(this.menuViewModel.isScndTab){
				this.fnGetUserName();
				this.$refs.dropdoc1.onMaxChange(1);
				this.$refs.dropdoc2.onMaxChange(1);
				this.$refs.dropdoc3.onMaxChange(1);
			}
		},
		//강사 등록
		fnSetTeacherApply: function(){
			let vm = this;
			let _fileKey = $('#fileKey').val();

			let _phoneOpenYn = 	(vm.teacherModel.phoneEduOrgYn ? "Y" : "N") +'|' +
								(vm.teacherModel.phoneGovOrgYn ? "Y" : "N") +'|' +
								(vm.teacherModel.phoneParentsYn ? "Y" : "N");
			let _emailOpenYn = 	(vm.teacherModel.emailEduOrgYn ? "Y" : "N") +'|' +
								(vm.teacherModel.emailGovOrgYn ? "Y" : "N") +'|' +
								(vm.teacherModel.emailParentsYn ? "Y" : "N");

			//유효성체크
			let _IsGender			= validation.isEmpty(vm.teacherModel.gender);
			let _IsPhonNum			= validation.isEmpty(vm.teacherModel.phone);
			let _IsEmailId			= validation.isEmpty(vm.teacherModel.emailId);
			let _IsEmailAddr		= false;
			if(vm.teacherModel.emailCd == ''){
				_IsEmailAddr		= validation.isEmpty(vm.teacherModel.emailAddrEtc);
			}
			let _IsAffiliationCd	= validation.isEmpty(vm.searchModel.affiliationCd);
			let _IsSggCd			= validation.isEmpty(vm.searchModel.sggCd);
			let _IsEduContent		= validation.isEmpty(vm.teacherModel.eduContent);
			let _IsActive			= validation.isEmpty(vm.teacherModel.currentActive);

			let _IsUploadPlanFile 	= vm.$refs.dropdoc1.cnt == 1 ? false : true;
			let _IsUploadEtcFile	= vm.$refs.dropdoc2.cnt == 1 ? false : true;
			let _IsUploadApplicationFile	= vm.$refs.dropdoc3.cnt == 1 ? false : true;

			let _word = '';
			let _resultInput 	= false;
			let _resultChoice 	= false;
			let _comment		= '';
			if(_IsGender){
				_word = '성별';
				_resultChoice 	= true;
			} else if(_IsPhonNum){
				_word = '연락처';
				_resultInput 	= true;
			} else if(_IsEmailId){
				_word = '이메일 계정';
				_resultInput 	= true;
			} else if(_IsEmailAddr){
				_word = '이메일 주소';
				_resultInput 	= true;
			} else if(_IsAffiliationCd){
				_word = '계열';
				_resultChoice 	= true;
			} else if(_IsSggCd){
				_word = '주요활동지역';
				_resultChoice 	= true;
			} else if(_IsEduContent){
				_word = '교육내용';
				_resultInput 	= true;
			} else if(_IsActive){
				_word = '현재 활동여부';
				_resultChoice 	= true;
			} else if(_IsUploadPlanFile){
				_word = '프로그램 운영계획(안)';
				_comment = '프로그램 운영계획(안) 파일을 업로드하지 않았습니다.';
			} else if(_IsUploadApplicationFile){
				_word = '마을강사 신청양식';
				_comment = '마을강사 신청양식 파일을 업로드하지 않았습니다.';
			} else if(_IsUploadEtcFile){
				_word = '기타 파일';
				_comment = '프로그램 운영계획(안) 이외 파일을 업로드하지 않았습니다.';
			}

			if (_resultChoice){
				swal({
					title       : _word+' 미선택',
					text        : _word+'을/를 선택해주세요.',
					icon        : this.fnOnLoadSwalImageData('error'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						}
					},
					dangerMode  : true,
				});
				return false;
			} else if( _resultInput) {
				swal({
					title       : _word+' 미입력',
					text        : _word+'을/를 입력해주세요.',
					icon        : this.fnOnLoadSwalImageData('error'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						}
					},
					dangerMode  : true,
				});
				return false;

			} else if( _IsUploadPlanFile || _IsUploadEtcFile || _IsUploadApplicationFile) {
				swal({
					title       : _word+' 오류',
					text        : _comment,
					icon        : this.fnOnLoadSwalImageData('error'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						}
					},
					dangerMode  : true,
				});
				return false;
			} else {
				let _param = { name 		 : vm.teacherModel.name
							 , gender 		 : vm.teacherModel.gender
							 , phone 		 : vm.teacherModel.phone
							 , email 		 : vm.teacherModel.emailId
							 , emailCd		 : vm.teacherModel.emailCd
							 , emailEtc		 : vm.teacherModel.emailCd == '' ? vm.teacherModel.emailAddrEtc : null
							 , phoneOpenYn 	 : _phoneOpenYn
							 , emailOpenYn 	 : _emailOpenYn
							 , sggCd		 : vm.searchModel.sggCd
							 , areas		 : vm.teacherModel.areas
							 , eduContent 	 : vm.teacherModel.eduContent
							 , currentActive : vm.teacherModel.currentActive
							 , affiliationCd : vm.searchModel.affiliationCd
							 , fileKey       : _fileKey
							 };
				let param = {param:_param};

				Axios.post("/api/afterschool/teacher/create", param).then(function(response) {
					let result = response.data.result;
					let _userKey = response.data.userKey;
					if (result >= 1) {
						swal({
							title      : '',
							text       : '정상적으로 등록되었습니다. \n관리자의 승인 후 등록이 완료됩니다.',
							icon       : vm.fnOnLoadSwalImageData('success'),
							buttons: {
								cancel: {
									text: "Cancel",
									value: false,
									visible: false,
								},
								confirm: {
									text: "Ok",
									value: true,
									visible: true,
								},
							},
							dangerMode : true
						}).then(result => {
							if(result){
								vm.fnOnClickUpdate(_userKey);
								vm.fnChgTab(1);
								vm.fnChgValInitByTchr();
							}
						});
					} else if(result == -999) {
						swal({
							title      : '등록 실패',
							text       : '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
							icon       : vm.fnOnLoadSwalImageData('error'),
							buttons: {
								cancel: {
									text: "Cancel",
									value: false,
									visible: false,
								},
								confirm: {
									text: "Ok",
									value: true,
									visible: true,
								},
							},
							dangerMode : true
						}).then(result => {
							if(result){
								return false;
							}
						});
					} else {
						swal({
							title      : '',
							text       : '등록에 실패하였습니다.',
							icon       : vm.fnOnLoadSwalImageData('warning'),
							buttons: {
								cancel: {
									text: "Cancel",
									value: false,
									visible: false,
								},
								confirm: {
									text: "Ok",
									value: true,
									visible: true,
								},
							},
							dangerMode : true
						});
						return false;
					}
				}).catch(function(ex) {
					console.log(ex);
				});
			}
		},
		//강사 수정
		fnSetTeacherApplyUpdate: function(){
			let vm = this;
			let _fileKey = $('#fileKey').val();
			let _phoneOpenYn = 	(vm.teacherModel.phoneEduOrgYn ? "Y" : "N") +'|' +
								(vm.teacherModel.phoneGovOrgYn ? "Y" : "N") +'|' +
								(vm.teacherModel.phoneParentsYn ? "Y" : "N");
			let _emailOpenYn = 	(vm.teacherModel.emailEduOrgYn ? "Y" : "N") +'|' +
								(vm.teacherModel.emailGovOrgYn ? "Y" : "N") +'|' +
								(vm.teacherModel.emailParentsYn ? "Y" : "N");
			//유효성체크
			let _IsGender			= validation.isEmpty(vm.teacherModel.gender);
			let _IsPhonNum			= validation.isEmpty(vm.teacherModel.phone);
			let _IsEmailId			= validation.isEmpty(vm.teacherModel.emailId);
			let _IsEmailAddr		= false;
			if(vm.teacherModel.emailCd == ''){
				_IsEmailAddr		= validation.isEmpty(vm.teacherModel.emailAddrEtc);
			}
			let _IsAffiliationCd	= validation.isEmpty(vm.searchModel.affiliationCd);
			let _IsSggCd			= validation.isEmpty(vm.searchModel.sggCd);
			let _IsEduContent		= validation.isEmpty(vm.teacherModel.eduContent);
			let _IsActive			= validation.isEmpty(vm.teacherModel.currentActive);

			let _IsUploadPlanFile 	= vm.$refs.dropdoc1.cnt == 1 ? false : true;
			let _IsUploadEtcFile	= vm.$refs.dropdoc2.cnt == 1 ? false : true;
      let _IsUploadApplicationFile	= vm.$refs.dropdoc3.cnt == 1 ? false : true;

			let _word = '';
			let _resultInput 	= false;
			let _resultChoice 	= false;
			let _comment		= '';
			if(_IsGender){
				_word = '성별';
				_resultChoice 	= true;
			} else if(_IsPhonNum){
				_word = '연락처';
				_resultInput 	= true;
			} else if(_IsEmailId){
				_word = '이메일 계정';
				_resultInput 	= true;
			} else if(_IsEmailAddr){
				_word = '이메일 주소';
				_resultInput 	= true;
			} else if(_IsAffiliationCd){
				_word = '계열';
				_resultChoice 	= true;
			} else if(_IsSggCd){
				_word = '주요활동지역';
				_resultChoice 	= true;
			} else if(_IsEduContent){
				_word = '교육내용';
				_resultInput 	= true;
			} else if(_IsActive){
				_word = '현재 활동여부';
				_resultChoice 	= true;
			} else if(_IsUploadPlanFile){
				_word = '프로그램 운영계획(안)';
				_comment = '프로그램 운영계획(안) 파일을 업로드하지 않았습니다.';
			} else if(_IsUploadApplicationFile){
				_word = '마을강사 신청양식';
				_comment = '마을강사 신청양식 파일을 업로드하지 않았습니다.';
			} else if(_IsUploadEtcFile){
				_word = '기타 파일';
				_comment = '프로그램 운영계획(안) 이외 파일을 업로드하지 않았습니다.';
			}

			if (_resultChoice){
				swal({
					title       : _word+' 미선택',
					text        : _word+'을/를 선택해주세요.',
					icon        : this.fnOnLoadSwalImageData('error'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						}
					},
					dangerMode  : true,
				});
				return false;
			} else if( _resultInput) {
				swal({
					title       : _word+' 미입력',
					text        : _word+'을/를 입력해주세요.',
					icon        : this.fnOnLoadSwalImageData('error'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						}
					},
					dangerMode  : true,
				});
				return false;

			} else if( _IsUploadPlanFile || _IsUploadEtcFile || _IsUploadApplicationFile) {
				swal({
					title       : _word+' 오류',
					text        : _comment,
					icon        : this.fnOnLoadSwalImageData('error'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						}
					},
					dangerMode  : true,
				});
				return false;
			} else {

				let _param = { name : 			vm.teacherModel.name
							 , gender : 		vm.teacherModel.gender
							 , phone : 			vm.teacherModel.phone
							 , email : 			vm.teacherModel.emailId
							 , emailCd:			vm.teacherModel.emailCd
							 , emailAddrEtc : 	vm.teacherModel.emailCd == '' ? vm.teacherModel.emailAddrEtc : null
							 , phoneOpenYn : 	_phoneOpenYn
							 , emailOpenYn : 	_emailOpenYn
							 , sggCd: 			vm.searchModel.sggCd
							 , areas:			vm.teacherModel.areas
							 , eduContent : 	vm.teacherModel.eduContent
							 , currentActive : 	vm.teacherModel.currentActive
							 , affiliationCd : vm.searchModel.affiliationCd
							 , fileKey      : _fileKey
							 , uidKey:			vm.teacherModel.uidKey
							 };
				let param = {param:_param};

				Axios.post("/api/afterschool/teacher/update", param).then(function(response) {
					let result = response.data.result;
					if (result >= 1) {
						swal({
							title      : '',
							text       : '정상적으로 수정되었습니다. \n추후 관리자의 승인 후 등록이 완료됩니다.',
							icon       : vm.fnOnLoadSwalImageData('success'),
							buttons: {
								cancel: {
									text: "Cancel",
									value: false,
									visible: false,
								},
								confirm: {
									text: "Ok",
									value: true,
									visible: true,
								},
							},
							dangerMode : true
						}).then(result => {
							if(result){
								location.reload();
							}
						});
					} else if(resultCnt == -999) {
						swal({
							title      : '수정 실패',
							text       : '수정에 실패하였습니다(개인정보 또는 비속어 포함)',
							icon       : vm.fnOnLoadSwalImageData('error'),
							buttons: {
								cancel: {
									text: "Cancel",
									value: false,
									visible: false,
								},
								confirm: {
									text: "Ok",
									value: true,
									visible: true,
								},
							},
							dangerMode : true
						}).then(result => {
							if(result){
								return false;
							}
						});
					} else {
						swal({
							title      : '',
							text       : '수정에 실패하였습니다.',
							icon       : vm.fnOnLoadSwalImageData('warning'),
							buttons: {
								cancel: {
									text: "Cancel",
									value: false,
									visible: false,
								},
								confirm: {
									text: "Ok",
									value: true,
									visible: true,
								},
							},
							dangerMode : true
						});
						return false;
					}
				}).catch(function(ex) {
					console.log(ex);
				});
			}
		},

		//강사등록 신청여부 체크
		fnChkTeacherApply: function(){
			let vm = this;
			let _param = {};
			let param = { param:_param};
			let pageName = $('#pageName').val();

			Axios.post("/api/afterschool/teacher/apply/select", param).then(function(response) {
				vm.teacherModel.applyCheck = response.data.result;
				if(pageName == 'teacherMain'){
					if(vm.teacherModel.applyCheck > 0){
						swal({
							title      : '',
							text       : '신청한 이력이 있습니다.',
							icon       : vm.fnOnLoadSwalImageData('warning'),
							buttons: {
								cancel: {
									text: "Cancel",
									value: false,
									visible: false,
								},
								confirm: {
									text: "Ok",
									value: true,
									visible: true,
								},
							},
							dangerMode : true
						});
						return false;
					}
				}
			}).catch(function(ex) {
				console.log(ex);
			});
		},

		//마을강사 소통방 목록 조회
		fnGetTeacherBrdList: function(pageNumber){
			let vm = this;
			vm.viewModel.pager.rowSize = 4;
			vm.viewModel.pager.blockSize = 5;
			vm.viewModel.pager.pageNo = pageNumber;
			let _param = {keyword : vm.teacherModel.keyword};
			let param = { param:_param
						, pageNo: vm.viewModel.pager.pageNo
						, pageSize: vm.viewModel.pager.rowSize
						};
			Axios.post("/api/afterschool/teacher/brd/list/select", param).then(function(response) {
				vm.teacherModel.brdList = response.data.paramBrdDtoList;
				vm.teacherModel.brdListCnt = response.data.paramListCnt;
				vm.fnSetPager(vm.teacherModel.brdListCnt, 'fnGetTeacherBrdList');
			}).catch(function(ex) {
				console.log(ex);
			});
		},

		//마을강사 소통방 상세 조회
		fnGetTeacherBrdDetail: function(_uidKey){
			let vm = this;
			let _param = {uidKey:_uidKey};
			let param = { param:_param};
			Axios.post("/api/afterschool/teacher/brd/detail/select", param).then(function(response) {
				vm.teacherModel.brdDetail = response.data.paramBrdDto;
			}).catch(function(ex) {
				console.log(ex);
			});
			vm.fnGetTeacherBrdDetailReply(1, _uidKey);
		},
		//마을강사 소통방 상세 댓글 조회
		fnGetTeacherBrdDetailReply: function(pageNumber, _uidKey){
			let vm = this;
			// vm.viewModel.pager.rowSize = 15;
			// vm.viewModel.pager.blockSize = 5;
			// vm.viewModel.pager.pageNo = pageNumber;
			let _param = { uidKey: _uidKey};
			let param = { param:        _param
						// , pageNo:       vm.viewModel.pager.pageNo
						// , pageSize:     vm.viewModel.pager.rowSize
						};
			Axios.post("/api/afterschool/teacher/reply/select", param).then(function(response) {
				vm.teacherModel.replyDepthZeroList = response.data.replyDepthZeroList;
				vm.teacherModel.replyDepthOneList = response.data.replyDepthOneList;
				vm.teacherModel.replyListCnt = response.data.paramListCnt;
				// vm.fnSetPager(response.data.paramListCnt, "fnGetTeacherBrdDetailReply");
			}).catch(function(ex) {
				console.log(ex);
				return false;
			});
		},
		//마을강사 소통방 상세 댓글 창 열기
		onClickTeacherBrdReplyWriteOn: function(){
			let vm = this;
			vm.teacherViewModel.isReplyWrite = true;
		},
		//마을강사 소통방 상세 댓글 창 닫기
		onClickTeacherBrdReplyWriteOff: function(_uidKey){
			let vm = this;
			vm.teacherModel.replyContent = '';
			vm.teacherViewModel.isReplyWrite = false;
			vm.fnGetTeacherBrdDetailReply(1,_uidKey);
		},
		//마을강사 소통방 상세 대댓글 창 열기
		onClickTeacherBrdReReplyWriteOn: function(_uidKey){
			let vm = this;
			vm.teacherModel.replyUidKey = _uidKey;
			vm.teacherViewModel.isReReplyWrite = true;
		},
		//마을강사 소통방 상세 대댓글 창 닫기
		onClickTeacherBrdReReplyWriteOff: function(_uidKey){
			let vm = this;
			vm.teacherModel.reReplyContent = '';
			vm.teacherModel.replyUidKey = '';
			vm.teacherViewModel.isReReplyWrite = false;
			vm.fnGetTeacherBrdDetailReply(1,_uidKey);
		},
		//마을강사 소통방 상세 댓글 수정 창 열기
		onClickTeacherBrdReplyUpdateOn: function(object){
			let vm = this;
			vm.teacherModel.replyUidKey = object.uidKey;
			vm.teacherViewModel.isReplyUpdate = true;
			vm.teacherModel.replyContent = object.content;
		},
		//마을강사 소통방 상세 대댓글 수정 창 닫기
		onClickTeacherBrdReplyUpdateOff: function(_brdUidKey){
			let vm = this;
			vm.teacherModel.replyUidKey = '';
			vm.teacherModel.replyContent = '';
			vm.teacherViewModel.isReplyUpdate = false;
			vm.fnGetTeacherBrdDetailReply(1,_brdUidKey);
		},
		//마을강사 소통방 상세 대댓글 수정 창 열기
		onClickTeacherBrdReReplyUpdateOn: function(object){
			let vm = this;
			vm.teacherModel.replyUidKey = object.uidKey;
			vm.teacherViewModel.isReReplyUpdate = true;
			vm.teacherModel.replyContent = object.content;
		},
		//마을강사 소통방 상세 대댓글 수정 창 닫기
		onClickTeacherBrdReReplyUpdateOff: function(_uidKey){
			let vm = this;
			vm.teacherModel.replyUidKey = '';
			vm.teacherModel.replyContent = '';
			vm.teacherViewModel.isReReplyUpdate = false;
			vm.fnGetTeacherBrdDetailReply(1,_uidKey);
		},
		//마을방과후 소통방 상세 댓글 수정
		fnSetTeacherBrdReplyUpdate: function(_uidKey, _brdUidKey){
			let vm = this;
			let _param = { contentFirst : vm.teacherModel.replyContent
						 , uidKey       : _uidKey
						 };
			let param = { param:_param}
			Axios.post("/api/afterschool/teacher/reply/update", param).then(function(response) {
				let result = response.data.result;
				if(result > 0){
					swal({
						title      : '수정 성공',
						text       : '수정에 성공하였습니다.',
						icon       : vm.fnOnLoadSwalImageData('success'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							vm.fnChgValInitBySpc();
							vm.fnChgTab(2,true);
							// location.reload();
						}
					});
				} else if(resultCnt == -999) {
					swal({
						title      : '수정 실패',
						text       : '수정에 실패하였습니다(개인정보 또는 비속어 포함)',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							return false;
						}
					});
				} else {
					swal({
						title      : '수정 실패',
						text       : '수정에 실패하였습니다.',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							return false;
						}
					});
				}
			}).catch(function(ex) {
				console.log(ex);
					swal({
						title      : '수정 실패',
						text       : '수정에 실패하였습니다.',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							return false;
						}
					});
			});
		},
		//마을방과후 소통방 상세 댓글 삭제
		fnSetTeacherBrdReplydelete: function(_uidKey, _brdUidKey){
			let vm = this;
			let _param = { uidKey       : _uidKey};
			let param = { param:_param}
			Axios.post("/api/afterschool/teacher/reply/delete", param).then(function(response) {
				let result = response.data.result;
				if (result >= 1) {
					alert("정상적으로 삭제되었습니다.");
					vm.onClickTeacherBrdReplyUpdateOff(_brdUidKey);
				} else {
					alert("수정에 삭제하였습니다.");
					return false;
				}
			}).catch(function(ex) {
				console.log(ex);
				alert("수정에 실패하였습니다.");
				return false;
			});
		},
		//마을방과후 소통방 상세 대댓글 남기기
		fnSetTeacherBrdReReply: function(_uidKey, _replyUidKey){
			let vm = this;
			let _param = { contentFirst  	: vm.teacherModel.reReplyContent
						 , uidKey        : _uidKey
						 , parentsUidKey 	: _replyUidKey
						 , replyDepth   	: '1'
						 };
			let param = {param:_param};
			Axios.post("/api/afterschool/teacher/reply/write", param).then(function(response) {
				let result = response.data.result;
				if (result >= 1) {
					alert("정상적으로 등록되었습니다.");
					vm.onClickTeacherBrdReReplyWriteOff(_uidKey);
				} else {
					alert("등록에 실패하였습니다.");
					return false;
				}
			}).catch(function(ex) {
				console.log(ex);
				alert("등록에 실패하였습니다.");
				return false;
			});
		},
		//마을방과후 소통방 상세 댓글 등록
		fnSetTeacherBrdReply: function(_uidKey){
			let vm = this;
			let _param = { contentFirst : vm.teacherModel.replyContent
						 , uidKey    : _uidKey
						 , replyDepth   : '0'
						 };
			let param = {param:_param};
			Axios.post("/api/afterschool/teacher/reply/write", param).then(function(response) {
				let result = response.data.result;
				if(result > 0){
					swal({
						title      : '등록 성공',
						text       : '등록에 성공하였습니다.',
						icon       : vm.fnOnLoadSwalImageData('success'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							vm.fnChgValInitBySpc();
							vm.fnChgTab(2,true);
							// location.reload();
						}
					});
				} else if(resultCnt == -999) {
					swal({
						title      : '등록 실패',
						text       : '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							return false;
						}
					});
				} else {
					swal({
						title      : '등록',
						text       : '등록에 실패하였습니다.',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							return false;
						}
					});
				}
			}).catch(function(ex) {
				console.log(ex);
				swal({
					title      : '등록',
					text       : '등록에 실패하였습니다.',
					icon       : vm.fnOnLoadSwalImageData('error'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						},
					},
					dangerMode : true
				}).then(result => {
					if(result){
						return false;
					}
				});
			});
		},
		//글쓰기 버튼 클릭
		onClickTeacherBrdWrite: function(){
			let vm = this;
			let _userKey = $("#loginUserKey").val();
			if (this.fnIsEmptyChk(_userKey)) {
				swal({
                    title      : '',
                    text       : '로그인이 필요합니다. 로그인 페이지로 이동합니다.',
                    icon       : vm.fnOnLoadSwalImageData('info'),
                    buttons    : true,
                    dangerMode : true
                }).then(result => {
                    if(result){
                        location.href = "/youthnavi/signup/login";
                    }
                });
			} else {
				this.fnChgSubTabByTchr(3);
			}
		},
		//마을방과후 소통방 글쓰기
		fnSetTechaerBrdWrite: function(){
			let vm = this;
			let _param = { title		: vm.teacherModel.brdDetail.title
						 , contentFirst	: vm.teacherModel.brdDetail.content
						 };
			let param = {param:_param};
			Axios.post("/api/afterschool/teacher/brd/write", param).then(function(response) {
				let result = response.data.result;
				if (result >= 1) {
					swal({
						title      : '',
						text       : '정상적으로 등록되었습니다.',
						icon       : vm.fnOnLoadSwalImageData('success'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							vm.fnChgTab(4);
						}
					});
				} else if(resultCnt == -999) {
					swal({
						title      : '등록 실패',
						text       : '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							return false;
						}
					});
				} else {
					swal({
						title      : '',
						text       : '등록에 실패하였습니다.',
						icon       : vm.fnOnLoadSwalImageData('warning'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					});
					return false;
				}
			}).catch(function(ex) {
				console.log(ex);
				swal({
					title      : '',
					text       : '등록에 실패하였습니다.',
					icon       : vm.fnOnLoadSwalImageData('warning'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						},
					},
					dangerMode : true
				});
				return false;
			});
		},
		//마을방과후 소통방 글 수정화면
		onClickTeacherBrdUpdate: function(object){
			let vm = this;
			vm.teacherModel.brdDetail.title = object.title;
			vm.teacherModel.brdDetail.content = object.contentFirst;
			vm.teacherModel.brdDetail.uidKey = object.uidKey;
			vm.fnChgSubTabByTchr(4);
		},
		//마을방과후 소통방 글쓰기
		fnSetTechaerBrdUpdate: function(){
			let vm = this;
			let _param = { title		: vm.teacherModel.brdDetail.title
						 , contentFirst	: vm.teacherModel.brdDetail.content
						 , uidKey		: vm.teacherModel.brdDetail.uidKey
						 };
			let param = {param:_param};
			Axios.post("/api/afterschool/teacher/brd/update", param).then(function(response) {
				let result = response.data.result;
				if (result >= 1) {
					swal({
						title      : '수정 성공',
						text       : '정상적으로 수정되었습니다.',
						icon       : vm.fnOnLoadSwalImageData('info'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							vm.fnChgTab(4);
						}
					});

				} else if(resultCnt == -999) {
					swal({
						title      : '수정 실패',
						text       : '수정에 실패하였습니다(개인정보 또는 비속어 포함)',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							return false;
						}
					});
				} else {
					swal({
						title      : '수정 실패',
						text       : '수정에 실패하였습니다.',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					});
					return false;
				}
			}).catch(function(ex) {
				console.log(ex);
				swal({
                    title      : '수정 실패',
                    text       : '수정에 실패하였습니다.',
                    icon       : vm.fnOnLoadSwalImageData('error'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						},
					},
                    dangerMode : true
                });
				return false;
			});
		},
		//마을방과후 소통방 글 삭제
		onClickTeacherBrdDelete: function(_uidKey){
			let vm = this;
			let _param = { uidKey		: _uidKey };
			let param = {param:_param};
			Axios.post("/api/afterschool/teacher/brd/delete", param).then(function(response) {
				let result = response.data.result;
				if (result >= 1) {
					swal({
						title      : '',
						text       : '정상적으로 삭제되었습니다.',
						icon       : vm.fnOnLoadSwalImageData('info'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							vm.fnChgTab(4);
						}
					});
				} else {
					swal({
						title      : '',
						text       : '삭제에 실패하였습니다.',
						icon       : vm.fnOnLoadSwalImageData('warning'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					});
					return false;
				}
			}).catch(function(ex) {
				console.log(ex);
				swal({
                    title      : '',
                    text       : '삭제에 실패하였습니다.',
                    icon       : vm.fnOnLoadSwalImageData('warning'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						},
					},
                    dangerMode : true
                });
				return false;
			});
		},
		//마을강사 상세 페이지
		fnGetTeacherDetail: function(pageNumber, _uidKey){
			let vm = this;
			vm.viewModel.pager.rowSize = 6;
			vm.viewModel.pager.blockSize = 5;
			vm.viewModel.pager.pageNo = pageNumber;
			let _param = { uidKey: _uidKey};
			let param = { param:        _param
						, pageNo:       vm.viewModel.pager.pageNo
						, pageSize:     vm.viewModel.pager.rowSize
						};
			Axios.post("/api/afterschool/teacher/detail", param).then(function(response) {
				vm.teacherModel.teacherDto = response.data.paramUsrDto;
				vm.filePlanList = response.data.filePlanList;
				vm.fileImgList = response.data.fileImgList;

				// response.data.paramPrgmDtoList.forEach(function (object) {
				// 	if(object.zzimYn == 'Y'){
				// 		object.isZzim = true;
				// 	} else {
				// 		object.isZzim = false;
				// 	}
				// 	let today = new Date();
				// 	let startDate = object.acceptStartDate;
				// 	let endDate = object.acceptEndDate;
				// 	if(startDate >= today){
				// 		if(endDate > today){
				// 			object.status = 'finish';
				// 		} else {
				// 			object.status = 'ing';
				// 		}
				// 	} else {
				// 		object.status = 'before';
				// 	}

				// 	vm.programModel.programList.push(object);
				// });
				vm.fnSetPager(response.data.paramListCnt, 'fnGetTeacherDetail');
			}).catch(function(ex) {
				console.log(ex);
				return false;
			});
		},
		//마을공간 등록화면 구성
		fnGetSpaceApply: function(){
			let vm = this;
			//시군구코드 가져오기
			vm.fnGetLocalCode();
			//이메일코드 가져오기
			vm.fnGetEmailCode();
			//공간코드 가져오기
			vm.fnGetFacilityCodeByMajor();
		},
		//대분류 공간코드 조회
		fnGetFacilityCodeByMajor: function(){
			let vm = this;
			let _param = {};
			let param = {param : _param};
			Axios.post("/api/afterschool/code/facility/major", param).then(function(response) {
				if(response.data.paramCdDtoList != null && response.data.paramCdDtoList.length != 0){
					response.data.paramCdDtoList.forEach(function (item) {
						let val = { code: item.targetCd, value: item.targetTitle };
						vm.searchModel.facilityMajorCdList.push(val);
					});
				}
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//중분류공간코드 조회
		fnGetFacilityCodeByMedium: function(facilityMjCd){
			let vm = this;
			let _param = {subCode:facilityMjCd};
			let param = {param : _param};
			Axios.post("/api/afterschool/code/facility/medium", param).then(function(response) {
				if(response.data.paramCdDtoList != null && response.data.paramCdDtoList.length != 0){
					vm.searchModel.facilityMediumCdList = [];
					response.data.paramCdDtoList.forEach(function (item) {
						let val = { code: item.targetCd, value: item.targetTitle };
						vm.searchModel.facilityMediumCdList.push(val);
					});
				}
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//공간코드 기타 값 초기화
		fnInitEtcValue: function(facilityMdCd){
			if(facilityMdCd != 'FCTNVADMNV01016' ||  facilityMdCd != 'FCTNVADMNV02006'){
				this.spaceModel.facilityMdEtc = '';
			}
		},
		//마을공간 등록
		fnSetSpace: function(){
			let vm = this;
			// if(vm.fnValidateChk(vm.valiObj) > 0){
			// 	return false;
			// }
			let _param = { spaceName 	: vm.spaceModel.spaceName
						 , sggCd	 	: vm.searchModel.sggCd
						 , spaceAddr 	: vm.spaceModel.spaceAddr
						 , spaceTel	 	: vm.spaceModel.spaceTel
						 , email 	 	: vm.spaceModel.spaceEmail + "@" + (vm.spaceModel.emailCd == '' ?  vm.spaceModel.emailAddrEtc : vm.spaceModel.emailAddr)
						 , emailOpenYn 	: vm.spaceModel.emailOpenYn ? "Y" : "N"
						 , majorLevel 	: vm.spaceModel.facilityMjCd
						 , mediumLevel	: vm.spaceModel.facilityMdCd
						 , spaceEtc		: vm.spaceModel.facilityMdEtc
						 , admittedCnt	: vm.spaceModel.admittedCnt
						 , surfaceArea	: vm.spaceModel.surfaceArea
						 , purpose		: vm.spaceModel.purpose
						 , mentoringYn	: vm.spaceModel.mentoringYn
						 , rentalFee	: vm.spaceModel.rentalFee
						 , managementAgency : vm.spaceModel.managementAgency
						 , url			: vm.spaceModel.url
						 , fileKey		: $('#fileKey').val()
						 };
			let param = {param : _param};
			Axios.post("/api/afterschool/space/create", param).then(function(response) {
				let result = response.data.result;
				if(result > 0){
					swal({
						title      : '',
						text       : '등록에 성공하였습니다.',
						icon       : vm.fnOnLoadSwalImageData('success'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							vm.fnChgTab(2);
							vm.fnChgValInitBySpc();
						}
					});
				} else {
					swal({
						title      : '',
						text       : '등록에 실패하였습니다.',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					});
					return false;
				}
			}).catch(function(ex) {
				console.log(ex);
				swal({
					title      : '',
					text       : '등록에 실패하였습니다.',
					icon       : vm.fnOnLoadSwalImageData('error'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						},
					},
					dangerMode : true
				});
				return false;
			});
		},
		//마을강사 초기화
		fnChgValInitByTchr: function() {
			let vm = this;
			vm.teacherModel.name 			= '';
			vm.teacherModel.gender 			= '';
			vm.teacherModel.phone 			= '';
			vm.teacherModel.phoneOpenYn		= '';
			vm.teacherModel.emailId			= '';
			vm.teacherModel.emailAddr		= '';
			vm.teacherModel.emailAddrEtc	= '';
			vm.teacherModel.emailOpenYn		= '';
			vm.teacherModel.eduContent		= '';
			vm.teacherModel.currentActive	= '';
			vm.teacherModel.domainName		= '';
			vm.teacherModel.domainCd		= '';
			vm.searchModel.domainCd			= '';
			vm.searchModel.domainName		= '';
			vm.searchModel.affiliationCd	= '';
			vm.searchModel.affiliationName	= '';
			vm.searchModel.sggCd			= '';
			vm.searchModel.sggName			= '';
			vm.searchModel.domainCdList		= [];
			vm.searchModel.affiliationCdList= [];
			vm.searchModel.sggCdList		= [];
			vm.searchModel.emailCdList		= [];
			vm.phoneNumberByTeacherApply	= '';
			vm.selectEmailBoxInTeacherApply	= '';
			vm.selectDomainBoxInTeacherApply= '';
			vm.selectLocalBoxInTeacherApply	= '';
			vm.teacherModel.phoneEduOrgYn	= false;
			vm.teacherModel.phoneGovOrgYn	= false;
			vm.teacherModel.phoneParentsYn	= false;
			vm.teacherModel.emailEduOrgYn	= false;
			vm.teacherModel.emailGovOrgYn	= false;
			vm.teacherModel.emailParentsYn	= false;
			vm.teacherModel.areas			= '';
			vm.fileEtcList					= [];
			vm.selectProFiles				= [];
			vm.searchModel.keyword			= '';
			vm.mapViewModel.mapInit			= 0;
		},
		//마을공간 초기화
		fnChgValInitBySpc: function() {
			let vm = this;
			vm.spaceModel.facilityMjCd		='';
			vm.spaceModel.facilityMjName	='';
			vm.spaceModel.facilityMdCd		='';
			vm.spaceModel.facilityMdName	='';
			vm.spaceModel.facilityMdEtc		='';
			vm.spaceModel.spaceName		 	='';
			vm.spaceModel.spaceAddr		 	='';
			vm.spaceModel.spaceTel		 	='';
			vm.spaceModel.spaceEmail		='';
			vm.spaceModel.majorLevel		='';
			vm.spaceModel.mediumLevel		='';
			vm.spaceModel.admittedCnt		='';
			vm.spaceModel.surfaceArea		='';
			vm.spaceModel.purpose		 	='';
			vm.spaceModel.rentalFee		 	='';
			vm.spaceModel.mentoringYn		='';
			vm.spaceModel.managementAgency	='';
			vm.spaceModel.url		 		='';
			vm.searchModel.sggName		 	='';
			vm.searchModel.sggCd		 	='';
			vm.spaceModel.emailAddr		 	='';
			vm.spaceModel.emailCd		 	='';
			vm.spaceModel.emailAddrEtc		='';
			vm.spaceModel.emailOpenYn		='';
			vm.searchModel.facilityMajorCdList 	= [];
			vm.searchModel.facilityMediumCdList = [];
			vm.searchModel.emailCdList			= [];
			vm.searchModel.sggCdList			= [];
			vm.searchModel.keyword			= '';
			vm.programModel.programList		= [];
			vm.searchModel.isMentoring		= false;

		},
		//멘토링 가능 여부 체크
		fnChkMentoringYn: function(){
			this.searchModel.isMentoring = !this.searchModel.isMentoring;
			// this.fnGetAfterSchoolSpcCntBySggList();
			// this.fnGetAfterSchoolSpcList(1);
		},
		//마을공간 검색
		fnGetSearchBySpace: function(){
			this.fnGetAfterSchoolSpcCntBySggList();
			this.fnGetAfterSchoolSpcList(1);
		},
		//마을공간 상세
		fnGetAfterSchoolSpaceDetail: function(pageNumber, _uidKey){
			let vm = this;
			vm.viewModel.pager.rowSize = 6;
			vm.viewModel.pager.blockSize = 5;
			vm.viewModel.pager.pageNo = pageNumber;
			let _param = {uidKey: _uidKey};
			let param = { param : _param
				    	, pageNo: vm.viewModel.pager.pageNo
				     	, pageSize: vm.viewModel.pager.rowSize
				    	};
			Axios.post("/api/afterschool/space/detail", param).then(function(response) {
				vm.spaceModel.spaceDto = response.data.paramSpcDto;
				response.data.paramPrgmDtoList.forEach(function (object) {
					if(object.zzimYn == 'Y'){
						object.isZzim = true;
					} else {
						object.isZzim = false;
					}
					let today = new Date();
					let startDate = object.acceptStartDate;
					let endDate = object.acceptEndDate;
					if(startDate >= today){
						if(endDate > today){
							object.status = 'finish';
						} else {
							object.status = 'ing';
						}
					} else {
						object.status = 'before';
					}

					vm.programModel.programList.push(object);
				});
				vm.fnSetPager(response.data.paramListCnt, 'fnGetAfterSchoolSpaceDetail');

			}).catch(function(ex) {
				console.log(ex);
			});

		},
		//alert 이미지 호출
        fnOnLoadSwalImageData:function(value){
            let _icon = "/design/common/images/sub/img_alert_"+value+".png";
            return _icon;
        },
		//마을강사찾기 페이지
		fnGetAfterTeacherSearchPage: function(){
			let vm = this;
			let _sggCd = $('#sggCd').val();
			if(_sggCd != null && _sggCd !=''){
				vm.searchModel.sggCd = _sggCd;
			}
			vm.fnGetAfterSchoolTchrCntBySggList();
			vm.fnChgSubTabByTchr(1);
		},
		//마을공간 페이지
		fnGetAfterSpaceSearchPage: function(){
			let vm = this;
			let _sggCd = $('#sggCd').val();
			if(_sggCd != null && _sggCd !=''){
				vm.searchModel.sggCd = _sggCd;
			}
			vm.fnChgValInitBySpc();
			vm.fnChgSubTabBySpc(1);
		},
		//마을강사페이지 검색 초기화
		fnChgSearchByTchr: function(){
			this.fnChgTab(3);
		},
		//마을방과후 프로그렘페이지 검색 초기화
		fnChgSearchByPrgm: function(){
			this.fnChgTab(3);
		},

		//마을공간 등록시 이미지 파일키 호출
		fnGetImgFileKeyBySpace: function(){
			let vm = this;
			let _param = {};
			let param = { param : _param};
			Axios.post("/api/afterschool/space/imgFileKey", param).then(function(response) {
				$('#fileKey').val(response.data.fileKey);
			});
		},

		//연락처체크-강사등록
		fnOnChkTelByTeacherApply: function(e){
			let vm = this;
			vm.phoneNumberByTeacherApply = e.target.value;
		},
		//연락처체크-공간등록
		fnOnChkTelBySpaceApply: function(e){
			let vm = this;
			vm.phoneNumberBySpaceApply = e.target.value;
		},
		//수용인원체크-강사등록
		fnOnChkAddmittedCntBySpaceApply: function(e){
			let vm = this;
			vm.admittedCntNumberBySpaceApply = e.target.value;
		},
		//면적체크-강사등록
		fnOnChkAreaBySpaceApply: function(e){
			let vm = this;
			vm.surfaceAreaFloatBySpaceApply = e.target.value;
		},
		//////////유효성체크//////////
		//마을공간등록-유효성체크
		fnOnChangeCheckSpaceName:function(){
			// let vm = this;
            // let _valid = vm.spaceModel.spaceName;
            // vm.spaceModel.validateTxtSpaceName = ( _valid == '') ? Validator.methods.fnValidateTxtEmpty(_valid, '마을공간명은 필수항목입니다.' ) : '';
			// vm.spaceModel.isSpaceName = vm.spaceModel.spaceName != '' ? true : false;
        },
		fnOnChangeCheckSggCd:function(){
			// let vm = this;
            // let _valid = vm.searchModel.sggCd;
            // vm.spaceModel.validateTxtSpaceName = ( _valid == '') ? Validator.methods.fnValidateTxtEmpty(_valid,'지역선택은 필수항목입니다.' ) : '';
			// vm.spaceModel.isSggCd = vm.searchModel.sggCd != '' ? true : false;
        },
		fnOnChangeCheckSpaceAddr:function(){
			// let vm = this;
            // let _valid = vm.spaceModel.spaceAddr;
            // vm.spaceModel.validateTxtSpaceName = ( _valid == '') ? Validator.methods.fnValidateTxtEmpty(_valid, '주소는 필수항목입니다.' ) : '';
			// vm.spaceModel.isSpaceAddr = vm.spaceModel.spaceAddr != '' ? true : false;
        },

		fnValidateChk:function(validateObj){
            let vm = this;
            let chkLegnth = 0;
            for(let item in validateObj){
                if(validateObj[item] == false){
                    chkLegnth++;
                    vm.$refs[item].focus();
                    break;
                }
            }
            return chkLegnth;
        },
		//좋아요 처리
        fnChgLikeBtn: function(object){
            //로그인 체크
            let vm = this;
            let _userKey = $("#loginUserKey").val();

            if (this.fnIsEmptyChk(_userKey)) {
                swal({
                    title      : '',
                    text       : '로그인이 필요합니다. 로그인 페이지로 이동합니다.',
                    icon       : vm.fnOnLoadSwalImageData('info'),
                    buttons    : true,
                    dangerMode : true
                }).then(result => {
                    if(result){
                        location.href = "/youthnavi/signup/login";
                    }
                });
            } else {
                //로그인이 되어 있으면
                object.isLike = !object.isLike;
                vm.programModel.review.isLike = object.isLike;
                let _param = { uidKey        : object.uidKey
                             , rcmmUidKey    : object.rcmmUidKey
                             , isLike        : object.isLike
                             };
                let param = {param:_param};
                Axios.post("/api/realinfo/contents/like/update", param).then(function(response) {
                  let result = response.data.result
                }).catch(function(ex) {
                  console.log(ex);
                });
            }
        },
		onClickAfterSpaceDetail : function(uidKey){
			location.href="/customer/afterschool/space?tab=2&uidKey="+uidKey;
		},
		onClickAfterTchrDetail : function(uidKey){
			location.href="/customer/afterschool/teacher?tab=3&uidKey="+uidKey;
		},
		//파일키 호출
		fnGetFileKey: function(){
			let vm = this;
			let _param = {};
			let param = {param:_param};
			Axios.post("/api/afterschool/fileKey/create", param).then(function(response) {
				vm.fileKey = response.data.fileKey;
				$('#fileKey').val(vm.fileKey);
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//마이내비 마을강사 조회
		fnGetTeacherApply: function(){
			let vm = this;
			let _param = {uidKey:$('#uidKey').val()};
			let param = {param:_param};
			Axios.post("/api/parents/afterschool/teacherSelect", param).then(function(response) {
				let chk = vm.teacherModel.applyCheck;
				vm.teacherModel = response.data.paramUsrDto;
				vm.teacherModel.applyCheck = chk;

				vm.phoneNumberByTeacherApply = vm.teacherModel.phone;
				vm.searchModel.affiliationCd = vm.teacherModel.affiliationCd;
				vm.searchModel.sggCd = vm.teacherModel.sggCd;

				let tmpEmail = vm.teacherModel.emailOpenYn.split("\|");
				if(tmpEmail[0] == "Y"){
					vm.teacherModel.emailEduOrgYn = true;
				} else {
					vm.teacherModel.emailEduOrgYn = false;
				}

				if(tmpEmail[1] == "Y"){
					vm.teacherModel.emailGovOrgYn = true;
				} else {
					vm.teacherModel.emailGovOrgYn = false;
				}

				if(tmpEmail[2] == "Y"){
					vm.teacherModel.emailParentsYn = true;
				} else {
					vm.teacherModel.emailParentsYn = false;
				}

				let tmpPhone = vm.teacherModel.phoneOpenYn.split("\|");
				if(tmpPhone[0] == "Y"){
					vm.teacherModel.phoneEduOrgYn = true;
				} else {
					vm.teacherModel.phoneEduOrgYn = false;
				}

				if(tmpPhone[1] == "Y"){
					vm.teacherModel.phoneGovOrgYn = true;
				} else {
					vm.teacherModel.phoneGovOrgYn = false;
				}

				if(tmpPhone[2] == "Y"){
					vm.teacherModel.phoneParentsYn = true;
				} else {
					vm.teacherModel.phoneParentsYn = false;
				}
				vm.filePlanList = response.data.filePlanList;
				vm.fileApplyList = response.data.fileApplyList;
				vm.fileImgList = response.data.fileImgList;
                vm.fileEtcList = response.data.fileEtcList;

				let _pageName = $('#pageName').val();
				if(_pageName == 'teacherApply'){
					vm.$refs.dropdoc1.onMaxChange(1);
					vm.$refs.dropdoc2.onMaxChange(1);
				}

				vm.filePlanList.forEach(function(file){
					file.fileUrl = "/doc/" + file.file_new_name.substr(0,8) + "/" + file.file_new_name;
				});
				vm.fileImgList.forEach(function(file){
					file.fileUrl = "/img/" + file.file_new_name.substr(0,8) + "/" + file.file_new_name;
				});
				vm.fileEtcList.forEach(function(file){
					file.fileUrl = "/doc/" + file.file_new_name.substr(0,8) + "/" + file.file_new_name;
				});

				if(vm.teacherModel.aprvYn == "Y"){
					vm.teacherModel.aprv =  '승인'
				} else if(vm.teacherModel.aprvYn == "A"){
          vm.teacherModel.aprv =  '미승인'
				} else if(vm.teacherModel.aprvYn == "N"){
					vm.teacherModel.aprv =  '거부'
				} else if(vm.teacherModel.aprvYn == "D"){
					vm.teacherModel.aprv =  '반려'
				} else if(vm.teacherModel.aprvYn == "R"){
					vm.teacherModel.aprv =  '재신청'
				}
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//마을강사 신청 권한
		fnOnClickUpdate:function(_userKey){
            let vm = this;
            if(Object.keys(vm.teacherModel) === 0){
                alert("체크해주세요");
            }else{
                let _param = {
                    cmm_res_key : _userKey
                  , cmm_sys_cd :  'USRNVYTHNV00210'
                  , cmm_sml_cd :  'USRNVYTHNV00214'
                  , cmm_dpmt_cd : null
                }
                let _result = {resultData : JSON.stringify(_param) };
                Axios.post("/api/account/member/aprv", _result, { }).then(function(response) {
                    if(response.data.resultData == 'failed'){
                        // swal("권한신청에 실패했습니다. 중복된 신청내역이 있거나 관리자에 문의해주세요.");
                        // vm.fnGetList();
						console.log('error');
                    }else{
						// swal("신청을 완료했습니다.");
                        // vm.fnGetList();
						console.log('finish');
                    }
                }).catch(function(ex) {
                    console.log(ex);
                });
            }
        },
		//마을강사 등록 버튼 클릭
		onClickCreateAfterTeacher: function(){
			this.fnSetTeacherApply();		//신청정보저장
			// this.fnOnClickUpdate();		//권한 신청
		},
		//전화번호하이픈
		fnChgTelNum : function(telNum){
			let vm = this;
			let result = [];
			let restNumber = '';

			if(!telNum){
				return '';
			}

			let value = telNum.replace(/[^0-9]/g, '');
			// 지역번호와 나머지 번호로 나누기
			if (value.startsWith("02")) {
				// 서울 02 지역번호
				result.push(value.substr(0, 2));
				restNumber = value.substring(2);
			} else if (value.startsWith("1")) {
				// 지역 번호가 없는 경우
				// 1xxx-yyyy
				restNumber = value;
			} else {
				// 나머지 3자리 지역번호
				// 0xx-yyyy-zzzz
				result.push(value.substr(0, 3));
				restNumber = value.substring(3);
			}

			if (restNumber.length === 7) {
				// 7자리만 남았을 때는 xxx-yyyy
				result.push(restNumber.substring(0, 3));
				result.push(restNumber.substring(3));
			} else {
				result.push(restNumber.substring(0, 4));
				result.push(restNumber.substring(4));
			}
			let tmpTel = result.filter((val) => val).join("-");
			return tmpTel;
		},
		//마을강사 승인처리
		onClickAfterTeacherApproval: function(){
			let vm = this;
			let _param = {uidKey:$('#uidKey').val()};
			let param = {param:_param};
			Axios.post("/api/mynavi/afterschool/teacherApproval", param).then(function(response) {
				let result = response.data.result;
				if (result > 0) {
					swal({
						title      : '',
						text       : '승인 처리 되었습니다.',
						icon       : vm.fnOnLoadSwalImageData('success'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							location.href="/youthnavi/mypage/center/aprvAfterTeacher"
						}
					});
				} else {
					swal({
						title      : '',
						text       : '승인에 실패하였습니다',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					});
					return false;
				}
			});
		},
    fnToggleAfterTeacherReturn: function(){ // 마을강사 반려사유 작성 폼 toggle
      let vm = this;
      vm.afterTeacherIsShowRejectForm = !vm.afterTeacherIsShowRejectForm
    },
		//마을강사 반려처리
		onClickAfterTeacherReturn: function(){

      if (!confirm('반려하시겠습니까?')) return false;

			let vm = this;
			let _param = {
        uidKey   : $('#uidKey').val(),
        rejectMsg: vm.afterTeacherRejectMsg, // 반려 사유
      };
			let param = {param:_param};
			Axios.post("/api/mynavi/afterschool/teacherReturn", param).then(function(response) {
				let result = response.data.result;
				if (result > 0) {
					swal({
						title      : '',
						text       : '반려 처리 되었습니다.',
						icon       : vm.fnOnLoadSwalImageData('success'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							location.href="/youthnavi/mypage/center/aprvAfterTeacher"
						}
					});
				} else {
					swal({
						title      : '',
						text       : '반려에 실패하였습니다',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					});
					return false;
				}
			});

		},
		//게시물 삭제
        onClickBoardDetailDelete:function(_uidKey){
            let vm = this;
            let _param = { uidKey:_uidKey};
            let param = {param : _param};
            Axios.post("/api/realinfo/board/delete", param).then(function(response) {
                let resultCnt = response.data.result;
                if(resultCnt > 0){
                    swal({
                        title      : '삭제 완료',
                        text       : '게시물 삭제가 완료되었습니다.',
                        icon       : vm.fnOnLoadSwalImageData('success'),
                        buttons: {
                            cancel: {
                                text: "Cancel",
                                value: false,
                                visible: false,
                            },
                            confirm: {
                                text: "Ok",
                                value: true,
                                visible: true,
                            }
                        },
                        dangerMode : true
                    }).then(result => {
						if(result){
							let _pageName = $('#pageName').val();
							if(_pageName == 'meetingMain'){
								vm.fnSetGalleryCancle();
							} else if(_pageName == 'connectMain'){
								vm.onClickConnectList(1);
							}
						}
                    });
                } else {
                    swal({
                        title       : '삭제 실패',
                        text        : '게시물 삭제가 실패되었습니다.',
                        icon        : vm.fnOnLoadSwalImageData('error'),
                        buttons: {
                            cancel: {
                                text: "Cancel",
                                value: false,
                                visible: false,
                            },
                            confirm: {
                                text: "Ok",
                                value: true,
                                visible: true,
                            }
                        },
                        dangerMode  : true,
                   });
                }
            }).catch(function(ex) {
                swal({
                    title       : '삭제 실패',
                    text        : '게시물 삭제가 실패하였습니다.',
                    icon        : vm.fnOnLoadSwalImageData('error'),
                    buttons: {
                        cancel: {
                            text: "Cancel",
                            value: false,
                            visible: false,
                        },
                        confirm: {
                            text: "Ok",
                            value: true,
                            visible: true,
                        },
                    },
                    dangerMode  : true,
               });
            });
		//마이내비 공지사항 조회
        }, fnGetMyNaviNoticeList: function(pageNumber){
			let vm = this;
			vm.viewModel.pager.rowSize = vm.mynaviModel.rowNum;
            vm.viewModel.pager.blockSize = 5;
            vm.viewModel.pager.pageNo = pageNumber;
			let _param = { keyword:''
						 , startDate:''
						 , endDate:''
						 };
			let param = { param:_param
						, pageNo:vm.viewModel.pager.pageNo
						, pageSize:vm.viewModel.pager.rowSize
			}
			Axios.post("/api/mynavi/afterschool/notice/list", param).then(function(response) {
				vm.mynaviModel.contentList = response.data.paramBrdDtoList;
				vm.mynaviModel.contentListCnt = response.data.paramListCnt;
				vm.fnSetPager(response.data.paramListCnt, 'fnGetNoticeList');
			});
		},
		//마이내비 공지사항 조회
        fnGetMyNaviFaqList: function(pageNumber){
			let vm = this;
			vm.viewModel.pager.rowSize = vm.mynaviModel.rowNum;
            vm.viewModel.pager.blockSize = 5;
            vm.viewModel.pager.pageNo = pageNumber;
			let _param = { keyword:''
						 , startDate:''
						 , endDate:''
						 };
			let param = { param:_param
						, pageNo:vm.viewModel.pager.pageNo
						, pageSize:vm.viewModel.pager.rowSize
			}
			Axios.post("/api/mynavi/afterschool/faq/list", param).then(function(response) {
				vm.mynaviModel.contentList = response.data.paramQnaDtoList;
				vm.mynaviModel.contentListCnt = response.data.paramListCnt;
				vm.fnSetPager(response.data.paramListCnt, 'fnGetFaqList');
			});
		}
		, fnOnClickSharePop: function(){
            this.isShare = true;
        }
        , fnOnClickCloseSharePop: function(){
            this.isShare = false;
        }
        , fnOnLoadKakaoContent: function(value){
            let _atag =  value.replace(/<(\/a|a|\/img|img|\/br|br|\/p|p|\/span|span)([^>]*)>/gi,'');
            if( _atag == null){
                return '';
            }
            let _nbsptag =  _atag.replace(/&nbsp;/gi,'');
            if( _nbsptag == null){
                return '';
            }
            let _httptag = _nbsptag.replace(/^(((http(s?))\:\/\/))([0-9a-zA-Z\-]+\.)+[a-zA-Z]{2,6}(\:[0-9]+)?(\/\S*)?/, '');
            if( _httptag == null){
                return '';
            }

            return  (_httptag.length >= 200) ? _httptag.substring(0,200).concat('...') : _httptag;
        }
        //카카오 공유
        , fnOnClickKakaoShare:function(){
            let vm = this;
            let tmpObj = {};
            let _pageName = $('#pageName').val();
			let _tab = $('#tab').val();
            let _imgPath = '';
            let _content = ''
            let _uri = '';

			let param = {};
			let urlAddress='';
			Axios.post("/api/url/address", param).then(function(response) {
				urlAddress = response.data.urlName;
				if(_pageName == 'meetingMain'){
					tmpObj = vm.meetingModel.galleryVO;
					_content = tmpObj.contentFirst;
					 _uri = urlAddress+'/customer/afterschool/meetingPlace?tab=1&uidKey=' + tmpObj.uidKey+ "&shared=Y";
					vm.fnShareLog(tmpObj.uidKey);
				} else if(_pageName == 'connectMain' && vm.menuViewModel.isFrstTab){
					tmpObj = vm.boardModel.notice;
					_content = tmpObj.contentFirst;
					_uri = urlAddress+'/customer/afterschool/connect?tab=1&uidKey=' + tmpObj.uidKey+ "&shared=Y";
					vm.fnShareLog(tmpObj.uidKey);
				} else if(_pageName == 'connectMain' && vm.menuViewModel.isScndTab){
					tmpObj = vm.boardModel.notice;
					_content = tmpObj.contentFirst;
					_uri = urlAddress+'/customer/afterschool/connect?tab=2&uidKey=' + tmpObj.uidKey+ "&shared=Y";
					vm.fnShareLog(tmpObj.uidKey);
				}
				if(vm.fileImgList != null && vm.fileImgList.length > 0){
					_imgPath = urlAddress+'/design/common/images/sub/img_noimg.png';
				}
				let _data = vm.fnOnLoadKakaoContent(_content);
				Share.methods.fnOnCreateKakaoShareUrl( _uri
													  , tmpObj.title
													  , _imgPath
													  , _data
													  , ''
													  , ''
													  , ''
													  , ''
													  );

			});
        },
        //네이버공유
        fnOnClickNaverShare: function(tab){
            let vm  = this;
			let _tmpObj = {};
			let _pageName = $('#pageName').val();
            let _uri = '';

			let param = {};
			let urlAddress='';
			Axios.post("/api/url/address", param).then(function(response) {
				urlAddress = response.data.urlName;
				if(_pageName == 'meetingMain'){
					_tmpObj = vm.meetingModel.galleryVO;
					_uri = urlAddress+'/customer/afterschool/meetingPlace?tab=1&uidKey=' + _tmpObj.uidKey+ "&shared=Y";
					vm.fnShareLog(_tmpObj.uidKey);
				} else if(_pageName == 'connectMain' && vm.menuViewModel.isFrstTab){
					_tmpObj = vm.boardModel.notice
					_uri = urlAddress+'/customer/afterschool/connect?tab=1&uidKey=' + _tmpObj.uidKey+ "&shared=Y";
					vm.fnShareLog(_tmpObj.uidKey);
				}

				Share.methods.fnOnCreateNaverShareUrl( _uri
													 , _tmpObj.title
													 );
			});
        },
        //페이스공유
        fnOnClickFacebookShare: function(tab){
            let vm  = this;
			let _tmpObj = {};
			let _pageName = $('#pageName').val();
            let _uri = '';

			let param = {};
			let urlAddress='';
			Axios.post("/api/url/address", param).then(function(response) {
				urlAddress = response.data.urlName;
				if(_pageName == 'meetingMain'){
					_tmpObj = vm.meetingModel.galleryVO;
					_uri = urlAddress+'/customer/afterschool/meetingPlace?tab=1&uidKey=' + _tmpObj.uidKey+ "&shared=Y";
					vm.fnShareLog(_tmpObj.uidKey);
				} else if(_pageName == 'connectMain' && vm.menuViewModel.isFrstTab){
					_tmpObj = vm.boardModel.notice;
					_uri = urlAddress+'/customer/afterschool/connect?tab=1&uidKey=' + _tmpObj.uidKey+ "&shared=Y";
					vm.fnShareLog(_tmpObj.uidKey);
				}

				Share.methods.fnOnCreateFacebookShareUrl( _uri);
			});
        },
        //링크공유
        fnOnClickLinkShare: function(tab){
            let vm  = this;
			let _tmpObj = {};
			let _pageName = $('#pageName').val();
            let _uri = '';

			let param = {};
			let urlAddress='';
			Axios.post("/api/url/address", param).then(function(response) {
				urlAddress = response.data.urlName;
				if(_pageName == 'meetingMain'){
					_tmpObj = vm.meetingModel.galleryVO;
					_uri = urlAddress+'/customer/afterschool/meetingPlace?tab=1&uidKey=' + _tmpObj.uidKey+ "&shared=Y";
					vm.fnShareLog(_tmpObj.uidKey);
				} else if(_pageName == 'connectMain' && vm.menuViewModel.isFrstTab){
					_tmpObj = vm.boardModel.notice;
					_uri = urlAddress+'/customer/afterschool/connect?tab=1&uidKey=' + _tmpObj.uidKey+ "&shared=Y";
					vm.fnShareLog(_tmpObj.uidKey);
				}

				let popup_url = '/customer/activity/share/link?url='+encodeURIComponent(_uri);
				window.open(popup_url, '공유하기', 'width=550, heigth=550, toolbar=no, menubar=no, scrollbars=no, resizable=no');
			});
        },
		fnShareLog(uidKey){
			Axios.post("/api/logCud/insert", {paramUid : uidKey, statusCode : "share", version : "insert"}).then(function(response) {
				let result = response.data.resultCnt;
			});
		},
		//개월 버튼
        onClickDateBtn: function(num){
            let vm = this;
            let date = new Date();
            let _date = new Date();
            if(num == 1){
                vm.mynaviModel.startDate = _date;
                vm.mynaviModel.endDate = date;
                vm.mynaviViewModel.isToday      = true;
                vm.mynaviViewModel.isWeek       = false;
                vm.mynaviViewModel.isOneMonth   = false;
                vm.mynaviViewModel.isTwoMonth   = false;
                vm.mynaviViewModel.isSixMonth   = false;
            } else if(num == 2){
                vm.mynaviModel.endDate = _date;
                vm.mynaviModel.startDate = new Date(date.setDate(date.getDate()-7));
                vm.mynaviViewModel.isToday      = false;
                vm.mynaviViewModel.isWeek       = true;
                vm.mynaviViewModel.isOneMonth   = false;
                vm.mynaviViewModel.isTwoMonth   = false;
                vm.mynaviViewModel.isSixMonth   = false;
            } else if(num == 3){
                vm.mynaviModel.endDate = _date;
                vm.mynaviModel.startDate = new Date(date.setMonth(date.getMonth()-1));
                vm.mynaviViewModel.isToday      = false;
                vm.mynaviViewModel.isWeek       = false;
                vm.mynaviViewModel.isOneMonth   = true;
                vm.mynaviViewModel.isTwoMonth   = false;
                vm.mynaviViewModel.isSixMonth   = false;
            } else if(num == 4){
                vm.mynaviModel.endDate = _date;
                vm.mynaviModel.startDate = new Date(date.setMonth(date.getMonth()-2));
                vm.mynaviViewModel.isToday      = false;
                vm.mynaviViewModel.isWeek       = false;
                vm.mynaviViewModel.isOneMonth   = false;
                vm.mynaviViewModel.isTwoMonth   = true;
                vm.mynaviViewModel.isSixMonth   = false;
            } else if(num == 5){
                vm.mynaviModel.endDate = _date;
                vm.mynaviModel.startDate = new Date(date.setMonth(date.getMonth()-6));
                vm.mynaviViewModel.isToday      = false;
                vm.mynaviViewModel.isWeek       = false;
                vm.mynaviViewModel.isOneMonth   = false;
                vm.mynaviViewModel.isTwoMonth   = true;
                vm.mynaviViewModel.isSixMonth   = false;
            } else if(num == 6){
                vm.mynaviModel.endDate          = '';
                vm.mynaviModel.startDate        = '';
                vm.mynaviModel.keyword          = '';
                vm.mynaviViewModel.isToday      = false;
                vm.mynaviViewModel.isWeek       = false;
                vm.mynaviViewModel.isOneMonth   = false;
                vm.mynaviViewModel.isTwoMonth   = false;
                vm.mynaviViewModel.isSixMonth   = false;
            }
        },
		//보여주기 옵션 설정
        fnSetCntOption: function(){
            this.mynaviModel.orderList.push({
                code: "10",
                value: "10건씩 보기"
            });
            this.mynaviModel.orderList.push({
                code: "20",
                value: "20건씩 보기"
            });
            this.mynaviModel.orderList.push({
                code: "30",
                value: "30건씩 보기"
            });
        },
		//공지사항 상세페이지
		onClickNoticeDetail: function(uidKey){
			location.href = '/customer/afterschool/connect?tab=1&uidKey=' + uidKey;
		},
		//마을방과후 이음 목록
		onClickConnectList:function(tab){
			location.href = '/customer/afterschool/connect?tab='+tab;
		},
		//공지사항 작성페이지 이동
        onClickNoticeWrite: function(uidKey){
			if(uidKey != null && uidKey != ''){
				location.href="/mynavi/afterschool/notice/write?uidKey="+uidKey;
			} else {
				location.href="/mynavi/afterschool/notice/write";
			}
        },
		//마이내비 공지사항 목록 페이지 이동
		onClickMyNaviNoticeList: function(){
			location.href="/youthnavi/mypage/center/aprvAfterNotice";
		},
		//공지사항 등록
        fnSetNoticeContent: function(){
            let vm = this;

            //유효성 체크
            let _IsTitle = validation.isEmpty(vm.mynaviModel.title);
            let _IsContent = validation.isEmpty(vm.mynaviModel.content);
            let _param = { title        : vm.mynaviModel.title
                         , contentFirst : vm.mynaviModel.content
						 , type			: 'insert'
                         };
            let param = {param : _param};

            if(_IsTitle || _IsContent){

                let _word = '';
                if(_IsTitle){
                    _word = '제목';
                } else if(_IsContent){
                    _word = '내용';
                }

                swal({
                    title       : _word+' 오류',
                    text        : _word+'을 입력해주세요.',
                    icon        : this.fnOnLoadSwalImageData('error'),
                    buttons: {
                        cancel: {
                            text: "Cancel",
                            value: false,
                            visible: false,
                        },
                        confirm: {
                            text: "Ok",
                            value: true,
                            visible: true,
                        }
                    },
                    dangerMode  : true,
               });
            } else {
                if(vm.mynaviModel.title.length > 200){
					swal({
                        title       : '제목 길이 오류',
                        text        : '제목은 200자 이하로 입력해주세요.',
                        icon        : vm.fnOnLoadSwalImageData('error'),
                        buttons: {
                            cancel: {
                                text: "Cancel",
                                value: false,
                                visible: false,
                            },
                            confirm: {
                                text: "Ok",
                                value: true,
                                visible: true,
                            }
                        },
                        dangerMode  : true,
                    });
                } else {

                    Axios.post("/api/afterschool/notice/create", param).then(function(response) {
                        let resultCnt = response.data.result;
                        if(resultCnt > 0){
                            swal({
                                title      : '등록 완료',
                                text       : '게시물 등록이 완료되었습니다.',
                                icon       : vm.fnOnLoadSwalImageData('success'),
                                buttons: {
                                    cancel: {
                                        text: "Cancel",
                                        value: false,
                                        visible: false,
                                    },
                                    confirm: {
                                        text: "Ok",
                                        value: true,
                                        visible: true,
                                    }
                                },
                                dangerMode : true
                            }).then(result => {
								if(result){
									vm.onClickMyNaviNoticeList();
								}
                            });
                        } else if(resultCnt == -999) {
							swal({
								title      : '등록 실패',
								text       : '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
								icon       : vm.fnOnLoadSwalImageData('error'),
								buttons: {
									cancel: {
										text: "Cancel",
										value: false,
										visible: false,
									},
									confirm: {
										text: "Ok",
										value: true,
										visible: true,
									},
								},
								dangerMode : true
							}).then(result => {
								if(result){
									return false;
								}
							});
						} else {
                            swal({
                                title       : '등록 실패',
                                text        : '게시물 등록이 실패하였습니다.',
                                icon        : vm.fnOnLoadSwalImageData('error'),
                                buttons: {
                                    cancel: {
                                        text: "Cancel",
                                        value: false,
                                        visible: false,
                                    },
                                    confirm: {
                                        text: "Ok",
                                        value: true,
                                        visible: true,
                                    }
                                },
                                dangerMode  : true,
                           });
                        }
                    }).catch(function(ex) {
                        swal({
                            title       : '등록 실패',
                            text        : '게시물 등록이 실패하였습니다.',
                            icon        : vm.fnOnLoadSwalImageData('error'),
                            buttons: {
                                cancel: {
                                    text: "Cancel",
                                    value: false,
                                    visible: false,
                                },
                                confirm: {
                                    text: "Ok",
                                    value: true,
                                    visible: true,
                                }
                            },
                            dangerMode  : true,
                       });
                    });
                }
            }
        },
		//공지사항 수정
        fnChgNoticeContent: function(){
            let vm = this;
            let _uidKey = $('#uidKey').val();

            //유효성 체크
            let _IsTitle = validation.isEmpty(vm.mynaviModel.title);
            let _IsContent = validation.isEmpty(vm.mynaviModel.content);

            let _param = { title        : vm.mynaviModel.title
						 , contentFirst : vm.mynaviModel.content
						 , type			: 'update'
						 , uidKey		: vm.mynaviModel.uidKey
						 };
            let param = {param : _param};
            if(_IsTitle || _IsContent){

                let _word = '';
                if(_IsTitle){
                    _word = '제목';
                } else if(_IsContent){
                    _word = '내용';
                }

                swal({
                    title       : _word+' 오류',
                    text        : _word+'을 입력해주세요.',
                    icon        : vm.fnOnLoadSwalImageData('error'),
                    buttons: {
                        cancel: {
                            text: "Cancel",
                            value: false,
                            visible: false,
                        },
                        confirm: {
                            text: "Ok",
                            value: true,
                            visible: true,
                        }
                    },
                    dangerMode  : true,
                });
            } else {
                if(vm.mynaviModel.title.length > 200){
					swal({
                        title       : '제목 길이 오류',
                        text        : '제목은 200자 이하로 입력해주세요.',
                        icon        : vm.fnOnLoadSwalImageData('error'),
                        buttons: {
                            cancel: {
                                text: "Cancel",
                                value: false,
                                visible: false,
                            },
                            confirm: {
                                text: "Ok",
                                value: true,
                                visible: true,
                            }
                        },
                        dangerMode  : true,
                    });
                } else {
                    Axios.post("/api/afterschool/notice/update", param).then(function(response) {
                        let resultCnt = response.data.result;
                        let word = '수정';
                        if(resultCnt > 0){
                            swal({
                                title      : word + ' 완료',
                                text       : '게시물 '+word+'이 완료되었습니다.',
                                icon       : vm.fnOnLoadSwalImageData('success'),
                                buttons: {
                                    cancel: {
                                        text: "Cancel",
                                        value: false,
                                        visible: false,
                                    },
                                    confirm: {
                                        text: "Ok",
                                        value: true,
                                        visible: true,
                                    }
                                },
                                dangerMode : true
                            }).then(result => {
                                vm.onClickMyNaviNoticeList();
                            });
                        } else if(resultCnt == -999) {
							swal({
								title      : '수정 실패',
								text       : '수정에 실패하였습니다(개인정보 또는 비속어 포함)',
								icon       : vm.fnOnLoadSwalImageData('error'),
								buttons: {
									cancel: {
										text: "Cancel",
										value: false,
										visible: false,
									},
									confirm: {
										text: "Ok",
										value: true,
										visible: true,
									},
								},
								dangerMode : true
							}).then(result => {
								if(result){
									return false;
								}
							});
						} else {
                            swal({
                                title       : word + ' 실패',
                                text        : '게시물 '+word+'이 실패되었습니다.',
                                icon        : vm.fnOnLoadSwalImageData('error'),
                                buttons: {
                                    cancel: {
                                        text: "Cancel",
                                        value: false,
                                        visible: false,
                                    },
                                    confirm: {
                                        text: "Ok",
                                        value: true,
                                        visible: true,
                                    }
                                },
                                dangerMode  : true,
                           });
                        }
                    }).catch(function(ex) {
                        swal({
                            title       : word + ' 실패',
                            text        : '게시물 '+word+'이 실패하였습니다.',
                            icon        : vm.fnOnLoadSwalImageData('error'),
                            buttons: {
                                cancel: {
                                    text: "Cancel",
                                    value: false,
                                    visible: false,
                                },
                                confirm: {
                                    text: "Ok",
                                    value: true,
                                    visible: true,
                                },
                            },
                            dangerMode  : true,
                       });
                    });
                }
            }
        },
		//자주묻는질문 작성페이지 이동
        onClickFaqWrite: function(uidKey){
			if(uidKey != null && uidKey != ''){
				location.href="/mynavi/afterschool/faq/write?uidKey="+uidKey;
			} else {
				location.href="/mynavi/afterschool/faq/write";
			}
        },
		//자주묻는질문 상세페이지
		onClickFaqDetail: function(uidKey){
			location.href = '/customer/afterschool/connect?tab=2&uidKey=' + uidKey;
		},
		//마이내비 자주묻는질문 목록 페이지 이동
		onClickMyNaviFaqList: function(){
			location.href="/youthnavi/mypage/center/aprvAfterFaq";
		},
		//자주묻는질문 등록
        fnSetFaqContent: function(){
            let vm = this;

            //유효성 체크
            let _IsTitle = validation.isEmpty(vm.mynaviModel.title);
            let _IsContent = validation.isEmpty(vm.mynaviModel.content);
            let _param = { title        : vm.mynaviModel.title
                         , contentFirst	: vm.mynaviModel.content
						 , type			: 'insert'
						 , faqCd		: vm.searchModel.faqCd
                         };
            let param = {param : _param};

            if(_IsTitle || _IsContent){

                let _word = '';
                if(_IsTitle){
                    _word = '제목';
                } else if(_IsContent){
                    _word = '내용';
                }

                swal({
                    title       : _word+' 오류',
                    text        : _word+'을 입력해주세요.',
                    icon        : this.fnOnLoadSwalImageData('error'),
                    buttons: {
                        cancel: {
                            text: "Cancel",
                            value: false,
                            visible: false,
                        },
                        confirm: {
                            text: "Ok",
                            value: true,
                            visible: true,
                        }
                    },
                    dangerMode  : true,
               });
            } else {
                if(vm.mynaviModel.title.length > 200){
					swal({
                        title       : '제목 길이 오류',
                        text        : '제목은 200자 이하로 입력해주세요.',
                        icon        : vm.fnOnLoadSwalImageData('error'),
                        buttons: {
                            cancel: {
                                text: "Cancel",
                                value: false,
                                visible: false,
                            },
                            confirm: {
                                text: "Ok",
                                value: true,
                                visible: true,
                            }
                        },
                        dangerMode  : true,
                    });
                } else {
                    Axios.post("/api/afterschool/faq/create", param).then(function(response) {
                        let resultCnt = response.data.result;
                        if(resultCnt > 0){
                            swal({
                                title      : '등록 완료',
                                text       : '게시물 등록이 완료되었습니다.',
                                icon       : vm.fnOnLoadSwalImageData('success'),
                                buttons: {
                                    cancel: {
                                        text: "Cancel",
                                        value: false,
                                        visible: false,
                                    },
                                    confirm: {
                                        text: "Ok",
                                        value: true,
                                        visible: true,
                                    }
                                },
                                dangerMode : true
                            }).then(result => {
								if(result){
									vm.onClickMyNaviFaqList();
								}
                            });
                        } else if(resultCnt == -999) {
							swal({
								title      : '등록 실패',
								text       : '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
								icon       : vm.fnOnLoadSwalImageData('error'),
								buttons: {
									cancel: {
										text: "Cancel",
										value: false,
										visible: false,
									},
									confirm: {
										text: "Ok",
										value: true,
										visible: true,
									},
								},
								dangerMode : true
							}).then(result => {
								if(result){
									return false;
								}
							});
						} else {
                            swal({
                                title       : '등록 실패',
                                text        : '게시물 등록이 실패하였습니다.',
                                icon        : vm.fnOnLoadSwalImageData('error'),
                                buttons: {
                                    cancel: {
                                        text: "Cancel",
                                        value: false,
                                        visible: false,
                                    },
                                    confirm: {
                                        text: "Ok",
                                        value: true,
                                        visible: true,
                                    }
                                },
                                dangerMode  : true,
                           });
                        }
                    }).catch(function(ex) {
                        swal({
                            title       : '등록 실패',
                            text        : '게시물 등록이 실패하였습니다.',
                            icon        : vm.fnOnLoadSwalImageData('error'),
                            buttons: {
                                cancel: {
                                    text: "Cancel",
                                    value: false,
                                    visible: false,
                                },
                                confirm: {
                                    text: "Ok",
                                    value: true,
                                    visible: true,
                                }
                            },
                            dangerMode  : true,
                       });
                    });
                }
            }
        },
		//자주묻는질문 수정
        fnChgFaqContent: function(){
            let vm = this;
            let _uidKey = $('#uidKey').val();

            //유효성 체크
            let _IsTitle = validation.isEmpty(vm.mynaviModel.title);
            let _IsContent = validation.isEmpty(vm.mynaviModel.content);
			let _IsFaq = validation.isEmpty(vm.searchModel.faqCd);

            let _param = { title        : vm.mynaviModel.title
						 , contentFirst : vm.mynaviModel.content
						 , type			: 'update'
						 , uidKey		: vm.mynaviModel.uidKey
						 , faqCd		: vm.searchModel.faqCd
						 };
            let param = {param : _param};
            if(_IsTitle || _IsContent){

                let _word = '';
                if(_IsTitle){
                    _word = '제목';
                } else if(_IsContent){
                    _word = '내용';
                }

                swal({
                    title       : _word+' 오류',
                    text        : _word+'을 입력해주세요.',
                    icon        : vm.fnOnLoadSwalImageData('error'),
                    buttons: {
                        cancel: {
                            text: "Cancel",
                            value: false,
                            visible: false,
                        },
                        confirm: {
                            text: "Ok",
                            value: true,
                            visible: true,
                        }
                    },
                    dangerMode  : true,
                });
            } else if (_IsFaq){
				swal({
					title       : '카테고리 오류',
					text        : '카테고리를 선택해주세요.',
					icon        : this.fnOnLoadSwalImageData('error'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						}
					},
					dangerMode  : true,
				});
			} else {
                if(vm.mynaviModel.title.length > 200){
					swal({
                        title       : '제목 길이 오류',
                        text        : '제목은 200자 이하로 입력해주세요.',
                        icon        : vm.fnOnLoadSwalImageData('error'),
                        buttons: {
                            cancel: {
                                text: "Cancel",
                                value: false,
                                visible: false,
                            },
                            confirm: {
                                text: "Ok",
                                value: true,
                                visible: true,
                            }
                        },
                        dangerMode  : true,
                    });
                } else {
                    Axios.post("/api/afterschool/faq/update", param).then(function(response) {
                        let resultCnt = response.data.result;
                        let word = '수정';
                        if(resultCnt > 0){
                            swal({
                                title      : word + ' 완료',
                                text       : '게시물 '+word+'이 완료되었습니다.',
                                icon       : vm.fnOnLoadSwalImageData('success'),
                                buttons: {
                                    cancel: {
                                        text: "Cancel",
                                        value: false,
                                        visible: false,
                                    },
                                    confirm: {
                                        text: "Ok",
                                        value: true,
                                        visible: true,
                                    }
                                },
                                dangerMode : true
                            }).then(result => {
								if(result){
									vm.onClickMyNaviFaqList();
								}
                            });
                        } else if(resultCnt == -999) {
							swal({
								title      : '수정 실패',
								text       : '수정에 실패하였습니다(개인정보 또는 비속어 포함)',
								icon       : vm.fnOnLoadSwalImageData('error'),
								buttons: {
									cancel: {
										text: "Cancel",
										value: false,
										visible: false,
									},
									confirm: {
										text: "Ok",
										value: true,
										visible: true,
									},
								},
								dangerMode : true
							}).then(result => {
								if(result){
									return false;
								}
							});
						} else {ㄱ
                            swal({
                                title       : word + ' 실패',
                                text        : '게시물 '+word+'이 실패되었습니다.',
                                icon        : vm.fnOnLoadSwalImageData('error'),
                                buttons: {
                                    cancel: {
                                        text: "Cancel",
                                        value: false,
                                        visible: false,
                                    },
                                    confirm: {
                                        text: "Ok",
                                        value: true,
                                        visible: true,
                                    }
                                },
                                dangerMode  : true,
                           });
                        }
                    }).catch(function(ex) {
                        swal({
                            title       : word + ' 실패',
                            text        : '게시물 '+word+'이 실패하였습니다.',
                            icon        : vm.fnOnLoadSwalImageData('error'),
                            buttons: {
                                cancel: {
                                    text: "Cancel",
                                    value: false,
                                    visible: false,
                                },
                                confirm: {
                                    text: "Ok",
                                    value: true,
                                    visible: true,
                                },
                            },
                            dangerMode  : true,
                       });
                    });
                }
            }
        },
		//자주묻는질문 삭제
		onClickFaqDelete: function(_uidKey){
			let vm = this;
			swal({
                title      : '댓글 삭제',
                text       : '댓글을 삭제하시겠습니까?',
                icon       : vm.fnOnLoadSwalImageData('info'),
                buttons    : true,
                dangerMode : true
            }).then(result => {
				if(result){

					let _param = { uidKey	: _uidKey
								 , type		: 'delete' };
					let param = { param : _param};
					Axios.post("/api/afterschool/faq/delete", param).then(function(response) {
						let result = response.data.result;
						if (result > 0) {
							swal({
								title      : '',
								text       : '정상적으로 삭제되었습니다.',
								icon       : vm.fnOnLoadSwalImageData('success'),
								buttons: {
									cancel: {
										text: "Cancel",
										value: false,
										visible: false,
									},
									confirm: {
										text: "Ok",
										value: true,
										visible: true,
									},
								},
								dangerMode : true
							}).then(result => {
								if(result){
									vm.onClickMyNaviFaqList();
								}
							});
						} else {
							swal({
								title      : '',
								text       : '삭제에 실패하였습니다.',
								icon       : vm.fnOnLoadSwalImageData('error'),
								buttons: {
									cancel: {
										text: "Cancel",
										value: false,
										visible: false,
									},
									confirm: {
										text: "Ok",
										value: true,
										visible: true,
									},
								},
								dangerMode : true
							});
							return false;
						}
						}).catch(function(ex) {
							console.log(ex);
							swal({
								title      : '',
								text       : '삭제에 실패하였습니다.',
								icon       : vm.fnOnLoadSwalImageData('error'),
								buttons: {
									cancel: {
										text: "Cancel",
										value: false,
										visible: false,
									},
									confirm: {
										text: "Ok",
										value: true,
										visible: true,
									},
								},
								dangerMode : true
							});
						return false;
					});
				} else {
					return false;
				}
			});
		},
		//마을강사 등록페이지 이동
		onClickAfterTeacherApply: function(){
			location.href="/customer/afterschool/teacher?tab=2";
		},
		//이름조회
		fnGetUserName: function(){
			let vm = this;
			let _param = {};
			let param = {param:_param};
			Axios.post("/api/afterschool/select/name", param).then(function(response) {
				vm.teacherModel.name = response.data.userName;
			});
		},
		//마을강사 검색
		fnGetSearchByTeacher: function(){
			this.fnGetAfterSchoolTchrCntBySggList();
			this.fnGetAfterSchoolTchrList(1);
			this.menuViewModel.isClick = true;
		},
		//마을방과후 프로그램 검색
		fnGetSearchByProgram: function(){
			this.fnGetAfterSchoolPrgrCntBySggList();
			this.fnGetAfterSchoolPrgmList(1);
			this.menuViewModel.isClick = true;
		},
		//마을방과후 이음 문의하기 목록 조회
		fnGetQnaList: function(pageNumber){
			let vm = this;
			vm.viewModel.pager.rowSize = 10;
			vm.viewModel.pager.blockSize = 5;
			vm.viewModel.pager.pageNo = pageNumber;
			let _param = {keyword : vm.searchModel.keyword};
			let param = { param:_param
						, pageNo: vm.viewModel.pager.pageNo
						, pageSize: vm.viewModel.pager.rowSize
						};
			Axios.post("/api/afterschool/connect/qna/list", param).then(function(response) {
				vm.boardModel.qnaListCnt = response.data.paramListCnt;
				vm.boardModel.qnaList = [];
				response.data.paramQnaDtoList.forEach(function(item) {
					item.isPwSct = false;
					item.inputPw = '';
					vm.boardModel.qnaList.push(item);
				});
				vm.fnSetPager(response.data.paramListCnt, 'fnGetFaqList');
			});

		},
		//마을방과후 이음 문의하기 상세 조회
		fnGetQnaDetail: function(_uidKey) {
			let vm = this;
			let _param = { uidKey: _uidKey };
			let param = { param : _param};
			Axios.post("/api/afterschool/connect/qna/detail", param).then(function(response) {
				vm.boardModel.qna = response.data.paramQnaDto;
				if(vm.boardViewModel.isFrthSct){
					vm.fnGetSeoulGuCode();
				}
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//마을방과후 이음 문의하기 등록
		fnSetQna: function(){
			let vm = this;
			let _param = { title 			: vm.boardModel.qna.title
						 , sggCd 			: vm.searchModel.sggCd
						 , contentFirst 	: vm.boardModel.qna.content
						 , password			: vm.boardModel.qna.password
						 };
			let param = { param : _param
						, listPath : '/customer/afterschool/connect?tab=3'
						, detailPath : '/customer/afterschool/connect?tab=3&uidKey='};
			Axios.post("/api/afterschool/connect/qna/create", param).then(function(response) {
				let result = response.data.result;
				if (result > 0) {
					swal({
						title      : '등록 완료',
						text       : '정상적으로 등록되었습니다.',
						icon       : vm.fnOnLoadSwalImageData('success'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							vm.onClickConnectList(3);
						}
					});
				} else if(result == -999) {
					swal({
						title      : '등록 실패',
						text       : '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							return false;
						}
					});
				} else {
					swal({
						title      : '등록 실패',
						text       : '등록에 실패하였습니다',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					});
					return false;
				}
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//마을방과후 문의하기 비밀번호 입력화면 출력
		onClickAfterQnaPw(_uidKey) {
			let vm = this;

			let isOpen = vm.boardModel.qnaList.find(obj => obj.uidKey == _uidKey).isPwSct;
			let objIdx = vm.boardModel.qnaList.findIndex(
				obj => obj.uidKey == _uidKey
			);
			vm.boardModel.qnaList[objIdx].isPwSct = !isOpen;
		},
		//마을방과후 문의하기 비밀번호 확인
		onClickAfterQnaPwCheck(_uidKey) {
			let vm = this;
			let _userKey = $("#loginUserKey").val();
			if (this.fnIsEmptyChk(_userKey)) {
				swal({
					title      : '',
					text       : '로그인이 필요합니다. 로그인 페이지로 이동합니다.',
					icon       : vm.fnOnLoadSwalImageData('info'),
					buttons    : true,
					dangerMode : true
				}).then(result => {
					if(result){
						location.href = "/youthnavi/signup/login";
					}
				});
			} else {
				let _password = vm.boardModel.qnaList.find(obj => obj.uidKey == _uidKey).password;
				let _inputPw = vm.boardModel.qnaList.find(obj => obj.uidKey == _uidKey).inputPw;

				if (_inputPw != _password) {
					swal({
						title      : '',
						text       : '비밀번호가 일치하지 않습니다.',
						icon       : vm.fnOnLoadSwalImageData('warning'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					});
					return false;
				} else {
					vm.fnChgCnnctSubSct(2, _uidKey,'qna');
				}
			}
		},
		//마을방과후 문의하기 비밀번호 창 초기화
		fnChgIsPwCheckByConnectQna: function() {
			let vm = this;
			if (vm.boardModel.qnaList != null && vm.boardModel.qnaList.size > 0) {
				let tmp = 0;
				vm.boardModel.qnaList.forEach(function(item) {
					vm.boardModel.qnaList[tmp].isPwSct = false;
					vm.boardModel.qnaList[tmp].inputPw = false;
					tmp++;
				});
				vm.boardModel.qnaPw = '';
			}
		},
		//마을방과후 이음 문의하기 수정 클릭
		onClickAfterQnaUpdate: function(_uidKey){
			let vm = this;
			let isAnswer = (vm.boardModel.qna.answerUidKey == null) ? false : true;
			if(isAnswer){
				swal({
                    title      : '수정 불가',
                    text       : '답변이 달린 글은 수정할 수 없습니다.',
                    icon       : vm.fnOnLoadSwalImageData('warning'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						},
					},
                    dangerMode : true
                });
				return false;
			} else {
				vm.fnChgCnnctSubSct(4,_uidKey);
			}
		},
		//마을방과후 이음 문의하기 삭제 클릭
		onClickAfterQnaDelete: function(_uidKey){
			let vm = this;
			let isAnswer = (vm.boardModel.qna.answerUidKey == null) ? false : true;
			if(isAnswer){
				swal({
                    title      : '삭제 불가',
                    text       : '답변이 달린 글은 삭제할 수 없습니다.',
                    icon       : vm.fnOnLoadSwalImageData('warning'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						},
					},
                    dangerMode : true
                });
				return false;
			} else {
				swal({
					title      : '문의내용 삭제',
					text       : '삭제하시겠습니까?',
					icon       : vm.fnOnLoadSwalImageData('info'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: true,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						},
					},
					dangerMode : true
				}).then(result => {
					if(result){
						let _param = { uidKey : _uidKey
									 , type	  : 'delete'
									 };
						let param = {param : _param};
						Axios.post("/api/afterschool/connect/qna/delete", param).then(function(response) {
							let result = response.data.result;
							if (result > 0) {
								swal({
									title      : '삭제 성공',
									text       : '정상적으로 삭제되었습니다.',
									icon       : vm.fnOnLoadSwalImageData('success'),
									buttons: {
										cancel: {
											text: "Cancel",
											value: false,
											visible: false,
										},
										confirm: {
											text: "Ok",
											value: true,
											visible: true,
										},
									},
									dangerMode : true
								}).then(result => {
									if(result){
										vm.onClickConnectList(3);
									}
								});
							} else {
								swal({
									title      : '삭제 실패',
									text       : '삭제에 실패하였습니다',
									icon       : vm.fnOnLoadSwalImageData('error'),
									buttons: {
										cancel: {
											text: "Cancel",
											value: false,
											visible: false,
										},
										confirm: {
											text: "Ok",
											value: true,
											visible: true,
										},
									},
									dangerMode : true
								});
								return false;
							}
						}).catch(function(ex) {
							console.log(ex);
						});
					} else {
						return false;
					}
				});
			}
		},
		//문의하기 등록 버튼 클릭
		onClickAfterQnaCreate: function(){
			let vm = this;
			let _userKey = $("#loginUserKey").val();
			if (this.fnIsEmptyChk(_userKey)) {
				swal({
					title      : '',
					text       : '로그인이 필요합니다. 로그인 페이지로 이동합니다.',
					icon       : vm.fnOnLoadSwalImageData('info'),
					buttons    : true,
					dangerMode : true
				}).then(result => {
					if(result){
						location.href = "/youthnavi/signup/login";
					}
				});
			} else {
				vm.fnChgCnnctSubSct(3);
			}
		},
		//마을방과후 이음 문의하기 수정
		fnChgQna: function(){
			let vm = this;
			let _param = { title 		: vm.boardModel.qna.title
						 , sggCd 		: vm.searchModel.sggCd
						 , contentFirst : vm.boardModel.qna.content
						 , uidKey		: vm.boardModel.qna.uidKey
						 , type			: 'update'
						 };mypageCenterExpInfoQna
			let param = { param : _param};
			Axios.post("/api/afterschool/connect/qna/update", param).then(function(response) {
				let result = response.data.result;
				if (result > 0) {
					swal({
						title      : '수정 완료',
						text       : '정상적으로 수정되었습니다.',
						icon       : vm.fnOnLoadSwalImageData('success'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							vm.onClickConnectList(3);
						}
					});
				} else {
					swal({
						title      : '수정 실패',
						text       : '수정에 실패하였습니다',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					});
					return false;
				}
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//마이내비 프로그램 게시요청 목록
        fnGetProgramPostRequestList: function(pageNumber){
            let vm = this;
            vm.viewModel.pager.rowSize = vm.mynaviModel.rowNum;
            vm.viewModel.pager.blockSize = 5;
            vm.viewModel.pager.pageNo = pageNumber;
            let _param = { keyword  : vm.mynaviModel.keyword
                         , startDate: vm.fnChgDateString(vm.mynaviModel.startDate)
                         , endDate  : vm.fnChgDateString(vm.mynaviModel.endDate)
                         , viewYn   : vm.mynaviModel.selectViewYn
						 , selectSearch      : vm.mynaviModel.selectSearch
                         }
            let param = { param:_param
                        , pageNo:vm.viewModel.pager.pageNo
                        , pageSize:vm.viewModel.pager.rowSize
                        }
            Axios.post("/api/mynavi/afterschool/program/post/request/list", param).then(function(response) {
                vm.mynaviModel.contentList = response.data.paramPrgmDtoList;
                vm.mynaviModel.contentListCnt = response.data.paramListCnt;
                vm.fnSetPager(response.data.paramListCnt, 'fnGetProgramPostRequestList');
            }).catch(function(ex) {
                console.log(ex);
                return false;
            });
        },
		//날자값 변경
        fnChgDateString: function(_date){
            if(_date != null && _date != ''){
                let year = _date.getFullYear();
                let tmpMonth = _date.getMonth()+1;
                let tmpDate = parseInt(_date.getDate());
                let date = '';
                let month = '';
                if(tmpMonth < 10){
                    month = "0"+tmpMonth;
                } else {
                    month = tmpMonth;
                }
                if(tmpDate < 10){
                    date = "0"+tmpDate;
                } else {
                    date = tmpDate;
                }
                return year +"-"+month+"-"+date
            }
        },
		//프로그램 게시 여부 수정
		onClickProgramPostRequest: function(_uidKey, _aftschVwYn){
			let vm = this;
			let _viewYn = 'N';
			if (_aftschVwYn == 'Y'){
				_viewYn = 'N'
			} else if (_aftschVwYn == 'N'){
				_viewYn = 'Y'
			}
			let _param = { viewYn : _viewYn
						 , uidKey : _uidKey}
			let param = {param : _param};
            Axios.post("/api/mynavi/afterschool/program/post/request/update", param).then(function(response) {
				let result = response.data.result;
				if(result > 0){
					swal({
						title      : '변경 완료',
						text       : '변경 되었습니다.',
						icon       : vm.fnOnLoadSwalImageData('success'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							}
						},
						dangerMode : true
					}).then(result => {
						if(result){
							window.location.reload();
						}
					});
				} else {
					swal({
						title       : '변경 실패',
						text        : '변경되지 않았습니다.',
						icon        : this.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode  : true,
					}).then(result => {
						if(result){
							return false;
						}
					});
				}
            }).catch(function(ex) {
                console.log(ex);
            });
		},
		onClickPromgramDetail: function(){
			location.href='';
		},
		scrollToTop() {
            window.scrollTo(0,0);
        },
		//청소년 방과후 갤러리 상세
		onClickGalleryDetail: function(uidKey){
			location.href='/customer/afterschool/meetingPlace?tab=1&uidKey=' + uidKey;
		},

		fnChgMapColor: function(type){
			let vm = this;
			console.log('type',type)
			console.log('vm.searchModel.sggCd',vm.searchModel.sggCd)
			if (type == "searchType1") {
				$("svg path").not("#MAP" + vm.searchModel.sggCd).css("fill", "#eee4c2");
				$("#MAP" + vm.searchModel.sggCd).css("fill", "#f8cd3f");
			} else if (type == "searchType2") {
				$("svg path").not("#MAP" + vm.searchModel.sggCd).css("fill", "#ecd5cd");
				$("#MAP" + vm.searchModel.sggCd).css("fill", "#ee6538");
			} else if (type == "searchType3") {
				$("svg path").not("#MAP" + vm.searchModel.sggCd).css("fill", "#d1e3e7");
				$("#MAP" + vm.searchModel.sggCd).css("fill", "#5ac1da");
			}
		},
    fnCallImgAltSave:function () { // 이미지 alt 저장
      this.$refs.dropimg.fnParentSaveCB()
    },

	}
});

